// ─────────────────────────────────────────────────────────────
//  TÜRKÇE ÇEVİRİLER
//  Yeni anahtar eklerken mutlaka en.js'e de eş anahtar ekleyin.
// ─────────────────────────────────────────────────────────────

const tr = {

  /* ── Dil ── */
  "lang.tr": "Türkçe",
  "lang.en": "English",
  "lang.label": "Dil",

  /* ── Genel ── */
  "common.save": "Kaydet",
  "common.cancel": "Vazgeç",
  "common.confirm": "Onayla",
  "common.close": "Kapat",
  "common.loading": "Yükleniyor...",
  "common.error": "Hata",
  "common.success": "Başarılı",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.back": "Geri",
  "common.search": "Ara",
  "common.filter": "Filtrele",
  "common.all": "Tümü",
  "common.none": "Yok",
  "common.other": "Diğer",
  "common.ok": "Tamam",
  "common.send": "Gönder",
  "common.copy": "Kopyala",
  "common.copied": "Kopyalandı",
  "common.share": "Paylaş",
  "common.download": "İndir",
  "common.upload": "Yükle",
  "common.update": "Güncelle",
  "common.select": "Seç",
  "common.required": "Zorunlu alan",
  "common.optional": "İsteğe bağlı",
  "common.or": "veya",
  "common.and": "ve",

  /* ── Uygulama ── */
  "app.name": "Aile Yönetimi",
  "app.tagline": "Ailenizle birlikte, her şey daha kolay",
  "app.developer": "Sercan YAVUZ tarafından geliştirilmektedir.",
  "app.version": "Versiyon",
  "app.feedback": "✉️ Geri Bildirim Gönder",
  "app.description": "Ailenizle birlikte plan yapmak için tasarlandı.\nTüm veriler güvenli şekilde Database üzerinde saklanır.",

  /* ── Auth ── */
  "auth.welcome": "Hoş Geldiniz",
  "auth.privacyPolicy": "Gizlilik Politikası",
  "auth.termsOfService": "Kullanım Şartları",
  "auth.legalLinksLabel": "Yasal belgeler",
  "auth.legalConsentPrefix": "Kayıt olarak",
  "auth.legalConsentAnd": "ve",
  "auth.legalConsentSuffix": "metinlerini okuduğumu ve kabul ettiğimi onaylıyorum.",
  "auth.error.legalConsentRequired": "Hesap oluşturmak için Gizlilik Politikası ve Kullanım Şartları'nı kabul etmelisiniz.",
  "auth.loginSub": "Ailenizin dünyasına giriş yapın",
  "auth.resetSub": "Şifre sıfırlama bağlantısı gönderelim",
  "auth.login": "Giriş Yap",
  "auth.logout": "Çıkış Yap",
  "auth.register": "✨ Yeni Hesap Oluştur",
  "auth.createAccount": "Hesap Oluştur",
  "auth.createAccountSub": "Aile grubunuza katılmak için bilgilerinizi girin",
  "auth.forgotPassword": "Şifremi unuttum",
  "auth.resetPassword": "Şifreyi Sıfırla",  "auth.placeholder.newPassword": "Yeni şifre",  "auth.placeholder.newPasswordAgain": "Yeni şifre tekrar",  "auth.error.passwordMin": "Şifre 8-128 karakter olmalı.",  "auth.error.passwordMismatch": "Şifreler eşleşmiyor.",  "auth.info.passwordResetSuccess": "Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.",
  "auth.sendResetMail": "Sıfırlama Maili Gönder",
  "auth.backToLogin": "Giriş ekranına dön",
  "auth.diffAccount": "Farklı hesapla giriş yap",
  "auth.placeholder.loginInfo": "E-posta, kullanıcı adı veya telefon",
  "auth.placeholder.password": "Şifre",
  "auth.placeholder.passwordMin": "Şifre (8-128 karakter)",
  "auth.placeholder.name": "Ad",
  "auth.placeholder.surname": "Soyad",
  "auth.placeholder.phone": "Telefon: 05XXXXXXXXX",
  "auth.placeholder.username": "Kullanıcı adı",
  "auth.placeholder.email": "E-posta",
  "auth.placeholder.heightCm": "Boy (cm)",
  "auth.placeholder.weightKg": "Kilo (kg)",
  "auth.placeholder.bloodGroup": "Kan grubu seç",
  "auth.showPassword": "Şifreyi göster",
  "auth.hidePassword": "Şifreyi gizle",
  "auth.verifyEmail": "E-postanı doğrula",
  "auth.verifyEmailDesc": "Uygulamaya devam etmek için hesabına bağlı e-posta adresini doğrulaman gerekiyor.",
  "auth.verifyEmailInfo1": "Doğrulama bağlantısını bu adrese gönderdik.",
  "auth.verifyCheck": "Doğruladım, Kontrol Et",
  "auth.resendVerification": "Doğrulama mailini tekrar gönder",
  "auth.resendVerificationCountdown": "{{seconds}} sn sonra tekrar gönderebilirsin",
  "auth.verifyStepInbox": "Gelen kutunda Aile Yönetimi doğrulama e-postasını aç.",
  "auth.verifyStepSpam": "Göremiyorsan Spam, Gereksiz veya Promosyonlar klasörünü kontrol et.",
  "auth.verifyStepReturn": "E-postamı doğrula bağlantısına dokun; uygulama otomatik devam edecek.",
  "auth.wrongVerificationEmail": "E-posta adresim yanlış",
  "auth.newVerificationEmail": "Yeni e-posta adresi",
  "auth.currentPassword": "Mevcut şifren",
  "auth.updateEmailAndSend": "Adresi güncelle ve gönder",
  "auth.info.verificationAddressUpdated": "E-posta adresin güncellendi ve yeni doğrulama e-postası gönderildi.",
  "auth.error.verificationInitialSendFailed": "Hesabın oluşturuldu ancak doğrulama e-postası şu anda gönderilemedi. Aşağıdaki butonla tekrar deneyebilirsin.",
  "auth.error.verificationEmailUnchanged": "Yeni e-posta adresi mevcut adresinden farklı olmalı. Aynı adrese yeniden göndermek için doğrulama mailini tekrar gönder butonunu kullan.",
  "auth.error.verificationEmailChangeUnavailable": "E-posta adresi güncelleme hizmetine şu anda ulaşılamıyor. Lütfen daha sonra tekrar dene.",
  "auth.error.verificationEmailUpdateFailed": "E-posta adresi güncellenemedi.",
  "auth.footer": "Aile Yönetimi Uygulamanız · Sercan YAVUZ",

  /* ── Navigasyon / Sayfa Başlıkları ── */
  "nav.home": "Ana Sayfa",
  "nav.shopping": "Alışveriş",
  "nav.calendar": "Takvim",
  "nav.finance": "Finans",
  "nav.tasks": "Görevler",
  "nav.sharedExpenses": "Harcamalar",
  "nav.health": "Sağlık Verileri",
  "nav.map": "Aile Haritası",
  "nav.children": "Çocuk ve Bebek Takibi",
  "nav.chat": "Aile Sohbeti",
  "nav.documents": "Belgeler",
  "nav.cooking": "Bugün Ne Pişirsem?",
  "nav.management": "Yönetim",

  "management.adminOnlyToast": "Bu bölüme yalnızca aile yöneticileri erişebilir.",
  /* ── SideMenu ── */
  "menu.brand": "Aile Yönetimi",
  "menu.brandSub": "Family Planner",

  /* ── Ayarlar Panel ── */
  "settings.title": "⚙️ Ayarlar",
  "settings.tab.general": "Genel",
  "settings.tab.notifications": "Bildirim",
  "settings.tab.family": "Aile",
  "settings.tab.colors": "Renkler",
  "settings.tab.privacy": "Gizlilik",
  "settings.tab.about": "Hakkında",

  "settings.theme": "Tema",
  "settings.theme.dark": "🌙 Koyu",
  "settings.theme.light": "☀️ Açık",
  "settings.theme.hint": "Tema değişikliği anında uygulanır.",

  "settings.currency": "Para Birimi",

  "settings.defaultPage": "Varsayılan Açılış Sayfası",
  "settings.defaultPage.hint": "Uygulamayı açınca bu sayfa gelir.",

  "settings.language": "Dil / Language",
  "settings.language.hint": "Uygulama dilini değiştirin.",

  "settings.notifications.loading": "Bildirim ayarları yükleniyor...",
  "settings.notifications.loadingHint": "Son tercihleriniz alınıyor.",
  "settings.notifications.pushStatus": "📱 Cihaz Push Durumu",
  "settings.notifications.pushUnsupported": "⚠️ Bu cihaz / tarayıcı Web Push desteklemiyor. iPhone kullanıyorsanız uygulamayı Ana Ekran'a ekleyip oradan açın.",
  "settings.notifications.pushActive": "Push bildirimleri aktif",
  "settings.notifications.pushActiveHint": "Uygulama kapalıyken de bildirim alırsınız.",
  "settings.notifications.pushPassive": "Push bildirimleri aktif değil",
  "settings.notifications.pushPassiveHint": "Uygulama kapalıyken bildirim almıyorsunuz.",
  "settings.notifications.pushActivate": "🔔 Push Bildirimleri Aktifleştir",
  "settings.notifications.pushActivating": "Aktifleştiriliyor…",
  "settings.notifications.masterControl": "Ana Bildirim Kontrolü",
  "settings.notifications.allNotifications": "Tüm Bildirimler",
  "settings.notifications.allHint": "Tüm push bildirimlerini tek dokunuşla açıp kapatabilirsiniz.",
  "settings.notifications.categories": "Kategori Bildirimleri",
  "settings.notifications.cat.chat": "💬 Sohbet Bildirimleri",
  "settings.notifications.cat.tasks": "✅ Görev Bildirimleri",
  "settings.notifications.cat.calendar": "📅 Takvim Bildirimleri",
  "settings.notifications.cat.health": "❤️ Sağlık / İlaç Bildirimleri",
  "settings.notifications.cat.shopping": "🛒 Alışveriş Bildirimleri",
  "settings.notifications.cat.sharedExpenses": "💸 Ortak Harcama Bildirimleri",
  "settings.notifications.cat.finance": "💰 Finans Bildirimleri",
  "settings.notifications.cat.documents": "📁 Belge Bildirimleri",
  "settings.notifications.cat.documentExpiry": "⏳ Belge Son Tarihi Hatırlatmaları",
  "settings.notifications.cat.familyAnnouncements": "📢 Aile Duyuruları",
  "settings.notifications.cat.birthdays": "🎂 Doğum Günü Bildirimleri",
  "settings.notifications.cat.familyStatus": "📍 Aile Durumu Bildirimleri",
  "settings.notifications.quietHours": "Sessiz Saatler",
  "settings.notifications.quietHoursToggle": "Sessiz saatleri aktif et",
  "settings.notifications.quietHoursHint": "Bu saatler arasında otomatik hatırlatmalar gönderilmez.",
  "settings.notifications.quietStart": "Başlangıç",
  "settings.notifications.quietEnd": "Bitiş",
  "settings.notifications.autoReminders": "Otomatik Hatırlatmalar",
  "settings.notifications.autoRemindersHint": "Bu ayarlar backend otomatik hatırlatma motoru tarafından okunur.",
  "settings.notifications.shoppingReminder": "Bekleyen Alışveriş Hatırlatmaları",
  "settings.notifications.shoppingReminderHint": "Alışveriş listesinde alınmamış ürün varsa seçtiğiniz aralığa göre hatırlatılır.",
  "settings.notifications.freq.off": "Kapalı",
  "settings.notifications.freq.6hours": "Her 6 saatte bir",
  "settings.notifications.freq.daily": "Günde 1",
  "settings.notifications.freq.2days": "2 günde 1",
  "settings.notifications.freq.weekly": "Haftada 1",
  "settings.notifications.taskReminders": "Görev Hatırlatma Zamanları",
  "settings.notifications.task.today": "🔴 Son gün",
  "settings.notifications.task.tomorrow": "🟠 1 gün önce",
  "settings.notifications.task.threeDays": "🟡 3 gün önce",
  "settings.notifications.calendarReminders": "Takvim Hatırlatmaları",
  "settings.notifications.calendar.today": "📅 Etkinlik günü",
  "settings.notifications.calendar.tomorrow": "⏰ 1 gün önce",
  "settings.notifications.docReminders": "Belge Son Tarihi Hatırlatmaları",
  "settings.notifications.doc.oneDay": "⚠️ 1 gün önce / süresi bugün dolanlar",
  "settings.notifications.doc.sevenDays": "📁 7 gün önce",
  "settings.notifications.doc.thirtyDays": "📁 30 gün önce",
  "settings.notifications.healthReminders": "Sağlık Hatırlatmaları",
  "settings.notifications.financeReminders": "Finans Hatırlatmaları",
  "settings.notifications.finance.installments": "Taksit ödemeleri",
  "settings.notifications.finance.subscriptions": "Abonelik yenilemeleri",
  "settings.notifications.finance.bills": "Fatura ödemeleri",
  "settings.notifications.finance.savings": "Birikim kontrolleri",
  "settings.notifications.health.appointments": "🏥 Sağlık randevuları",
  "settings.notifications.health.medicines": "💊 İlaç hatırlatmaları",
  "settings.notifications.saved": "Bildirim ayarları kaydedildi ✓",

  "settings.family.rename": "Aile Adını Değiştir",
  "settings.family.renameSuccess": "Aile adı güncellendi ✓",
  "settings.family.namePlaceholder": "Aile adı",
  "settings.family.inviteCode": "Aile Davet Kodu",
  "settings.family.appGuideTitle": "Uygulama Rehberi",
  "settings.family.appGuideHint": "Ana sayfadaki temel özellikleri ve hızlı hareketleri yeniden keşfedin.",
  "settings.family.startAppGuide": "Uygulama Rehberini Başlat",
  "settings.family.inviteCodeHint": "Bu kodu paylaşarak aile grubuna yeni üye ekleyebilirsiniz.",
  "settings.family.shareInvite": "Aile daveti paylaş",
  "settings.family.shareText": "ailesine katılmak için davet kodu:",
  "settings.family.shareJoinHint": "Aile Yönetimi uygulamasında \"Aileye Kodla Katıl\" bölümünden bu kodu girerek aileye katılabilirsiniz.",
  "settings.family.shareClipboard": "Aile davet bilgisi kopyalandı.",
  "settings.family.copyFailed": "Aile kodu: ",

  "settings.colors.title": "Takvim Renkleri",
  "settings.colors.hint": "Her aile üyesine bir renk atayın. Bu renk takvimdeki etkinliklerde görünür.",

  "settings.privacy.export": "Veriyi Dışa Aktar",
  "settings.privacy.exportHint": "Profil bilgilerini JSON dosyası olarak indir.",
  "settings.privacy.exportBtn": "📥 Veriyi İndir",
  "settings.privacy.deleteLocationHistory": "Konum Geçmişimi Sil",
  "settings.privacy.deleteLocationHistoryHint": "Harita sayfasındaki tüm konum geçmişi kayıtlarınız sunucudan kalıcı olarak silinir. Bu işlem geri alınamaz.",
  "settings.privacy.deleteLocationHistorySuccess": "Konum geçmişiniz başarıyla silindi.",
  "settings.privacy.deleteLocationHistoryBtn": "Konum Geçmişimi Sil",
  "settings.privacy.deleteAccount": "Hesabı Sil",
  "settings.privacy.deleteHint": "Bu işlem geri alınamaz. Kişisel profiliniz, oturumlarınız, bildirim cihazlarınız, konum geçmişiniz ve size ait dosyalar temizlenir. Ortak aile kayıtları korunur.",
  "settings.privacy.deleteBtn": "🗑 Hesabı Sil",
  "settings.privacy.confirmDelete": "Onayla, Sil",
  "settings.privacy.confirmPasswordPlaceholder": "Şifrenizi onaylayın",
  "settings.privacy.deleteSuccess": "Hesabınız silindi. Oturumunuz kapatılıyor.",
  "settings.privacy.deleteFailed": "Hesap silinemedi. Lütfen tekrar deneyin.",
  "settings.privacy.adminTransferRequired": "Bu ailede tek yöneticisiniz. Hesabınızı silmeden önce yöneticiliği başka bir üyeye devredin.",
  "settings.privacy.invalidPassword": "Şifre hatalı.",
  "settings.privacy.passwordRequired": "Devam etmek için şifrenizi girin.",
  "settings.privacy.finalDeleteWarning": "Hesabınız silinecek. Profiliniz anonimleştirilir, oturumlarınız kapatılır, konum geçmişiniz ve size ait dosyalar temizlenir. Ortak aile kayıtları korunur. Bu işlem geri alınamaz.",

  "settings.about.version": "Versiyon 1.7.1 (22)",
  "settings.about.description": "Ailenizle birlikte plan yapmak için tasarlandı.\nTüm veriler güvenli şekilde saklanır.",
  "settings.about.feedback": "✉️ Geri Bildirim Gönder",
  "settings.about.feedbackShort": "Geri Bildirim",
  "settings.about.rateApp": "Bizi Değerlendirin",
  "settings.about.rateError": "Mağaza değerlendirme sayfası açılamadı. Lütfen daha sonra tekrar deneyin.",
  "settings.about.followUs": "BİZE ULAŞIN",
  "settings.about.website": "Web Sitesi",
  "settings.about.instagramAria": "Aile Yönetimi Instagram hesabını aç",
  "settings.about.websiteAria": "Aile Yönetimi web sitesini aç",
  "settings.about.linkError": "Bağlantı açılamadı. Lütfen daha sonra tekrar deneyin.",
  "settings.about.developer": "YAVUZ SOFT ©",

  /* ── Geri Bildirim ── */
  "feedback.navTitle": "Geri Bildirim",
  "feedback.eyebrow": "BİRLİKTE GELİŞTİRELİM",
  "feedback.title": "Görüşünüz bizim için değerli",
  "feedback.subtitle": "Önerinizi veya karşılaştığınız sorunu doğrudan ekibimize iletin.",
  "feedback.trust.private": "Güvenli ve gizli",
  "feedback.trust.direct": "Doğrudan ekibimize ulaşır",
  "feedback.category.label": "Kategori",
  "feedback.category.hint": "Size en uygun başlığı seçin.",
  "feedback.category.feature": "Özellik Önerisi",
  "feedback.category.feature.description": "Yeni fikir ve iyileştirmeler",
  "feedback.category.bug": "Hata Bildir",
  "feedback.category.bug.description": "Karşılaştığınız teknik sorunlar",
  "feedback.category.general": "Genel Geri Bildirim",
  "feedback.category.general.description": "Deneyiminiz ve düşünceleriniz",
  "feedback.message.label": "Mesajınız",
  "feedback.message.sectionHint": "Ne kadar ayrıntı paylaşırsanız sizi o kadar iyi anlayabiliriz.",
  "feedback.message.placeholder": "Deneyiminizi, önerinizi veya karşılaştığınız sorunu ayrıntılı şekilde yazın...",
  "feedback.message.hint": "En az 20, en fazla 1000 karakter.",
  "feedback.message.ready": "Göndermeye hazır",
  "feedback.message.remaining": "{{count}} karakter daha yazın",
  "feedback.screenshot.label": "Ekran görüntüsü",
  "feedback.screenshot.sectionHint": "Sorunu anlamamıza yardımcı olacak görseller ekleyin.",
  "feedback.screenshot.hint": "İsteğe bağlı · En fazla 2 adet · JPG, PNG veya HEIC · Dosya başına 7 MB",
  "feedback.screenshot.count": "{{count}} / 2",
  "feedback.screenshot.add": "Ekle",
  "feedback.screenshot.preview": "Ekran görüntüsü {{index}}",
  "feedback.screenshot.remove": "Ekran görüntüsünü kaldır",
  "feedback.send": "Gönder",
  "feedback.sending": "Gönderiliyor...",
  "feedback.privacy.title": "Güvenli gönderim",
  "feedback.privacy.message": "Veriler yalnızca Gönder'e dokunduğunuzda iletilir.",
  "feedback.success.title": "Geri bildiriminiz alındı",
  "feedback.success.message": "Uygulamayı geliştirmemize yardımcı olduğunuz için teşekkür ederiz.",
  "feedback.error.minLength": "Mesajınız en az 20 karakter olmalıdır.",
  "feedback.error.maxLength": "Mesajınız en fazla 1000 karakter olabilir.",
  "feedback.error.maxFiles": "En fazla 2 ekran görüntüsü ekleyebilirsiniz.",
  "feedback.error.fileType": "Yalnızca JPG, PNG veya HEIC dosyaları eklenebilir.",
  "feedback.error.fileSize": "Her ekran görüntüsü en fazla 7 MB olabilir.",
  "feedback.error.send": "Geri bildirim gönderilemedi. Lütfen tekrar deneyin.",
  "feedback.error.rateLimited": "Kısa süre içinde çok fazla geri bildirim gönderdiniz. Lütfen daha sonra tekrar deneyin.",
  "feedback.error.invalidFile": "Ekran görüntüsü doğrulanamadı. Lütfen JPG, PNG veya HEIC dosyası seçin.",
  "admin.feedback.title": "Kullanıcı Geri Bildirimleri",
  "admin.feedback.subtitle": "Önerileri, hata bildirimlerini ve kullanıcı deneyimini tek yerden yönetin.",
  "admin.feedback.cardSubtitle": "Öneri, hata ve genel görüşleri yönet",
  "admin.feedback.search": "Kullanıcı, e-posta veya mesaj ara",
  "admin.feedback.allStatuses": "Tüm durumlar",
  "admin.feedback.allCategories": "Tüm kategoriler",
  "admin.feedback.apply": "Uygula",
  "admin.feedback.export": "CSV Dışa Aktar",
  "admin.feedback.empty": "Filtrelere uygun geri bildirim bulunamadı.",
  "admin.feedback.attachment": "Ekran görüntüsü",
  "admin.feedback.close": "Kapat",
  "admin.feedback.previous": "Önceki",
  "admin.feedback.next": "Sonraki",
  "admin.feedback.records": "kayıt",
  "admin.feedback.startDate": "Başlangıç tarihi",
  "admin.feedback.endDate": "Bitiş tarihi",
  "admin.feedback.status": "Durum",
  "admin.feedback.loading": "Yükleniyor...",
  "admin.feedback.loadError": "Geri bildirimler alınamadı.",
  "admin.feedback.statusError": "Durum güncellenemedi.",
  "admin.feedback.attachmentError": "Ekran görüntüsü açılamadı.",
  "admin.feedback.csvError": "CSV oluşturulamadı.",
  "admin.feedback.pendingNotification": "Bildirim altyapısında bekliyor",
  "admin.feedback.open": "Açık",
  "admin.feedback.control": "Kontrol Et",
  "admin.feedback.status.new": "Yeni",
  "admin.feedback.status.reviewing": "İnceleniyor",
  "admin.feedback.status.completed": "Tamamlandı",
  "admin.feedback.status.archived": "Arşiv",

  /* ── Ana Sayfa ── */
  "home.welcome": "Hoş Geldin",
  "home.upcomingEvents": "Yaklaşan Etkinlikler",
  "home.noUpcoming": "Yaklaşan etkinlik yok",
  "home.shopping.title": "Alışveriş",
  "home.shopping.pending": "bekliyor",
  "home.shopping.done": "tamamlandı",
  "home.finance.balance": "Net Bakiye",
  "home.tasks.title": "Görevler",
  "home.tasks.active": "aktif",
  "home.sharedExpenses.title": "Ortak Harcamalar",
  "home.health.title": "Sağlık",
  "home.health.records": "kayıt",
  "home.documents.title": "Belgeler",
  "home.children.title": "Çocuk Takibi",
  "home.children.tracking": "takip",
  "home.map.title": "Harita",
  "home.map.sharing": "paylaşıyor",

  /* ── Üye Modal ── */
  "member.age": "Yaş",
  "member.role": "Rol",
  "member.familyAuthority": "Aile Yetkisi",
  "member.username": "Kullanıcı adı",
  "member.email": "E-posta",
  "member.phone": "Telefon",
  "member.birthDate": "Doğum tarihi",
  "member.gender": "Cinsiyet",
  "member.changeRole": "Rolü değiştir",
  "member.removeFromFamily": "Aileden çıkar",
  "member.modal.title": "Üye Bilgisi",

  /* ── Bildirim ── */
  "notification.count": "bildirim",

  /* ── Family Switcher ── */
  "familySwitcher.confirmTitle": "Aile değiştirilsin mi?",
  "familySwitcher.confirmSub": "Tüm veriler bu aileye geçecek.",
  "familySwitcher.switch": "Geç",
  "familySwitcher.createFamily": "Yeni Aile Oluştur",
  "familySwitcher.familyNameRequired": "Aile adı boş olamaz.",
  "familySwitcher.familyName": "Aile Adı",
  "familySwitcher.familyNamePlaceholder": "Örn: Yavuz Ailesi",
  "familySwitcher.icon": "İkon",
  "familySwitcher.color": "Renk",
  "familySwitcher.creating": "Oluşturuluyor…",
  "familySwitcher.joinFamily": "Aileye Katıl",
  "familySwitcher.joinByCode": "Davet Koduyla Katıl",
  "familySwitcher.codeRequired": "Davet kodunu girin.",
  "familySwitcher.joinHint": "Aile yöneticinizin oluşturduğu tek kullanımlık davet kodunu girin.",
  "familySwitcher.inviteCode": "Davet Kodu",
  "familySwitcher.checking": "Kontrol ediliyor…",
  "familySwitcher.myFamilies": "Ailelerim",
  "familySwitcher.empty": "Henüz bir aileye üye değilsiniz.",
  "familySwitcher.active": "Aktif",
  "familySwitcher.createSub": "Aile adı, ikon ve renk seç",
  "familySwitcher.enterInviteCode": "Tek kullanımlık davet kodunu gir",
  "familySwitcher.shareText": "🏠 {{name}} ailesine katılmak için davet kodu: {{code}}\n\nAile Yönetimi uygulamasında “Aileye Kodla Katıl” bölümünden bu kodu girerek aileye katılabilirsiniz.",
  "familySwitcher.shareTitle": "{{name}} Aile Daveti",
  "familySwitcher.inviteCopied": "Aile davet bilgisi kopyalandı.",
  "familySwitcher.shareCode": "Aile Kodunu Paylaş",
  "familySwitcher.shareChannels": "WhatsApp, SMS veya Messenger ile paylaş",
  "familySwitcher.adminOnlyShare": "Aile kodunu sadece yöneticiler paylaşabilir",
  "familySwitcher.limitWarning": "Ücretsiz aile limiti doldu. Yeni aile oluşturmak veya kodla katılmak için premium gerekir.",
  "familySwitcher.limitMessage": "Ücretsiz planda en fazla {{limit}} aile oluşturabilir veya aileye katılabilirsin.",
  "familySwitcher.premium.multiFamily": "Birden fazla aile grubu (Plus'a geç)",
  "familySwitcher.premium.unlimitedJoin": "10'a kadar aile oluştur veya katıl",
  "familySwitcher.premium.quickSwitch": "Aileler arasında hızlı geçiş",
  "familySwitcher.plus.multiFamily": "10'a kadar aile oluştur veya katıl",
  "familySwitcher.plus.unlimitedMembers": "Ailedeki 3 üye sınırı tamamen kalkar",
  "familySwitcher.plus.unlimitedRecords": "Tüm sayfalarda sınırsız kayıt ekleme",

  /* ── Sabitler / Listeler ── */
  "const.roles": ["Kişisel", "Baba", "Anne", "Çocuk", "Amca", "Hala", "Teyze", "Dayı", "Dede", "Nene", "Diğer"],
  "const.genders": ["Kadın", "Erkek", "Belirtmek istemiyorum"],
  "const.units": ["adet", "kg", "lt", "paket"],
  "const.shoppingCategories": [
    "Tümü", "Market", "Manav", "Kasap", "Şarküteri", "Fırın",
    "Temizlik", "Mutfak", "İçecek", "Kahvaltılık", "Atıştırmalık",
    "Kişisel Bakım", "Bebek", "Evcil Hayvan", "Elektronik",
    "Eczane", "Giyim", "Ev İhtiyaçları", "Diğer",
  ],
  "const.incomeCategories": [
    "Maaş", "Ek Gelir", "Serbest İş", "Satış", "Prim",
    "Kira Geliri", "Yatırım Getirisi", "Devlet Ödemesi",
    "Harçlık", "İade", "Birikimden Aktarma", "Diğer Gelir",
  ],
  "const.expenseCategories": [
    "Kredi Kartı", "Market", "Fatura", "Kira", "Su", "Elektrik", "Doğalgaz",
    "İnternet", "Telefon", "Araç Gideri", "Yakıt", "Araç Bakım",
    "Otopark", "Sigorta", "Vergi", "Ulaşım", "Toplu Taşıma",
    "Çocuk", "Eğitim", "Okul", "Oyuncak", "Bebek İhtiyaçları",
    "Sağlık", "İlaç", "Hastane", "Muayene", "Giyim",
    "Ev İhtiyaçları", "Mobilya", "Temizlik", "Kozmetik",
    "Kafe & Restoran", "Yemek", "Eğlence", "Tatil", "Hediye",
    "Abonelik", "Dijital Servisler", "Oyun", "Yazılım",
    "Kredi", "Borç Ödemesi", "Yatırım", "Birikim",
    "Aidat", "Diğer Gider",
  ],
  "const.calendarCategories": [
    "Aile Etkinliği", "Randevu", "Sağlık", "İş / Toplantı",
    "Okul / Çocuk", "Eğitim / Kurs", "Fatura / Ödeme", "Alışveriş",
    "Ev İşleri", "Sosyal Buluşma", "Spor / Aktivite", "Seyahat",
    "Tatil", "Resmi İş", "Araç", "Doğum Günü", "Kutlama",
    "Önemli", "Diğer",
  ],
  "const.familyAuthorities": ["Aile Yöneticisi", "Aile Üyesi"],
  "const.roleSortOrder": ["Kişisel", "Baba", "Anne", "Çocuk", "Amca", "Hala", "Teyze", "Dayı", "Dede", "Nene", "Diğer"],

  /* ── Ortak ── */
  "common.total": "Toplam",
  "common.pending": "Bekleyen",
  "common.taken": "Alınan",
  "common.noData": "Veri yok",
  "common.delete": "Sil",
  "common.expand": "Genişlet",
  "common.collapse": "Daralt",
  "common.add": "Ekle",
  "common.amount": "Tutar",
  "common.date": "Tarih",
  "common.category": "Kategori",
  "common.person": "Kişi",
  "common.note": "Not",
  "common.title": "Başlık",
  "common.description": "Açıklama",
  "common.assignee": "Atanan Kişi",
  "common.dueDate": "Son Tarih",
  "common.priority": "Öncelik",
  "common.unit": "Birim",
  "common.quantity": "Miktar",
  "common.noItems": "Henüz kayıt yok",
  "common.thisMonth": "Bu ay",
  "common.records": "kayıt",
  "common.late": "⚠ Gecikti",
  "common.months": ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],

  /* ── Alışveriş ── */
  "shopping.addItem": "Ürün Ekle",
  "shopping.itemName": "Ürün adı",
  "shopping.newCategory": "Yeni kategori adı",
  "shopping.reminder": "Bu ürün için hatırlatma kur",
  "shopping.reminderTitle": "🛒 Alışveriş Hatırlatması",
  "shopping.reminderBody": "ürününü almayı unutma!",
  "shopping.reminderBodyDefault": "Alışveriş listeni kontrol et.",
  "shopping.noItems": "Henüz ürün yok",
  "shopping.noCategory": "Kategori yok",
  "shopping.noAdder": "Ekleyen yok",
  "shopping.listTitle": "Alışveriş listesi",
  "shopping.categories": "Alışveriş kategorileri",
  "shopping.quickPlaceholder": "Listeye ne ekleyelim?",
  "shopping.details": "Ürün ayrıntılarını ekle",
  "shopping.hideDetails": "Ayrıntıları gizle",
  "shopping.detailsHint": "Miktar, birim, kategori ve hatırlatma",
  "shopping.categoriesPrevious": "Önceki kategoriler",
  "shopping.categoriesNext": "Sonraki kategoriler",
  "shopping.addToList": "Listeye Ekle",
  "shopping.adding": "Ekleniyor…",
  "shopping.progress.start": "İlk ürününüzü ekleyerek başlayın",
  "shopping.progress.pendingOne": "1 ürün alınmayı bekliyor",
  "shopping.progress.pending": "{{count}} ürün alınmayı bekliyor",
  "shopping.progress.doneOne": "1 ürünün tamamı alındı",
  "shopping.progress.done": "{{count}} ürünün tamamı alındı",
  "shopping.pendingSection": "Bekleyenler",
  "shopping.completedSection": "Alınanlar",
  "shopping.show": "Göster",
  "shopping.hide": "Gizle",
  "shopping.completeTitle": "Liste tamamlandı 🎉",
  "shopping.completeText": "Bu listedeki bütün ürünler alındı. Dilerseniz alınanları aşağıdan inceleyebilirsiniz.",
  "shopping.categoryCompleteTitle": "Bu kategori tamamlandı",
  "shopping.categoryCompleteText": "Bu kategoride bekleyen ürün kalmadı.",
  "shopping.emptyTitle": "Listeniz sizi bekliyor",
  "shopping.emptyText": "İhtiyacınız olanları ekleyin, hiçbir şeyi unutmadan alışverişi birlikte tamamlayın.",
  "shopping.emptyCategoryTitle": "Bu kategoride ürün yok",
  "shopping.emptyCategoryText": "Başka bir kategori seçebilir veya listeye yeni bir ürün ekleyebilirsiniz.",
  "shopping.startAdding": "İlk ürünü ekle",
  "shopping.markTaken": "Alındı olarak işaretle",
  "shopping.markPending": "Bekliyor olarak işaretle",
  "shopping.moreActions": "Ürün işlemleri",
  "shopping.deleteItem": "Ürünü sil",
  "shopping.deleteConfirm": "Bu ürün listeden silinsin mi?",
  "shopping.cancel": "Vazgeç",
  "shopping.deleting": "Siliniyor…",
  "shopping.scan.open": "Fotoğraftan ürün ekleme seçenekleri",
  "shopping.scan.camera": "Kamera",
  "shopping.scan.cameraHint": "Listeyi fotoğrafla tara",
  "shopping.scan.gallery": "Galeri",
  "shopping.scan.galleryHint": "Mevcut bir görseli seç",
  "shopping.scan.scanning": "Liste taranıyor…",
  "shopping.scan.reading": "Okunuyor %{{percent}}…",
  "shopping.scan.noItems": "Ürün tespit edilemedi. Daha net bir fotoğraf çekmeyi deneyin.",
  "shopping.scan.nativeOnly": "Fotoğraftan okuma yüklü mobil uygulamada çalışır. Lütfen cihazda deneyin.",
  "shopping.scan.failed": "Tarama başarısız. Lütfen tekrar deneyin.",
  "shopping.scan.success": "Ürünler başarıyla listeye eklendi",

  /* ── Görevler ── */
  "tasks.create": "Görev Oluştur",
  "tasks.name": "Görev adı",
  "tasks.description": "Açıklama (isteğe bağlı)",
  "tasks.selectPerson": "Kişi seç",
  "tasks.priority.low": "Düşük",
  "tasks.priority.normal": "Normal",
  "tasks.priority.high": "Yüksek",
  "tasks.filter.all": "Tümü",
  "tasks.filter.mine": "Bana Atanan",
  "tasks.filter.late": "Geciken",
  "tasks.filter.done": "Tamamlanan",
  "tasks.empty": "Görev bulunamadı",
  "tasks.reminder": "Bu görev için hatırlatma kur",
  "tasks.reminderTitle": "✅ Görev Hatırlatması",
  "tasks.reminderBody": "görevini unutma!",
  "tasks.reminderBodyDefault": "Görevini kontrol et.",
  "tasks.healthHint": "💡 Bu görev seçilen kişinin sağlık randevularına otomatik eklenecek",
  "tasks.createSubtitle": "Aileniz için görev ve sorumluluk ekleyin",
  "tasks.openForm": "Aç",
  "tasks.closeForm": "Kapat",
  "tasks.openFormAction": "Formu aç",
  "tasks.closeFormAction": "Formu kapat",
  "tasks.creating": "Oluşturuluyor…",
  "tasks.overview": "Görev listesi",
  "tasks.totalCount": "{{count}} görev",
  "tasks.overviewDetail": "{{active}} bekliyor · {{late}} gecikmiş · {{done}} tamamlandı",
  "tasks.emptyTitle": "Henüz görev yok",
  "tasks.emptyText": "İlk görevinizi oluşturun, günlük planları ailenizle birlikte kolayca tamamlayın.",
  "tasks.emptyLateTitle": "Gecikmiş görev yok 🎉",
  "tasks.emptyLateText": "Tüm görevleriniz zamanında ilerliyor.",
  "tasks.emptyMineTitle": "Size atanmış görev yok",
  "tasks.emptyMineText": "Yeni bir görev atandığında burada görünecek.",
  "tasks.emptyDoneTitle": "Henüz tamamlanan görev yok",
  "tasks.emptyDoneText": "Tamamladığınız görevler burada birikecek.",
  "tasks.createFirst": "İlk Görevi Oluştur",
  "tasks.complete": "Tamamla",
  "tasks.reopen": "Yeniden aç",
  "tasks.actions": "Görev işlemleri",
  "tasks.daysLate": "{{count}} gün gecikti",
  "tasks.deleteTitle": "Görevi sil",
  "tasks.deleteConfirm": "Bu görev kalıcı olarak silinecek. Devam etmek istediğinize emin misiniz?",
  "tasks.deleteYes": "Evet, sil",
  "tasks.progress.start": "İlk görevinizi oluşturun",
  "tasks.progress.doneOne": "Görev tamamlandı",
  "tasks.progress.done": "Tüm görevler tamamlandı",
  "tasks.progress.pendingOne": "1 görev tamamlanmayı bekliyor",
  "tasks.progress.pending": "{{count}} görev tamamlanmayı bekliyor",
  "tasks.stats.total": "Toplam",
  "tasks.stats.pending": "Bekleyen",
  "tasks.stats.completed": "Tamamlanan",
  "tasks.completeBannerTitle": "Görevler tamamlandı 🎉",
  "tasks.completeBannerText": "Harika iş! Bu listedeki bütün görevler tamamlandı.",

  /* ── Görev kategorileri (ek) ── */
  "const.taskExtraCategories": ["İlaç / Tedavi", "Egzersiz", "Beslenme", "Psikoloji", "Diş", "Göz"],

  /* ── Ortak Harcamalar ── */
  "expense.dashboard": "Aile Harcamaları Dashboard",
  "expense.monthlyTotal": "Bu ay ortak harcama toplamı",
  "expense.perPerson": "Kişi Başı",
  "expense.perPersonSub": "Ortalama paylaşım",
  "expense.topSpender": "En Çok Ödeyen",
  "expense.categoryCount": "Kategori",
  "expense.categoryCountSub": "Farklı harcama alanı",
  "expense.byCategoryTitle": "Kategori Bazlı Harcamalar",
  "expense.noCategory": "Bu ay kategori verisi yok",
  "expense.byPersonTitle": "Kişi Bazlı Harcama",
  "expense.byPersonEmpty": "Kişi bazlı harcama verisi yok",
  "expense.monthlyPaid": "Bu ay ödediği toplam",
  "expense.debtTitle": "Borç / Alacak Özeti",
  "expense.creditor": "Alacaklı",
  "expense.debtor": "Borçlu",
  "expense.showDebt": "Borç hesabını göster",
  "expense.add": "Ortak Harcama Ekle",
  "expense.titlePlaceholder": "Başlık / açıklama",
  "expense.amountPlaceholder": "Tutar (₺)",
  "expense.listTitle": "Harcama Listesi",
  "expense.empty": "Bu ay harcama kaydı yok",
  "expense.noTopCategory": "Kategori yok",
  "expense.noTopSpender": "Yok",
  "expense.noTopSpenderData": "Henüz veri yok",
  "expense.monthRecords": "kayıt",
  "expense.reminder": "Bu harcama için hatırlatma kur",
  "expense.reminderTitle": "💸 Harcama Hatırlatması",
  "expense.showMoreExpenses": "harcamayı göster",
  "expense.showLessRecords": "Daha az göster",
  "expense.heaviest": "Yoğun:",

  /* ── Takvim ── */
  "calendar.addEvent": "Etkinlik Ekle",
  "calendar.eventTitle": "Etkinlik başlığı",
  "calendar.eventDesc": "Açıklama (isteğe bağlı)",
  "calendar.color": "Renk",
  "calendar.assignee": "Kişi",
  "calendar.selectPerson": "Kişi seç (isteğe bağlı)",
  "calendar.reminder": "Bu etkinlik için hatırlatma kur",
  "calendar.empty": "Etkinlik bulunamadı",
  "calendar.upcoming": "Yaklaşan",
  "calendar.today": "Bugün",
  "calendar.filter.all": "Tümü",
  "calendar.filter.mine": "Benim",
  "calendar.filter.upcoming": "Yaklaşan",
  "calendar.filter.past": "Geçmiş",
  "calendar.noUpcoming": "Yaklaşan etkinlik yok",
  "calendar.noPast": "Geçmiş etkinlik yok",

  /* ── Profil / Üye Modal ── */
  "profile.title": "Profil",
  "profile.name": "Ad",
  "profile.surname": "Soyad",
  "profile.phone": "Telefon",
  "profile.birthDate": "Doğum Tarihi",
  "profile.gender": "Cinsiyet",
  "profile.role": "Rol",
  "profile.bloodType": "Kan Grubu",
  "profile.height": "Boy",
  "profile.weight": "Kilo",
  "profile.edit": "Profili Düzenle",
  "profile.save": "Kaydet",
  "profile.changePassword": "Şifre Değiştir",
  "profile.currentPassword": "Mevcut şifre",
  "profile.newPassword": "Yeni şifre",
  "profile.logout": "Çıkış Yap",

  /* ── Premium Popup ── */
  "premium.locked": "Bu özellik kilitli",
  "premium.upgrade": "Premium'a Geç",
  "premium.free": "Ücretsiz Plan",
  "premium.monthly": "/ ay",
  "premium.features": "Premium özellikler",
  "premium.close": "Kapat",
  "premium.restore": "Satın alımları geri yükle",
  "premium.terms": "Kullanım Koşulları",
  "premium.privacy": "Gizlilik Politikası",
  "premium.cta": "Premium'a Geç →",
  "premium.badge": "✦ PRO",

  /* ── Bildirim Popup ── */

  /* ── Premium özellik listesi ── */
  "premium.hero.title1": "Aileniz için",
  "premium.hero.title2": "Daha Fazlası",
  "premium.hero.title3": "Sizi Bekliyor",
  "premium.hero.subtitle": "Premium özelliklerle ailenizi daha iyi yönetin,\nanılarınızı güvenle saklayın.",
  "premium.plan.premium": "PREMIUM",
  "premium.plan.plus": "PREMIUM PLUS",
  "premium.plan.price.premium": "₺89",
  "premium.plan.price.plus": "₺149",
  "premium.plan.cta.premium": "Premium'a Geç",
    "premium.plan.cta.plus": "Premium Plus'a Geç",
  "premium.comingSoon": "Çok Yakında",
  "premium.comingSoonSub": "Satın alma özelliği yakında aktif olacak. Şimdilik premium özellikler yöneticiniz tarafından açılabilir.",
  "premium.comingSoonNotice": "Bu özellik şu anda satın alma için açık değil.",
  "premium.plan.sub.plus": "Daha büyük aileler için sınırsız üye desteği ve tüm premium özellikler.",
  "premium.plan.sub.default": "Tüm gelişmiş özelliklere erişin ve ailenizi en iyi şekilde yönetin.",
  "premium.perMonth": "/ ay",
  "premium.safe": "Güvenli ödeme",
  "premium.cancel": "İstediğin zaman iptal et",
  "premium.later": "Belki daha sonra",
  "premium.restoreBtn": "Satın almayı geri yükle",
  "premium.restoring": "Kontrol ediliyor…",
  "premium.notFound": "Aktif abonelik bulunamadı.",
  "premium.restoreFailed": "Geri yükleme başarısız.",
  "premium.closeLabel": "Kapat",
  "premium.familyAlt": "Aile",
  "premium.crownAlt": "Premium taç",
  "premium.features.premium": [
    {"title":"Sınırsız Kayıt","desc":"Alışveriş, görev, takvim, finans kayıtlarında limit yok"},
    {"title":"Finans Araçları","desc":"Rapor, birikim, taksit, abonelik ve fatura takibi"},
    {"title":"Canlı Konum & Harita","desc":"Canlı konum paylaşımı, geofence ve konum geçmişi"},
    {"title":"Gelişmiş Bildirimler","desc":"Zamanlı ve otomatik aile bildirimleri"},
    {"title":"Haftalık Menü & Çoklu Sohbet","desc":"Menü planlama ve birden fazla sohbet odası"}
  ],
  "premium.features.plus": [
    {"title":"Tüm Premium Özellikler","desc":"Premium'daki her şey Plus'a dahil"},
    {"title":"Birden Fazla Aile Grubu","desc":"10'a kadar aile oluştur veya aileye katıl"},
    {"title":"Sınırsız Aile Üyesi","desc":"Ailedeki 3 üye sınırı tamamen kalkar"},
    {"title":"Sınırsız Kayıt Ekleme","desc":"Tüm sayfalarda sınırsız veri girişi"},
    {"title":"Çoklu Aile Yönetimi","desc":"Aileler arasında hızlı geçiş ve ayrı planlama"}
  ],

  /* ── Takvim özel ── */
  "calendar.days": ["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"],
  "calendar.daysShort": ["P","S","Ç","P","C","C","P"],
  "calendar.yearlyView": "Yıllık Görünüm",
  "calendar.backToMonthly": "Aylık görünüme dön",
  "calendar.goToYearly": "Yıllık görünüme geç",
  "calendar.upcomingTitle": "Yaklaşan Etkinlikler",
  "calendar.noRecord": "Kayıt yok",
  "calendar.addBtn": "+ Ekle",
  "calendar.time": "Saat",
  "calendar.save": "Kaydet",
  "calendar.editTitle": "Etkinliği Düzenle",
  "calendar.editUpdate": "Güncelle",
  "calendar.editBtn": "Düzenle",
  "calendar.deleteBtn": "Sil",
  "calendar.closeBtn": "Kapat",
  "calendar.dayEmpty": "Bu gün için kayıt yok.",
  "calendar.titleRequired": "Başlık boş olamaz.",
  "calendar.personNotFound": "Kişi bulunamadı.",
  "calendar.noPermDelete": "Bu etkinliği silme yetkin yok.",
  "calendar.deleteConfirm": "silinsin mi?",
  "calendar.monthlyLimitDesc": "Sınırsız aylık etkinlik",
  "calendar.select": "Seç",
  "calendar.labelToday": "Bugün",
  "calendar.labelTomorrow": "Yarın",
  "calendar.labelThisWeek": "Bu Hafta",
  "calendar.reminderTitle": "📅 Takvim Hatırlatması",
  "calendar.reminderBody": "etkinliğini unutma!",
  "calendar.bulkImport.title": "📅 Aile takvimi güncellendi",
  "calendar.bulkImport.body": "{{name}} seçili cihaz takvimlerinden {{count}} etkinliği aile takvimine ekledi.",


  "auto.finance.title": "Finans Hatırlatmaları",
  "auto.finance.desc": "Taksit, abonelik ve fatura son ödeme tarihlerini otomatik hatırlatır.",
  "policy.finance.title": "Finans Bildirimleri",
  "policy.finance.desc": "Finans kartları için son ödeme tarihi hatırlatmaları.",
  "policy.finance.3days": "3 gün önce",
  "policy.finance.today": "Son ödeme gününde",
  "policy.finance.installmentBefore": "Taksit - ödeme öncesi",
  "policy.finance.installmentToday": "Taksit - ödeme günü",
  "policy.finance.subscriptionBefore": "Abonelik - yenileme öncesi",
  "policy.finance.subscriptionToday": "Abonelik - yenileme günü",
  "policy.finance.billBefore": "Fatura - ödeme öncesi",
  "policy.finance.billToday": "Fatura - ödeme günü",
  "policy.finance.savingValue": "Birikim - değer kontrolü",
  "policy.finance.savingContribution": "Birikim - katkı hatırlatması",
  "mgmt.auto.finance.installments": "Taksitler",
  "mgmt.auto.finance.subscriptions": "Abonelikler",
  "mgmt.auto.finance.bills": "Faturalar",

  /* ── Finans ── */
  "finance.tab.general": "Genel",
  "finance.tab.reports": "Rapor",
  "finance.tab.savings": "Birikim",
  "finance.tab.installments": "Taksitler",
  "finance.tab.subscriptions": "Abonelikler",
  "finance.tab.bills": "Faturalar",
  "finance.premiumDesc": "Finansal verilerini derinlemesine analiz et ve takip et",
  "finance.premiumBenefit1": "Aylık harcama grafikleri",
  "finance.premiumBenefit2": "Birikim ve yatırım takibi",
  "finance.premiumBenefit3": "Taksit ve abonelik yönetimi",
  "finance.premiumBenefit4": "Sınırsız finans kaydı",
  "finance.income": "Gelir",
  "finance.sharedExpense": "Ortak Harcama",
  "finance.topCategory": "En Yoğun Kategori",
  "finance.expense": "Gider",
  "finance.balance": "Net Bakiye",
  "finance.addRecord": "Kayıt Ekle",
  "finance.titlePlaceholder": "Başlık",
  "finance.amountPlaceholder": "Tutar",
  "finance.period": "Periyot",
  "finance.oneTime": "Tek Seferlik",
  "finance.monthly": "Aylık",
  "finance.noRecords": "Bu dönemde kayıt yok",
  "finance.filter.all": "Tümü",
  "finance.filter.income": "Gelir",
  "finance.filter.expense": "Gider",
  "finance.savings.title": "Birikim & Yatırım",
  "finance.savings.add": "Birikim / Yatırım Ekle",
  "finance.savings.type": "Tür",
  "finance.savings.amount": "Miktar",
  "finance.savings.buyPrice": "Alış Fiyatı",
  "finance.savings.currentPrice": "Güncel Fiyat",
  "finance.savings.empty": "Henüz birikim kaydı yok",
  "finance.savings.reminderLabel": "Birikim için hatırlatma kur",
  "finance.installments.title": "Taksit Takibi",
  "finance.installments.add": "Taksit Ekle",
  "finance.installments.total": "Toplam",
  "finance.installments.count": "Taksit Sayısı",
  "finance.installments.paid": "Ödenen",
  "finance.installments.monthly": "Aylık Ödeme",
  "finance.installments.start": "Başlangıç",
  "finance.installments.dueDay": "Ödeme Günü",
  "finance.installments.empty": "Taksit kaydı yok",
  "finance.subs.title": "Abonelikler",
  "finance.subs.add": "Abonelik Ekle",
  "finance.subs.active": "Aktif",
  "finance.subs.passive": "Pasif",
  "finance.subs.empty": "Abonelik kaydı yok",
  "finance.bills.title": "Faturalar",
  "finance.bills.add": "Fatura Ekle",
  "finance.bills.dueDate": "Son Ödeme",
  "finance.bills.status": "Durum",
  "finance.bills.paid": "Ödendi",
  "finance.bills.unpaid": "Ödenmedi",
  "finance.bills.pending": "Beklemede",
  "finance.bills.empty": "Fatura kaydı yok",
  "finance.report.title": "Finans Raporu",
  "finance.report.incomeExpense": "Gelir / Gider",
  "finance.report.categoryExpense": "Gider Kategorileri",
  "finance.report.categoryIncome": "Gelir Kategorileri",
  "finance.report.sharedExpenses": "Ortak Harcamalar",
  "finance.newCategory": "Yeni kategori",

  /* ── Sağlık ── */
  "health.addRecord": "Sağlık Kaydı Ekle",
  "health.empty": "Sağlık kaydı yok",
  "health.type": "Kayıt Türü",
  "health.person": "Kişi",
  "health.date": "Tarih",
  "health.note": "Not",
  "health.filter.all": "Tümü",
  "health.filter.mine": "Benimkiler",
  "health.medicine.title": "İlaç Takibi",
  "health.medicine.add": "İlaç Ekle",
  "health.medicine.empty": "İlaç kaydı yok",
  "health.medicine.name": "İlaç Adı",
  "health.medicine.dose": "Doz",
  "health.medicine.frequency": "Sıklık",
  "health.medicine.start": "Başlangıç",
  "health.medicine.end": "Bitiş",
  "health.appointment.title": "Randevular",
  "health.appointment.add": "Randevu Ekle",
  "health.appointment.empty": "Randevu kaydı yok",
  "health.appointment.doctor": "Doktor / Klinik",
  "health.appointment.specialty": "Uzmanlık",
  "health.appointment.date": "Tarih",
  "health.appointment.time": "Saat",

  /* ── Çocuk Takibi ── */
  "children.add": "Çocuk / Bebek Ekle",
  "children.empty": "Çocuk takip kaydı yok",
  "children.name": "Ad Soyad",
  "children.birthDate": "Doğum Tarihi",
  "children.gender": "Cinsiyet",
  "children.notes": "Notlar",
  "children.growth.title": "Büyüme Takibi",
  "children.growth.height": "Boy (cm)",
  "children.growth.weight": "Kilo (kg)",
  "children.growth.date": "Tarih",
  "children.vaccine.title": "Aşı Takibi",
  "children.vaccine.name": "Aşı Adı",
  "children.vaccine.date": "Aşı Tarihi",
  "children.vaccine.done": "Yapıldı",
  "children.vaccine.pending": "Bekliyor",
  "children.milestone.title": "Gelişim Kilometre Taşları",
  "children.milestone.empty": "Kayıt yok",
  "children.empty.growth": "Henüz gelişim kaydı yok.",
  "children.empty.health": "Henüz sağlık kaydı yok.",
  "children.empty.routine": "Henüz rutin/aktivite kaydı yok.",
  "children.empty.nutrition": "Henüz beslenme kaydı yok.",
  "children.empty.diaper": "Henüz bez kaydı yok.",
  "children.empty.care": "Henüz bakım kaydı yok.",
  "children.empty.memory": "Henüz anı kaydı yok.",
  "children.empty.general": "Henüz kayıt yok.",
  "children.section.growth": "Gelişim Takibi",
  "children.section.nutrition": "Beslenme",
  "children.section.routine.baby": "Uyku",
  "children.section.diaper": "Bez Takibi",
  "children.section.health": "Sağlık",
  "children.section.memory": "Anılar",
  "children.section.health.pet": "Sağlık / Veteriner",
  "children.section.care": "Bakım",
  "children.section.routine.pet": "Aktivite",
  "children.section.growth.pet": "Kilo / Gelişim",
  "children.section.education": "Okul / Eğitim",
  "children.section.routine": "Günlük Rutin",

  /* ── Sohbet ── */
  "chat.placeholder": "Mesaj yaz…",
  "chat.send": "Gönder",
  "chat.empty": "Henüz mesaj yok",
  "chat.newRoom": "Yeni Oda",
  "chat.deleteRoom": "Odayı Sil",
  "chat.roomName": "Oda adı",
  "chat.you": "Sen",
  "chat.today": "Bugün",
  "chat.yesterday": "Dün",
  "chat.noRooms": "Henüz sohbet yok",
  "chat.noRoomsSub": "Yeni bir sohbet başlatmak için + butonuna dokun",
  "chat.noMessages": "Henüz mesaj yok",
  "chat.noMessagesSub": "İlk mesajı sen gönder!",
  "chat.noResults": "Sonuç bulunamadı",
  "chat.searchPlaceholder": "Mesajlarda ara...",
  "chat.inputPlaceholder": "Bir şey yaz…",
  "chat.deleteMsg": "Mesajı sil",
  "chat.roomNamePlaceholder": "Örn: Hafta sonu planları",

  /* ── Belgeler ── */
  "documents.add": "Belge Yükle",
  "documents.empty": "Belge yok",
  "documents.name": "Belge Adı",
  "documents.type": "Tür",
  "documents.owner": "Sahibi",
  "documents.expiry": "Geçerlilik",
  "documents.expired": "Süresi doldu ⚠️",
  "documents.valid": "Geçerli ✓",
  "documents.daysLeft": "gün kaldı",
  "documents.expiresSoon": "Yakında Doluyor",
  "documents.noExpiry": "Süresiz",
  "documents.download": "İndir",
  "documents.delete": "Sil",
  "documents.filter.all": "Tümü",
  "documents.filter.mine": "Benimkiler",
  "documents.filter.expiring": "Yakında Doluyor",
  "documents.newVersion": "Yeni Versiyon",
  "documents.versions": "Versiyonlar",

  /* ── Kullanıcı Yönetimi ── */
  "management.title": "Yönetim",
  "management.members": "Üyeler",
  "management.permissions": "İzinler",
  "management.invite": "Davet Et",
  "management.remove": "Çıkar",
  "management.role": "Rol",
  "management.authority": "Yetki",
  "management.save": "Kaydet",
  "management.saved": "Kaydedildi ✓",
  "management.empty": "Üye yok",
  "management.tab.pages": "Sayfalar",
  "management.tab.actions": "İşlemler",
  "management.tab.password": "Şifre",
  "management.tab.profile": "Profil",
  "management.profileRoleTitle": "Üyelik ve aile rolü",
  "management.profileRoleDesc": "Ailem kartı ile senkron çalışan premium profil yönetimi.",
  "management.memberRole": "Aile rolü",
  "management.membershipType": "Üyelik tipi",
  "management.selectRole": "Rol seç",
  "management.profileRoleSyncDesc": "Buradan yapılan değişiklik Ailem kartında, Ailem kartındaki değişiklik de burada aynı bilgilerle görünür.",
  "management.passwordResetFailed": "Şifre sıfırlama e-postası gönderilemedi.",
  "family.error.passwordResetFailed": "Şifre sıfırlama e-postası gönderilemedi. Lütfen e-posta adresini ve Firebase Auth durumunu kontrol edin.",
  "family.error.passwordResetUserNotFound": "Bu e-posta için Firebase Auth üzerinde kullanıcı bulunamadı.",
  "family.error.invalidEmail": "Geçerli bir e-posta adresi bulunamadı.",
  "management.saving": "Kaydediliyor...",
  "management.template": "Hızlı Şablon",
  "management.template.custom": "Özel",
  "management.template.full": "Tam Yetkili",
  "management.template.standard": "Standart Üye",
  "management.template.child": "Çocuk",
  "management.template.viewonly": "Sadece Görüntüle",
  "management.passwordReset": "📨 Şifre Sıfırlama E-postası Gönder",
  "management.passwordResetDesc": "Bu kullanıcıya şifre sıfırlama e-postası gönderin. Kullanıcı e-postasındaki bağlantıya tıklayarak yeni şifresini oluşturabilir.",
  "management.noEmail": "E-posta bulunamadı",
  "management.passwordResetSent": "Şifre sıfırlama e-postası gönderildi ✓",

  /* ── Sağlık kart başlıkları ── */
  "health.card.summary": "Sağlık Özeti",
  "health.card.medicine": "İlaç Takibi",
  "health.card.appointment": "Randevular",
  "health.card.measurement": "Ölçümler",
  "health.card.report": "Tahlil / Raporlar",
  "health.card.allergy": "Alerjiler",
  "health.card.condition": "Kronik Hastalıklar",
  "health.card.vaccine": "Aşı Takibi",
  "health.card.emergency": "Acil Durum Kartı",
  "health.card.note": "Sağlık Notları",
  "health.myProfile": "Kendi Sağlık Profilim",
  "health.noBirthDate": "Doğum tarihi yok",
  "health.noBloodType": "Kan grubu yok",
  "health.noRole": "Aile üyesi",
  "health.notSpecified": "Belirtilmedi",
  "health.save": "Kaydet",
  "health.cancel": "İptal",
  "health.addToCalendar": "Takvime ekle",
  "health.createTask": "Görev oluştur",

  /* ── Ortak tip seçici ── */
  "common.type": "Tür",
  "common.status": "Durum",
  "common.all2": "Tüm",

  /* ── Sağlık detay metinleri ── */
  "health.myInfo": "Sağlık Bilgilerim",
  "health.myInfoDesc": "Kan grubu, acil kişi, alerji, doktor ve özel notlar",
  "health.select": "Seç",
  "health.status.pending": "Bekliyor",
  "health.status.done": "Yapıldı",
  "health.status.active": "Aktif takip",
  "health.status.passive": "Pasif/geçmiş",
  "health.status.dotDone": "● Yapıldı",
  "health.status.dotLate": "● Gecikti",
  "health.status.dotPending": "○ Bekliyor",
  "health.status.dotCompleted": "● Tamamlandı",
  "health.status.dotPassive": "○ Pasif",
  "health.status.dotActive": "● Aktif",
  "health.medicine.planTitle": "İlaç planı oluştur",
  "health.medicine.planDesc": "Her saat ayrı doz olarak takip edilir ve zamanı gelince push bildirimi gönderilir.",
  "health.appointment.type": "Randevu tipi",
  "health.appointment.note": "Randevu notu",
  "health.appointment.default": "Sağlık Randevusu",
  "health.measurement.typePlaceholder": "Ölçüm tipi seç veya yaz",
  "health.measurement.default": "Ölçüm",
  "health.section.intro.appointment": "Takvimle bağlantılı, istersen görev olarak da takip edilebilir.",
  "health.section.intro.measurement": "Tansiyon, şeker, nabız, kilo ve diğer değerleri düzenli takip et.",
  "health.record.noAppointment": "Yok",
  "health.record.noMeasurement": "Yok",
  "health.record.nextAppt": "📅 Sonraki Randevu",
  "health.record.lastMeasurement": "🩺 Son Ölçüm",
  "health.record.reports": "📄 Rapor",
  "health.record.recordCount": "kayıt",
  "health.summary.label": "❤️ Sağlık özeti",
  "health.summary.noData": "Sağlık verisi ekleyin",
  "health.summary.emergencyCard": "Acil kart",
  "health.summary.todayDosesDone": "Bugünün dozları tamam",
  "health.summary.noMedicine": "İlaç yok",
  "health.summary.activeMedicine": "aktif ilaç",
  "health.summary.appointment": "Randevu:",
  "health.summary.chronic": "kronik",
  "health.summary.emergencyAvail": "Acil kart mevcut",
  "health.dose.label": "💉 Doz",
  "health.dose.plan": "📅 Plan",
  "health.dose.done": "✅ Yapıldı",
  "health.dose.yes": "Evet",
  "health.dose.no": "Hayır",
  "health.dose.next": "🔜 Sonraki",
  "health.dose.note": "📝 Not",
  "health.premium.title": "Sağlık kayıtları",
  "health.premium.b1": "Kişi başı sınırsız sağlık kaydı",
  "health.premium.b2": "İlaç ve hatırlatıcı takibi",
  "health.premium.b3": "Alerji ve kronik hastalık takibi",
  "health.premium.b4": "Tüm modüllerde sınırsız kullanım",
  "health.section.intro.report": "Tahlil sonuçları, raporlar ve sağlık belgelerini takip edin.",
  "health.section.intro.allergy": "Alerji, şiddet, belirti ve acil durum aksiyonlarını takip edin.",
  "health.section.intro.condition": "Kronik hastalık, doktor ve takip sıklığını kaydedin.",
  "health.section.intro.vaccine": "Planlanan ve yapılan aşıları takip edin.",
  "health.section.intro.emergency": "Acil kişi ve kritik sağlık bilgilerini saklayın.",
  "health.section.intro.note": "Genel sağlık notlarını tek yerde tutun.",
  "health.category": "Randevu",
  "health.bloodContext.ac": "Aç",
  "health.bloodContext.tok": "Tok",
  "health.bloodContext.rest": "Dinlenme",
  "health.bloodContext.postEx": "Egzersiz sonrası",
  "health.bloodContext.night": "Gece",
  "common.notification.count": "bildirim",

  /* ── Finans ek ── */
  "finance.savings.portfolio": "Birikim Portföyü",
  "finance.savings.portfolioDesc": "Altın, mevduat, borsa, kripto, döviz, gayrimenkul ve diğer birikimlerin manuel takibi.",
  "finance.backToFinance": "Finansa Dön",
  "finance.savings.addPlaceholder": "Birikim adı: Gram altın, THYAO, BTC...",
  "finance.savings.amountPlaceholder": "Miktar / adet / gram",
  "finance.savings.buyPricePlaceholder": "Alış fiyatı",
  "finance.savings.currentPricePlaceholder": "Güncel fiyat",
  "finance.savings.goldAmountPlaceholder": "Miktar / gram / adet",
  "finance.savings.buyUnitPricePlaceholder": "Alış birim fiyatı",
  "finance.savings.currentUnitPricePlaceholder": "Güncel birim fiyatı",
  "finance.savings.bankPlaceholder": "Banka adı",
  "finance.savings.principalPlaceholder": "Ana para / toplam tutar",
  "finance.savings.interestRatePlaceholder": "Faiz oranı (%)",
  "finance.savings.currentTotalValuePlaceholder": "Güncel toplam değer",
  "finance.savings.stockCodePlaceholder": "Hisse kodu: THYAO, ASELS...",
  "finance.savings.stockNamePlaceholder": "Hisse adı",
  "finance.savings.lotAmountPlaceholder": "Lot adedi",
  "finance.savings.coinSymbolPlaceholder": "Coin sembolü: BTC, ETH...",
  "finance.savings.coinNamePlaceholder": "Coin adı",
  "finance.savings.cryptoAmountPlaceholder": "Coin miktarı",
  "finance.savings.platformPlaceholder": "Borsa / platform",
  "finance.savings.currencyAmountPlaceholder": "Döviz miktarı",
  "finance.savings.buyRatePlaceholder": "Alış kuru",
  "finance.savings.currentRatePlaceholder": "Güncel kur",
  "finance.savings.fundCodePlaceholder": "Fon kodu",
  "finance.savings.fundNamePlaceholder": "Fon adı",
  "finance.savings.shareAmountPlaceholder": "Pay adedi",
  "finance.savings.cashAmountPlaceholder": "Nakit tutar",
  "finance.savings.storagePlacePlaceholder": "Saklama yeri: banka, kasa, cüzdan...",
  "finance.savings.notePlaceholder": "Not",
  "finance.savings.updatePrice": "Güncel kur / fiyat",
  "finance.savings.updatePriceHint": "Yeni değeri gir; aynı varlığa ait tüm kayıtlar birlikte güncellensin.",
  "finance.savings.update": "Güncelle",
  "finance.savings.cost": "Maliyet",
  "finance.savings.currentValue": "Güncel Değer",
  "finance.savings.profitLoss": "Kar / Zarar",
  "finance.savings.units": "birim",
  "finance.savings.buyDate": "Alış",
  "finance.savings.datePlaceholder": "Alış / kayıt tarihi",
  "finance.savings.termStartDatePlaceholder": "Vade başlangıç tarihi",
  "finance.savings.termEndDatePlaceholder": "Vade bitiş tarihi",
  "finance.validation.title": "Eksik zorunlu alanlar var",
  "finance.validation.fillFields": "Lütfen kırmızı işaretli alanları doldurun:",
  "finance.validation.installmentName": "Taksit adı",
  "finance.validation.installmentCounts.title": "Taksit bilgilerini kontrol edin",
  "finance.validation.installmentCounts.totalRequired": "Taksit sayısı zorunludur.",
  "finance.validation.installmentCounts.totalInteger": "Taksit sayısı tam sayı olmalıdır.",
  "finance.validation.installmentCounts.totalRange": "Taksit sayısı 1 ile {{max}} arasında olmalıdır.",
  "finance.validation.installmentCounts.paidRequired": "Ödenen taksit sayısı zorunludur.",
  "finance.validation.installmentCounts.paidInteger": "Ödenen taksit sayısı tam sayı olmalıdır.",
  "finance.validation.installmentCounts.paidNonNegative": "Ödenen taksit sayısı 0'dan küçük olamaz.",
  "finance.validation.installmentCounts.paidExceedsTotal": "Ödenen taksit sayısı toplam taksit sayısından fazla olamaz.",
  "finance.validation.installmentCounts.paidChangeLimit": "Tek işlemde en fazla {{limit}} taksitlik değişiklik yapabilirsiniz.",
  "finance.action.adding": "Ekleniyor...",
  "finance.debt.gold.category": "Altın Borcu",
  "finance.debt.fx.category": "Döviz Borcu",
  "finance.debt.gold.title": "Altın borcu planı",
  "finance.debt.gold.hint": "Altın kalemlerini ve aylık ödeme planınızı güvenle takip edin. Güncel değer mevcut piyasa fiyatlarıyla hesaplanır.",
  "finance.debt.fx.title": "Döviz borcu planı",
  "finance.debt.fx.hint": "Borç ve ödeme para birimlerini ayrı seçin; kalan tutar mevcut döviz kuruyla güncellensin.",
  "finance.debt.gold.item": "Altın kalemi",
  "finance.debt.gold.addItem": "Altın kalemi ekle",
  "finance.debt.gold.addPaymentItem": "Ödemeye altın ekle",
  "finance.debt.gold.amount": "Altın miktarı",
  "finance.debt.gold.quantityPieces": "Adet",
  "finance.debt.gold.quantityGram": "Toplam gram",
  "finance.debt.gold.quantityOunce": "Troy ons",
  "finance.debt.gold.karat": "Ayar (zorunlu)",
  "finance.debt.gold.purity": "Saflık (zorunlu)",
  "finance.debt.gold.type.gram": "Gram altın",
  "finance.debt.gold.type.quarter": "Çeyrek altın",
  "finance.debt.gold.type.half": "Yarım altın",
  "finance.debt.gold.type.full": "Tam altın",
  "finance.debt.gold.type.republic": "Cumhuriyet altını",
  "finance.debt.gold.type.ata": "Ata altın",
  "finance.debt.gold.type.bracelet": "Bilezik",
  "finance.debt.gold.type.other_jewelry": "Diğer altın/takı",
  "finance.debt.gold.type.ounce": "Troy ons altın",
  "finance.debt.gold.type.bar": "Altın külçe",
  "finance.debt.gold.type.coin": "Altın para",
  "finance.debt.gold.type.jewelry": "Altın takı",
  "finance.debt.gold.type.custom": "Diğer altın",
  "finance.debt.fx.principal": "Toplam döviz borcu",
  "finance.debt.fx.currency": "Borç para birimi",
  "finance.debt.monthlyPayment": "Aylık ödeme miktarı",
  "finance.debt.setReminder": "Bu borç için özel hatırlatma kur",
  "finance.debt.customReminderTitle": "🔔 Borç planı hatırlatman",
  "finance.debt.customReminderBody": "\"{{name}}\" için oluşturduğun kişisel hatırlatmanın zamanı geldi.",
  "finance.debt.reminderSaveFailed": "Borç kaydedildi ancak özel hatırlatma oluşturulamadı. Lütfen kaydı düzenleyip tekrar deneyin.",
  "finance.debt.progress": "Borç ödeme ilerlemesi",
  "finance.debt.estimatedMonths": "Tahmini kalan ay",
  "finance.debt.remainingPrincipal": "kalan ana borç",
  "finance.debt.nextPayment": "Sonraki ödeme",
  "finance.debt.estimatedEnd": "Tahmini bitiş",
  "finance.debt.marketUpdated": "Piyasa güncellendi",
  "finance.debt.marketMayBeStale": "Piyasa fiyatı güncel olmayabilir",
  "finance.debt.addPayment": "Ödeme ekle",
  "finance.debt.paymentTitle": "Borç ödemesi ekle",
  "finance.debt.payment.money": "Para ile ödeme",
  "finance.debt.payment.gold": "Altın ile ödeme",
  "finance.debt.payment.mixed": "Karma ödeme",
  "finance.debt.payment.amount": "Ödenen para tutarı",
  "finance.debt.payment.date": "Ödeme tarihi",
  "finance.debt.payment.note": "Ödeme notu (isteğe bağlı)",
  "finance.debt.payment.save": "Ödemeyi kaydet",
  "finance.debt.payment.history": "Son ödemeler",
  "finance.debt.paymentRequired": "Ödeme türüne uygun tutar veya altın miktarını doldurun.",
  "finance.debt.paymentFailed": "Borç ödemesi kaydedilemedi. Lütfen tekrar deneyin.",
  "finance.debt.estimateDisclaimer": "Tahmin, güncel altın veya döviz fiyatlarının sabit kaldığı varsayımıyla hesaplanır.",
  "finance.goldDebt.tomorrowTitle": "✨ Yarın altın borcu ödeme günün",
  "finance.goldDebt.todayTitle": "✨ Bugün altın borcu ödeme günün",
  "finance.goldDebt.tomorrowBody": "\"{{name}}\" için yarın planladığın {{amount}} ödemeyi birlikte takip etmeyi unutmayalım 😊",
  "finance.goldDebt.todayBody": "\"{{name}}\" için ödeme günün bugün. Küçük ama düzenli adımlar borcu hafifletir 💛",
  "finance.fxDebt.tomorrowTitle": "💱 Yarın döviz borcu ödeme günün",
  "finance.fxDebt.todayTitle": "💱 Bugün döviz borcu ödeme günün",
  "finance.fxDebt.tomorrowBody": "\"{{name}}\" için yarın {{amount}} ödeme planın var. Şimdiden haber vereyim 😊",
  "finance.fxDebt.todayBody": "\"{{name}}\" döviz borcu ödeme günün bugün. Planındaki bir adımı daha tamamlayabilirsin 💪",
  "finance.realEstate.add": "Gayrimenkul Ekle",
  "finance.realEstate.formTitle": "Gayrimenkul bilgileri",
  "finance.realEstate.formHint": "Portföyünüzü doğru takip edebilmek için temel bilgileri girin; isteğe bağlı alanları daha sonra da güncelleyebilirsiniz.",
  "finance.realEstate.identitySection": "Mülk ve konum",
  "finance.realEstate.valueSection": "Değer ve kullanım",
  "finance.realEstate.ownershipSection": "Tapu ve finansman",
  "finance.realEstate.name": "Gayrimenkul adı",
  "finance.realEstate.namePlaceholder": "Örn. Çankaya'daki ev, Bodrum arsası",
  "finance.realEstate.type": "Gayrimenkul türü",
  "finance.realEstate.typePlaceholder": "Tür seçin",
  "finance.realEstate.type.apartment": "Daire",
  "finance.realEstate.type.house": "Müstakil ev",
  "finance.realEstate.type.villa": "Villa",
  "finance.realEstate.type.land": "Arsa / arazi",
  "finance.realEstate.type.commercial": "Ticari gayrimenkul",
  "finance.realEstate.type.office": "Ofis",
  "finance.realEstate.type.shop": "Dükkan",
  "finance.realEstate.type.warehouse": "Depo",
  "finance.realEstate.type.other": "Diğer",
  "finance.realEstate.city": "Şehir",
  "finance.realEstate.cityPlaceholder": "Örn. Ankara",
  "finance.realEstate.district": "İlçe",
  "finance.realEstate.districtPlaceholder": "Örn. Çankaya",
  "finance.realEstate.neighborhood": "Mahalle / bölge",
  "finance.realEstate.neighborhoodPlaceholder": "Örn. Bahçelievler",
  "finance.realEstate.area": "Brüt alan",
  "finance.realEstate.rooms": "Oda sayısı",
  "finance.realEstate.roomsPlaceholder": "Örn. 3+1",
  "finance.realEstate.currency": "Para birimi",
  "finance.realEstate.purchasePrice": "Alış bedeli",
  "finance.realEstate.currentValue": "Güncel tahmini değer",
  "finance.realEstate.purchaseDate": "Edinme tarihi",
  "finance.realEstate.useStatus": "Kullanım durumu",
  "finance.realEstate.use.owner_occupied": "Aile kullanıyor",
  "finance.realEstate.use.rented": "Kirada",
  "finance.realEstate.use.vacant": "Boş",
  "finance.realEstate.use.under_construction": "Yapım aşamasında",
  "finance.realEstate.monthlyRent": "Aylık kira geliri",
  "finance.realEstate.leaseStart": "Kira başlangıç tarihi",
  "finance.realEstate.deedStatus": "Tapu durumu",
  "finance.realEstate.deed.full": "Tam mülkiyet",
  "finance.realEstate.deed.shared": "Hisseli tapu",
  "finance.realEstate.deed.mortgaged": "İpotekli",
  "finance.realEstate.deed.other": "Diğer",
  "finance.realEstate.ownershipShare": "Sahiplik payı (%)",
  "finance.realEstate.remainingLoan": "Kalan kredi borcu",
  "finance.realEstate.monthlyLoanPayment": "Aylık kredi ödemesi",
  "finance.realEstate.valueChange": "Değer değişimi",
  "finance.realEstate.netEquity": "Net özkaynak",
  "finance.realEstate.grossYield": "Tahmini brüt kira getirisi",
  "finance.realEstate.updateValue": "Değeri Güncelle",
  "finance.realEstate.updateValueHint": "Son tahmini piyasa değerini girin.",
  "finance.realEstate.emptyTitle": "Henüz gayrimenkul kaydı yok",
  "finance.realEstate.emptyText": "İlk gayrimenkulünüzü ekleyin; değer, kira geliri ve kredi durumunu düzenli olarak takip edin.",
  "finance.installments.hero": "Ev Taksitleri",
  "finance.installments.heroDesc": "Bu ay ödenecek toplam taksit. Tüm ev taksitlerini tek yerden takip et.",
  "finance.installments.namePlaceholder": "Taksit adı: Telefon, beyaz eşya, kredi...",
  "finance.installments.totalPlaceholder": "Toplam tutar",
  "finance.installments.countPlaceholder": "Taksit sayısı",
  "finance.installments.paidCountPlaceholder": "Ödenen taksit",
  "finance.installments.monthlyPlaceholder": "Aylık ödeme (boşsa otomatik)",
  "finance.installments.dueDayPlaceholder": "Son ödeme günü",
  "finance.installments.notePlaceholder": "Not",
  "finance.installments.paidOf": "ödendi",
  "finance.installments.monthlyPayment": "Aylık Ödeme",
  "finance.installments.remaining": "Kalan Taksit",
  "finance.installments.remainingDebt": "Kalan Borç",
  "finance.installments.eachMonth": "Her ay",
  "finance.installments.day": ". gün",
  "finance.installments.reminderLabel": "Taksit ödemesi için hatırlatma kur",
  "finance.notifyTarget.title": "Otomatik bildirim kime gitsin?",
  "finance.notifyTarget.self": "Sadece bana",
  "finance.notifyTarget.admins": "Aile yöneticilerine",
  "finance.notifyTarget.selected": "Seçili aile üyelerine",
  "finance.notifyTarget.all": "Tüm aileye",
  "finance.notifyTarget.hint": "Bu seçim yalnızca otomatik finans hatırlatmalarını etkiler. Kullanıcının Finans Bildirimleri kapalıysa bildirim gitmez.",
  "finance.notifyTarget.noMembers": "Seçilebilecek aile üyesi yok.",
  "finance.notifyTarget.member": "Aile üyesi",
  "finance.installments.startDatePlaceholder": "Başlangıç tarihi",
  "finance.subs.hero": "Abonelik Takibi",
  "finance.subs.heroDesc": "Aylık toplam abonelik maliyeti",
  "finance.subs.activeCount": "aktif abonelik",
  "finance.subs.platform": "Platform / Servis",
  "finance.subs.selectPlatform": "Seçiniz...",
  "finance.subs.renewalPeriod": "Yenileme Periyodu",
  "finance.subs.nextPayment": "Sonraki Ödeme",
  "finance.subs.payer": "Kim Ödüyor",
  "finance.subs.payerPlaceholder": "İsim",
  "finance.subs.status": "Durum",
  "finance.subs.statusActive": "Evet",
  "finance.subs.statusInactive": "Hayır",
  "finance.subs.notePlaceholder": "Not (isteğe bağlı)",
  "finance.subs.toggleActive": "Aktif et",
  "finance.subs.togglePassive": "Pasife al",
  "finance.subs.activeLabel": "Aktif",
  "finance.subs.passiveLabel": "Pasif",
  "finance.subs.monthlyCost": "Aylık Maliyet",
  "finance.subs.yearlyCost": "Yıllık Maliyet",
  "finance.subs.nextPaymentLabel": "Sonraki ödeme:",
  "finance.subs.reminderLabel": "Abonelik yenileme hatırlatması kur",
  "finance.subs.manualName": "Abonelik adı girin",
  "finance.subs.amount": "Tutar",
  "finance.subs.currency": "Para Birimi",
  "finance.bills.hero": "Fatura Takibi",
  "finance.bills.heroDesc": "Ödenmemiş fatura toplamı",
  "finance.bills.pendingCount": "bekleyen",
  "finance.bills.type": "Fatura Türü",
  "finance.bills.period": "Periyot",
  "finance.bills.manualName": "Fatura adı girin",
  "finance.bills.amount": "Tutar",
  "finance.bills.currency": "Para Birimi",
  "finance.bills.dueDate2": "Son Ödeme Tarihi",
  "finance.bills.payer": "Kim Ödüyor",
  "finance.bills.payerPlaceholder": "İsim (isteğe bağlı)",
  "finance.bills.notePlaceholder": "Not (isteğe bağlı)",
  "finance.bills.reminderLabel": "Fatura son ödeme hatırlatması kur",
  "finance.bills.markPaid": "Ödendi olarak işaretle",
  "finance.bills.markUnpaid": "Ödenmedi olarak işaretle",
  "finance.bills.paidBtn": "Ödendi ✓",
  "finance.bills.payBtn": "Öde",
  "finance.bills.dueDateLabel": "Son Ödeme",
  "finance.bills.statusLabel": "Durum",
  "finance.bills.overdue": "gün gecikmiş",
  "finance.bills.daysLeft": "gün kaldı",
  "finance.bills.carryover.eyebrow": "Geçmişten devreden",
  "finance.bills.carryover.title": "Ödenmemiş faturalar",
  "finance.bills.carryover.hint": "Önceki aylardan kalan faturalar, ödendi olarak işaretlenene kadar burada görünür.",
  "finance.bills.carryover.count": "{{count}} gecikmiş fatura",
  "finance.bills.carryover.badge": "Vadesi geçmiş",
  "finance.bills.currentMonth.eyebrow": "Seçili dönem",
  "finance.bills.currentMonth.title": "Bu ayın faturaları",
  "finance.bills.quick.eyebrow": "Geçen aydan hazır",
  "finance.bills.quick.title": "Hızlı fatura ekle",
  "finance.bills.quick.hint": "Tutarı ve son ödeme tarihini güncelle; diğer bilgiler geçen aydan güvenle alınsın.",
  "finance.bills.quick.lastMonth": "Geçen ayki kayıttan",
  "finance.bills.quick.add": "Bu aya ekle",
  "finance.bills.quick.adding": "Ekleniyor...",
  "finance.bills.quick.validation": "Fatura tutarını ve son ödeme tarihini kontrol et.",
  "finance.bills.quick.error": "Fatura bu aya eklenemedi. Lütfen tekrar dene.",
  "finance.report.last30": "Son 30 Gün Trend",
  "finance.report.last30empty": "Son 30 gün içinde grafik oluşturacak gelir/gider kaydı yok",

  /* ── Yönetim bildirim paneli ── */
  "mgmt.repeat.none": "Tek Sefer",
  "mgmt.repeat.hourly": "Her Saat",
  "mgmt.repeat.daily": "Her Gün",
  "mgmt.repeat.every3days": "3 Günde Bir",
  "mgmt.repeat.weekly": "Her Hafta",
  "mgmt.repeat.monthly": "Her Ay",
  "mgmt.target.allUsers": "Tüm kullanıcılar",
  "mgmt.target.familyUsers": "Aile üyeleri",
  "mgmt.target.users": "Seçili kullanıcılar",
  "mgmt.send.now": "Hemen Gönder",
  "mgmt.send.scheduled": "Zamanla",
  "mgmt.send.scheduledAlt": "Zamanlı Gönder",
  "mgmt.notify.prepare": "🔔 Aile Bildirimi Hazırla",
  "mgmt.notify.recent": "🕘 Son Gönderilenler",
  "mgmt.notify.scheduled": "⏰ Zamanlı Bildirimler",
  "mgmt.notify.systemAnnouncement": "📢 Tüm Kullanıcılara Sistem Duyurusu",
  "mgmt.notify.automation": "⚙️ Otomatik Bildirim Kuralları",
  "mgmt.notify.repeatAnnouncements": "📢 Tekrar Eden Sistem Duyuruları",
  "mgmt.notify.recentLogs": "🕘 Son Çalışma Logları",
  "mgmt.notify.automationTitle": "⚙️ Bildirim Otomasyonu",
  "mgmt.notify.quietHours": "🌙 Genel Sessiz Saat Politikası",
  "mgmt.notify.policyTitle": "🔧 Bildirim Saat Politikaları",
  "mgmt.notify.scheduled2": "⏰ Zamanlanmış Bildirimler",
  "mgmt.notify.readers": "Okuyanlar",
  "mgmt.notify.noReaders": "Henüz okuyan yok.",
  "mgmt.notify.unread": "Okumayanlar",
  "mgmt.notify.allRead": "Herkes okudu.",
  "mgmt.notify.lastRun": "Son çalışma",
  "mgmt.notify.result": "Sonuç",
  "mgmt.notify.sentPush": "Gönderilen push",
  "mgmt.notify.error": "Hata",
  "mgmt.notify.activeScheduled": "Aktif zamanlı bildirim",
  "mgmt.notify.pendingNotif": "Bekleyen bildirim",
  "mgmt.notify.todaySent": "Bugün gönderilen bildirim",
  "mgmt.notify.applyQuiet": "Sistem genelinde sessiz saatleri uygula",
  "mgmt.notify.respectQuiet": "Sessiz saatlere uy",
  "mgmt.notify.blockRepeat": "Tekrar eden bildirimi engelle",
  "mgmt.notify.target": "Hedef kullanıcı",
  "mgmt.notify.pendingTotal": "Bekleyen toplam",
  "mgmt.notify.filtered": "Filtrelenen",
  "mgmt.notify.repeat": "Tekrarlı",
  "mgmt.notify.targetLabel": "Hedef:",
  "mgmt.notify.targetCount": "Hedef sayısı:",
  "mgmt.notify.repeatLabel": "Tekrar:",
  "mgmt.notify.planLabel": "Plan:",
  "mgmt.notify.typeLabel": "Tip:",
  "mgmt.notify.creatorLabel": "Oluşturan:",
  "mgmt.notify.statusPending": "bekliyor",
  "mgmt.profile.email": "📧",

  /* ── İzin etiketleri ── */
  "perm.addShopping": "Ürün ekleyebilir",
  "perm.deleteOwnShopping": "Kendi ürününü silebilir",
  "perm.deleteAllShopping": "Tüm ürünleri silebilir",
  "perm.addCalendarEvent": "Etkinlik ekleyebilir",
  "perm.updateOwnCalendarEvent": "Kendi etkinliğini düzenleyebilir",
  "perm.updateAllCalendarEvents": "Tüm etkinlikleri düzenleyebilir",
  "perm.deleteOwnCalendarEvent": "Kendi etkinliğini silebilir",
  "perm.deleteAllCalendarEvents": "Tüm etkinlikleri silebilir",
  "perm.addFinance": "Gelir/Gider ekleyebilir",
  "perm.deleteOwnFinance": "Kendi kaydını silebilir",
  "perm.deleteAllFinance": "Tüm kayıtları silebilir",
  "perm.addTask": "Görev oluşturabilir",
  "perm.completeOwnTask": "Kendi görevini tamamlayabilir",
  "perm.completeAllTasks": "Tüm görevleri tamamlayabilir",
  "perm.deleteOwnTask": "Kendi görevini silebilir",
  "perm.deleteAllTasks": "Tüm görevleri silebilir",
  "perm.addSharedExpense": "Harcama ekleyebilir",
  "perm.deleteOwnSharedExpense": "Kendi harcamasını silebilir",
  "perm.deleteAllSharedExpense": "Tüm harcamaları silebilir",
  "perm.addHealthRecord": "Sağlık kaydı ekleyebilir",
  "perm.deleteOwnHealthRecord": "Kendi sağlık kaydını silebilir",
  "perm.deleteAllHealthRecords": "Tüm sağlık kayıtlarını silebilir",
  "perm.addMapPlace": "Ortak yer ekleyebilir",
  "perm.deleteOwnMapPlace": "Kendi eklediği yeri silebilir",
  "perm.deleteAllMapPlaces": "Tüm ortak yerleri silebilir",
  "perm.shareLocation": "Konum paylaşabilir",
  "perm.addChildRecord": "Çocuk/bebek/pet kaydı ekleyebilir",
  "perm.deleteOwnChildRecord": "Kendi kaydını silebilir",
  "perm.deleteAllChildRecords": "Tüm çocuk/bebek/pet kayıtlarını silebilir",
  "perm.sendMessage": "Mesaj gönderebilir",
  "perm.editOwnMessage": "Kendi mesajını düzenleyebilir",
  "perm.deleteOwnMessage": "Kendi mesajını silebilir",
  "perm.deleteAllMessages": "Tüm mesajları silebilir",
  "perm.pinMessage": "Mesaj sabitleyebilir",
  "perm.sendMedia": "Fotoğraf/dosya gönderebilir",
  "perm.reactMessage": "Reaksiyon ekleyebilir",
  "perm.addDocument": "Belge yükleyebilir",
  "perm.deleteOwnDocument": "Kendi belgesini silebilir",
  "perm.deleteAllDocuments": "Tüm belgeleri silebilir",
  "perm.generateMealSuggestion": "Menü önerisi alabilir",
  "perm.rateMealSuggestion": "Menüyü beğenebilir / beğenmeyebilir",
  "perm.manageMealSuggestions": "Menü önerilerini yönetebilir",
  "perm.addCategory": "Kategori ekleyebilir",
  "perm.manageUsers": "Kullanıcı yetkilerini yönetebilir",
  "perm.sendFamilyNotification": "Aile bildirimi gönderebilir",
  "perm.manageScheduledNotifications": "Zamanlı bildirimleri yönetebilir",
  "perm.manageNotificationAutomation": "Bildirim otomasyonunu yönetebilir",
  "perm.sendSystemAnnouncement": "Sistem duyurusu gönderebilir",

  /* ── Chat ek ── */
  "chat.pin": "📌 Sabitle",
  "chat.unpin": "📌 Sabiti Kaldır",
  "chat.premium.multiRoom": "Birden fazla sohbet odası",
  "chat.premium.multiRoomDesc": "Aile için farklı konularda sohbet odaları oluştur",
  "chat.premium.b1": "Sınırsız sohbet odası",
  "chat.premium.b2": "Sınırsız mesaj geçmişi",
  "chat.premium.b3": "Grup ve özel sohbet",
  "chat.premium.b4": "Medya paylaşımı",
  "chat.newRoomBtn": "+ Yeni Sohbet",

  /* ── UserManagement bildirim şablonları ── */
  "mgmt.notif.template.home.title": "Eve Dönüş Saatinizi Yazın",
  "mgmt.notif.template.home.desc": "Bugün eve kaçta geleceğinizi aile grubunda paylaşır mısınız? Planımızı ona göre yapalım.",
  "mgmt.notif.template.dinner.title": "Sofra Hazır",
  "mgmt.notif.template.dinner.desc": "Yemek hazır. Müsait olan herkes sofraya gelebilir. Afiyet olsun ❤️",
  "mgmt.notif.template.meeting.title": "Aile Toplanma Hatırlatması",
  "mgmt.notif.template.meeting.desc": "Bugün ailece konuşmamız gereken bir konu var. Uygun olduğunuzda uygulamayı kontrol edin.",
  "mgmt.notif.template.shopping.title": "Ev Eksikleri Kontrolü",
  "mgmt.notif.template.shopping.desc": "Ev için alınması gereken eksikler olabilir. Alışveriş listesini kontrol eder misiniz?",
  "mgmt.notif.template.location.title": "Konum / Güvendeyim Kontrolü",
  "mgmt.notif.template.location.desc": "Müsait olduğunuzda konumunuzu veya güvende olduğunuzu aileyle paylaşır mısınız?",
  "mgmt.notif.template.emergency.desc": "Aile için önemli ve acil bir konu var. Lütfen mümkün olan en kısa sürede uygulamayı kontrol edin.",
  "mgmt.notif.priority.normal": "🔔 Normal",
  "mgmt.notif.priority.priority": "⚡ Öncelikli",
  "mgmt.notif.priority.announce": "📢 Duyuru",
  "mgmt.notif.priority.silent": "🔕 Sessiz",
  "mgmt.auto.template.welcome.title": "Aile Yönetimi seni bekliyor",
  "mgmt.auto.template.welcome.desc": "Aile planlarını ve bildirimlerini kontrol etmeyi unutma.",
  "mgmt.auto.template.tasks.title": "Görevlerini kontrol et",
  "mgmt.auto.template.tasks.desc": "Sana atanmış görevler olabilir. Hemen göz atabilirsin.",
  "mgmt.auto.template.calendar.title": "Takvime Göz At",
  "mgmt.auto.template.calendar.desc": "Yaklaşan aile etkinliklerini kaçırmamak için takvime göz at.",
  "mgmt.auto.template.shopping.title": "Alışveriş listesine göz at",
  "mgmt.auto.template.shopping.desc": "Ailenin alışveriş listesinde bekleyen ürünler olabilir.",
  "mgmt.auto.template.documents.title": "Belgeleri Kontrol Et",
  "mgmt.auto.template.documents.desc": "Belge kasasında kontrol etmen gereken kayıtlar olabilir.",
  "mgmt.auto.template.general.title": "Genel Bilgilendirme",
  "mgmt.auto.template.general.desc": "Aile Yönetimi uygulamasında yeni bir bilgilendirme var.",
  "mgmt.sys.maintenance.title": "Planlı Bakım Duyurusu",
  "mgmt.sys.maintenance.desc": "Aile Yönetimi uygulamasında kısa süreli planlı bakım yapılacaktır.",
  "mgmt.sys.newfeature.title": "Yeni Özellik Yayında",
  "mgmt.sys.newfeature.desc": "Aile Yönetimi uygulamasına yeni bir özellik eklendi.",
  "mgmt.sys.update.title": "Uygulama Güncellendi",
  "mgmt.sys.update.desc": "Daha iyi performans ve hata düzeltmeleri içeren yeni güncelleme yayına alındı.",
  "mgmt.sys.performance.title": "Performans İyileştirmesi",
  "mgmt.sys.performance.desc": "Uygulamada hız ve kararlılık iyileştirmeleri yapıldı.",
  "mgmt.sys.notification.title": "Bildirim Sistemi Yenilendi",
  "mgmt.sys.notification.desc": "Push bildirim sistemi iyileştirildi.",
  "mgmt.sys.outage.title": "Kısa Süreli Hizmet Çalışması",
  "mgmt.sys.outage.desc": "Sistem altyapısında kısa süreli çalışma yapılacaktır.",
  "mgmt.sys.sync.title": "Veri Senkronizasyonu",
  "mgmt.sys.sync.desc": "Aile verilerinizin daha düzenli senkronize edilmesi için iyileştirme yapılmıştır.",
  "mgmt.sys.announcement.title": "Genel Sistem Duyurusu",
  "mgmt.sys.announcement.desc": "Aile Yönetimi uygulamasıyla ilgili önemli bir bilgilendirme paylaşıldı.",
  "mgmt.sys.thanks.title": "Teşekkürler",
  "mgmt.sys.thanks.desc": "Aile Yönetimi uygulamasını kullandığınız için teşekkür ederiz.",
  "mgmt.sys.newyear.title": "🎉 Yeni Yıl Kutlaması",
  "mgmt.sys.newyear.desc": "Aile Yönetimi ailesi olarak yeni yılınızı kutlarız! Bu yıl da yanınızdayız.",
  "mgmt.sys.ramadan.title": "🌙 Ramazan Ayı Tebriği",
  "mgmt.sys.ramadan.desc": "Mübarek Ramazan ayınızı kutlarız, hayırlı işler getirmesini dileriz.",
  "mgmt.sys.eid.title": "🌟 Bayram Tebriği",
  "mgmt.sys.eid.desc": "Bayramınızı en içten dileklerimizle kutlarız.",
  "mgmt.sys.birthday_app.title": "🎂 Uygulama Yıl Dönümü",
  "mgmt.sys.birthday_app.desc": "Aile Yönetimi olarak bir yılı daha geride bıraktık, bizimle olduğunuz için teşekkürler!",
  "mgmt.sys.premium_offer.title": "💎 Premium Fırsatı",
  "mgmt.sys.premium_offer.desc": "Sınırlı süreli premium fırsatını kaçırmayın, tüm özelliklerin kilidini açın.",
  "mgmt.sys.premium_renewal.title": "🔁 Premium Yenileme Hatırlatması",
  "mgmt.sys.premium_renewal.desc": "Premium üyeliğinizin yenilenme tarihi yaklaşıyor.",
  "mgmt.sys.backup_done.title": "💾 Yedekleme Tamamlandı",
  "mgmt.sys.backup_done.desc": "Aile verileriniz başarıyla yedeklendi.",
  "mgmt.sys.backup_reminder.title": "🗄️ Yedekleme Hatırlatması",
  "mgmt.sys.backup_reminder.desc": "Verilerinizin güncel bir yedeğini almanızı öneririz.",
  "mgmt.sys.tip_shopping.title": "🛒 İpucu: Alışveriş Listesi",
  "mgmt.sys.tip_shopping.desc": "Alışveriş listenizi aile üyeleriyle paylaşarak birlikte yönetebilirsiniz, denediniz mi?",
  "mgmt.sys.tip_calendar.title": "📅 İpucu: Takvim Renkleri",
  "mgmt.sys.tip_calendar.desc": "Her aile üyesine farklı bir takvim rengi atayarak etkinlikleri kolayca ayırt edebilirsiniz.",
  "mgmt.sys.tip_map.title": "🗺️ İpucu: Güvenli Alanlar",
  "mgmt.sys.tip_map.desc": "Çocuklarınız için okul veya ev gibi güvenli alanlar tanımlayarak giriş-çıkışlardan haberdar olun.",
  "mgmt.sys.tip_finance.title": "💰 İpucu: Bütçe Takibi",
  "mgmt.sys.tip_finance.desc": "Finans sayfasından aylık gelir-gider grafiklerinizi inceleyebilirsiniz.",
  "mgmt.sys.tip_health.title": "❤️ İpucu: Sağlık Kayıtları",
  "mgmt.sys.tip_health.desc": "Aile bireylerinin aşı ve randevu takibini Sağlık sayfasından yapabilirsiniz.",
  "mgmt.sys.tip_chat.title": "💬 İpucu: Aile Sohbeti",
  "mgmt.sys.tip_chat.desc": "Aile sohbet odasından tüm üyelerle anlık mesajlaşabilirsiniz.",
  "mgmt.sys.feedback_request.title": "📝 Geri Bildirim İsteği",
  "mgmt.sys.feedback_request.desc": "Uygulamayı geliştirmemize yardımcı olun, görüşlerinizi bizimle paylaşın.",
  "mgmt.sys.survey.title": "📊 Kısa Anket",
  "mgmt.sys.survey.desc": "Sizin için hazırladığımız kısa anketi doldurmanızı rica ederiz.",
  "mgmt.sys.welcome.title": "👋 Hoş Geldiniz",
  "mgmt.sys.welcome.desc": "Aile Yönetimi ailesine hoş geldiniz! Size yardımcı olmak için buradayız.",
  "mgmt.sys.onboarding_tip.title": "🚀 Başlangıç İpucu",
  "mgmt.sys.onboarding_tip.desc": "Uygulamayı en verimli şekilde kullanmak için ayarlar sayfasını incelemenizi öneririz.",
  "mgmt.sys.community.title": "🤝 Topluluk Duyurusu",
  "mgmt.sys.community.desc": "Aile Yönetimi kullanıcı topluluğumuza katılarak deneyimlerinizi paylaşabilirsiniz.",
  "mgmt.sys.known_issue.title": "🐞 Bilinen Sorun Bildirimi",
  "mgmt.sys.known_issue.desc": "Tespit edilen bir sorun üzerinde çalışıyoruz, en kısa sürede çözülecektir.",
  "mgmt.sys.issue_resolved.title": "✅ Sorun Çözüldü",
  "mgmt.sys.issue_resolved.desc": "Daha önce bildirdiğimiz sorun çözülmüştür, ilginiz için teşekkürler.",
  "mgmt.sys.server_migration.title": "🔄 Sunucu Taşıma Bilgilendirmesi",
  "mgmt.sys.server_migration.desc": "Daha iyi performans için sunucu altyapımızı güncelliyoruz.",
  "mgmt.sys.new_app_version.title": "📱  Yeni Uygulama Sürümü",
  "mgmt.sys.new_app_version.desc": "Yeni özellikler içeren güncel sürüm yayınlandı, güncellemeyi unutmayın.",
  "mgmt.sys.storage_warning.title": "📦 Depolama Alanı Uyarısı",
  "mgmt.sys.storage_warning.desc": "Belge depolama alanınız dolmak üzere, lütfen kontrol edin.",
  "mgmt.sys.privacy_update.title": "🔒 Gizlilik Politikası Güncellemesi",
  "mgmt.sys.privacy_update.desc": "Gizlilik politikamızda güncelleme yapılmıştır, incelemenizi rica ederiz.",
  "mgmt.sys.terms_update.title": "📄 Kullanım Koşulları Güncellemesi",
  "mgmt.sys.terms_update.desc": "Kullanım koşullarımızda değişiklik yapılmıştır.",
  "mgmt.sys.holiday_closure.title": "🏖️ Tatil Dönemi Bilgilendirmesi",
  "mgmt.sys.holiday_closure.desc": "Resmi tatil döneminde destek ekibimiz sınırlı çalışacaktır.",
  "mgmt.sys.weather_alert.title": "🌦️ Hava Durumu Uyarısı",
  "mgmt.sys.weather_alert.desc": "Bölgenizde olumsuz hava koşulları bekleniyor, dikkatli olun.",
  "mgmt.sys.family_milestone.title": "🏆 Aile Başarısı",
  "mgmt.sys.family_milestone.desc": "Aileniz uygulamayı düzenli kullanarak harika bir alışkanlık kazandı, tebrikler!",
  "mgmt.sys.invite_friends.title": "📨 Arkadaşlarını Davet Et",
  "mgmt.sys.invite_friends.desc": "Aile Yönetimi'ni sevdiklerinizle paylaşarak onların da ailelerini düzenlemesine yardım edin.",
  "mgmt.sys.rate_app.title": "⭐ Uygulamayı Değerlendirin",
  "mgmt.sys.rate_app.desc": "Deneyiminizden memnunsanız bizi mağazada değerlendirmeyi unutmayın.",
  "mgmt.sys.new_integration.title": "🔗 Yeni Entegrasyon",
  "mgmt.sys.new_integration.desc": "Uygulamamıza yeni bir entegrasyon eklendi, keşfetmeye ne dersiniz?",
  "mgmt.sys.seasonal_tip.title": "🍂 Mevsimsel Hatırlatma",
  "mgmt.sys.seasonal_tip.desc": "Mevsim değişikliğiyle birlikte aile takviminizi gözden geçirmenizi öneririz.",
  "mgmt.sys.back_to_school.title": "🎒 Okula Dönüş Hatırlatması",
  "mgmt.sys.back_to_school.desc": "Okula dönüş dönemi için takvim ve görevlerinizi güncellemeyi unutmayın.",
  "mgmt.sys.daylight_saving.title": "🕐 Saat Değişikliği Bilgilendirmesi",
  "mgmt.sys.daylight_saving.desc": "Yaz/kış saati uygulaması başladı, takvim etkinliklerinizi kontrol edin.",
  "mgmt.sys.subscription_expired.title": "⏰ Abonelik Süresi Doldu",
  "mgmt.sys.subscription_expired.desc": "Premium aboneliğinizin süresi doldu, özelliklere erişiminiz sınırlandı.",
  "mgmt.sys.payment_failed.title": "⚠️ Ödeme Sorunu",
  "mgmt.sys.payment_failed.desc": "Son ödeme denemeniz başarısız oldu, lütfen ödeme bilgilerinizi güncelleyin.",
  "mgmt.sys.new_help_center.title": "❓ Yardım Merkezi Yenilendi",
  "mgmt.sys.new_help_center.desc": "Sıkça sorulan sorular ve yardım içerikleri güncellendi.",
  "mgmt.sys.data_export_ready.title": "📤 Veri Dışa Aktarma Hazır",
  "mgmt.sys.data_export_ready.desc": "Talep ettiğiniz veri dışa aktarma işlemi tamamlandı.",
  "mgmt.sys.general_thanks_loyal.title": "🙏 Sadık Kullanıcılara Teşekkür",
  "mgmt.sys.general_thanks_loyal.desc": "Uzun süredir bizimle olduğunuz için içtenlikle teşekkür ederiz.",
  "mgmt.notif.untitled": "Başlıksız bildirim",
  "mgmt.notif.untitledSys": "Başlıksız sistem duyurusu",
  "mgmt.notif.untitledAuto": "Otomatik Bildirim Çalışması",
  "mgmt.notif.familyMember": "Aile Üyesi",
  "mgmt.notif.noUserInfo": "Kullanıcı bilgisi yok",
  "mgmt.notif.sendBtn": "🔔 Aileye Bildirim Gönder",
  "mgmt.notif.closeBtn": "Paneli Kapat",
  "mgmt.notif.scheduledOpen": "⏰ Zamanlı Bildirimler",
  "mgmt.notif.scheduledClose": "⏰ Zamanlı Bildirimleri Kapat",
  "mgmt.notif.searchPlaceholder": "Ad, rol, kullanıcı adı veya e-posta ara",
  "mgmt.notif.titlePlaceholder": "Örn: Aile Duyurusu",
  "mgmt.notif.bodyPlaceholder": "Gönderilecek aile mesajını yaz...",
  "mgmt.notif.sending": "Gönderiliyor...",
  "mgmt.notif.scheduledCreated": "Zamanlı aile bildirimi oluşturuldu ✓",
  "mgmt.notif.sendFailed": "Aile bildirimi gönderilemedi.",
  "mgmt.notif.minOneUser": "En az bir aile üyesi seç.",
  "mgmt.notif.titleRequired": "Başlık ve mesaj boş olamaz.",
  "mgmt.notif.dateRequired": "Zamanlı bildirim için tarih ve saat seç.",
  "mgmt.notif.updateFailed": "Zamanlı bildirim güncellenemedi.",
  "mgmt.notif.cancelFailed": "Zamanlı bildirim iptal edilemedi.",
  "mgmt.notif.history": "🕘 Bildirim Geçmişi",
  "mgmt.notif.historyStatus": "Durum:",
  "mgmt.notif.historySent": "Gönderilen:",
  "mgmt.sys.open": "📢 Tüm Kullanıcılara Duyuru Gönder",
  "mgmt.sys.close": "📢 Tüm Kullanıcılara Duyuruyu Kapat",
  "mgmt.sys.titlePlaceholder": "Örn: Planlı Bakım Duyurusu",
  "mgmt.sys.bodyPlaceholder": "Tüm kullanıcılara gidecek sistem duyurusunu yaz...",
  "mgmt.sys.titlePlaceholderEn": "Ex: Planned Maintenance Announcement",
  "mgmt.sys.bodyPlaceholderEn": "Write the English version of the announcement...",
  "mgmt.sys.templateAutoTranslate": "✅ Hazır şablon seçildi — bu bildirim her kullanıcıya kendi uygulama diline göre (TR/EN) otomatik gönderilecek.",
  "mgmt.sys.fillEnglishHint": "Serbest metin yazıyorsunuz. Uygulamayı İngilizce kullanan kullanıcılara da doğru dilde gitmesi için lütfen İngilizce çevirisini de girin.",
  "mgmt.sys.noEnglishWarning": "⚠️ İngilizce alanlar boş — bu duyuru şu anda yalnızca yukarıdaki dilde (Türkçe) gönderilecek, İngilizce kullanan kullanıcılar da bu metni görecek.",
  "mgmt.sys.langBreakdown": "Dil dağılımı (TR · EN)",
  "mgmt.auto.open": "⚙️ Otomatik Bildirim Kuralları",
  "mgmt.auto.close": "⚙️ Otomatik Bildirim Kurallarını Kapat",
  "mgmt.auto.runNow": "▶️ Otomatik Bildirimleri Şimdi Kontrol Et",
  "mgmt.auto.running": "Kontrol ediliyor...",
  "mgmt.auto.loading": "Yükleniyor...",
  "mgmt.auto.refresh": "Yenile",
  "mgmt.premium.open": "▾ Aç",
  "mgmt.premium.close": "▴ Kapat",
  "mgmt.premium.on": "🟢 Premium sistemi AÇIK",
  "mgmt.premium.off": "🔴 Premium sistemi KAPALI",
  "mgmt.premium.activeDesc": "Kısıtlar aktif — ücretsiz kullanıcılar limitlerle karşılaşır",
  "mgmt.premium.inactiveDesc": "Kısıtlar devre dışı — tüm kullanıcılar sınırsız erişebilir",
  "mgmt.premium.locked": "🔒 Sadece premium",
  "mgmt.premium.open2": "✅ Herkese açık",
  "mgmt.premium.lockedLabel": "Kilitli",
  "mgmt.premium.openLabel": "Açık",
  "mgmt.premium.saveBtn": "💎 Premium Ayarlarını Kaydet",
  "mgmt.premium.saving": "Kaydediliyor...",
  "mgmt.limit.shopping": "Alışveriş öğesi",
  "mgmt.limit.task": "Aktif görev",
  "mgmt.limit.calendar": "Aylık takvim etkinliği",
  "mgmt.limit.finance": "Aylık finans kaydı",
  "mgmt.limit.health": "Sağlık kaydı (kişi)",
  "mgmt.limit.children": "Çocuk profili",
  "mgmt.limit.documents": "Belge sayısı",
  "mgmt.limit.messages": "Chat geçmişi",
  "mgmt.limit.mapPlaces": "Kayıtlı yer",
  "mgmt.limit.members": "Aile üye sayısı",
  "mgmt.limit.userFamilies": "Kullanıcı aile sayısı",
  "mgmt.limit.plusMembers": "Premium Plus toplam üye sınırı",
  "mgmt.limit.mealSuggestion": "Günlük menü önerisi",
  "mgmt.limit.liveLocation": "Harita — Canlı konum",
  "mgmt.limit.locationHistory": "Harita — Konum geçmişi",
  "mgmt.limit.petProfile": "Çocuk — Evcil hayvan",
  "mgmt.limit.weeklyMenu": "NePiş — Haftalık menü",
  "mgmt.limit.multiRoom": "Chat — Çoklu sohbet",
  "mgmt.limit.scheduledNotif": "Bildirim — Zamanlanmış",
  "mgmt.limit.multiFamily": "Genel — Çoklu aile",
  "mgmt.notif.selfAdmin": "Aile yöneticisi kendi Ana Sayfa ve Yönetim erişimini kapatamaz.",
  "mgmt.notif.sysAdminPanel": "Push bildirim sistemi yönetim paneli.",
  "mgmt.notif.familyPanel": "Ailenize özel bildirim gönderebilirsiniz.",
  "mgmt.notif.testBtn": "🧪 Test Bildirimi Gönder",
  "mgmt.notif.testSending": "Gönderiliyor...",
  "mgmt.notif.userSearch": "Ad, e-posta, kullanıcı adı veya telefon ara",
  "mgmt.notif.userTitlePh": "Örn: Takvimini kontrol et",
  "mgmt.notif.userBodyPh": "Gönderilecek mesajı yaz...",
  "mgmt.role.familyMember": "Aile Üyesi",
  "mgmt.limit.unit.item": "öğe",
  "mgmt.limit.unit.task": "görev",
  "mgmt.limit.unit.perMonth": "/ay",
  "mgmt.limit.unit.perPerson": "/kişi",
  "mgmt.limit.unit.profile": "profil",
  "mgmt.limit.unit.doc": "belge",
  "mgmt.limit.unit.message": "mesaj",
  "mgmt.limit.unit.place": "yer",
  "mgmt.limit.unit.member": "üye",
  "mgmt.limit.unit.family": "aile",
  "mgmt.limit.unit.perDay": "/gün",


  "mgmt.auto.onlyPending": "Sadece bekleyen kayıt varsa",
  "mgmt.auto.oncePerDay": "Aynı kullanıcıya günde 1 kez",
  "mgmt.auto.dueToday": "Bugün son",
  "mgmt.auto.dueTomorrow": "Yarın son",
  "mgmt.auto.threeDays": "3 gün kala",
  "mgmt.auto.thirtyDays": "30 gün kala",
  "mgmt.auto.tenDays": "10 gün kala",
  "mgmt.auto.fiveDays": "5 gün kala",
  "mgmt.auto.expired": "Süresi doldu",
  "mgmt.auto.medicines": "İlaçlar",
  "mgmt.auto.timepolicy": "Zaman politikası",
  "mgmt.premium.savedOk": "✓ Premium ayarları kaydedildi",
  "mgmt.premium.saveError": "Kayıt hatası",
  "mgmt.premium.defaultsLoaded": "Varsayılan değerler yüklendi. Kaydetmeyi unutma.",
  "mgmt.sched.loadFailed": "Zamanlanmış bildirimler yüklenemedi.",
  "mgmt.sched.updatedOk": "Zamanlanmış bildirim güncellendi ✓",
  "mgmt.sched.updateFailed": "Zamanlanmış bildirim güncellenemedi.",
  "mgmt.sched.cancelledOk": "Zamanlanmış bildirim iptal edildi ✓",
  "mgmt.sched.cancelFailed": "Zamanlanmış bildirim iptal edilemedi.",
  "mgmt.sched.deletedOk": "Zamanlanmış bildirim silindi ✓",
  "mgmt.sched.deleteFailed": "Zamanlanmış bildirim silinemedi.",
  "mgmt.sched.createdOk": "Zamanlı bildirim oluşturuldu ✓",
  "mgmt.sched.createFailed": "Zamanlı bildirim oluşturulamadı.",
  "mgmt.sched.confirmCancel": "Bu zamanlanmış bildirimi iptal etmek istiyor musun?",
  "mgmt.sched.confirmDelete": "Bu zamanlanmış bildirimi tamamen silmek istiyor musun? Bu işlem geri alınamaz.",
  "mgmt.auto.loadFailed": "Otomatik bildirim kuralları yüklenemedi.",
  "mgmt.auto.ruleFailed": "Kural güncellenemedi.",
  "mgmt.auto.optionFailed": "Kural seçeneği güncellenemedi.",
  "mgmt.auto.runFailed": "Otomatik bildirimler çalıştırılamadı.",
  "mgmt.auto.repeatFailed": "Tekrar eden sistem duyurusu güncellenemedi.",
  "mgmt.auto.quietSavedOk": "Genel sessiz saat politikası kaydedildi ✓",
  "mgmt.auto.policyFailed": "Bildirim politikası kaydedilemedi.",
  "mgmt.auto.defaultsOk": "Varsayılan bildirim politikaları yüklendi ✓",
  "mgmt.auto.defaultsFailed": "Varsayılan politikalar kurulamadı.",
  "mgmt.auto.confirmReset": "Tüm bildirim otomasyonu varsayılan saat politikalarına döndürülsün mü?",
  "mgmt.sys.superAdminOnly": "Bu işlem sadece süper admin tarafından yapılabilir.",
  "mgmt.sys.sendFailed": "Sistem duyurusu gönderilemedi.",
  "mgmt.sys.security.title": "Güvenlik Bilgilendirmesi",
  "mgmt.sys.security.desc": "Hesap güvenliğiniz için bilgilerinizi güncel tutmayı ve şifrenizi kimseyle paylaşmamayı unutmayın.",
  "mgmt.notif.adminNotFound": "Yönetici kullanıcı bilgisi bulunamadı.",
  "mgmt.notif.historyFailed": "Bildirim geçmişi yüklenemedi.",
  "mgmt.notif.testTitle": "🧪 Test Bildirimi",
  "mgmt.notif.testDesc": "Aile Yönetimi bildirim sistemi sorunsuz çalışıyor.",
  "mgmt.notif.testOk": "Test bildirimi gönderildi ✓",
  "mgmt.notif.testFailed": "Test bildirimi gönderilemedi.",
  "mgmt.mail.title": "E-posta Sistemi ve Kullanım Analizi",
  "mgmt.mail.desc": "Brevo birincil, Resend yedek gönderim durumunu ve günlük kullanımı izleyin.",
  "mgmt.mail.targetLabel": "Hedef e-posta (boş bırakılırsa kendi adresinize gider)",
  "mgmt.mail.targetPh": "ornek@aileyonetimi.com",
  "mgmt.mail.targetHint": "Test, birincil sağlayıcıyı ve gerektiğinde otomatik yedek geçişini doğrular.",
  "mgmt.mail.testBtn": "📧 Test E-postası Gönder",
  "mgmt.mail.testSending": "Gönderiliyor...",
  "mgmt.mail.testOk": "Test e-postası gönderildi ✓",
  "mgmt.mail.testFailed": "Test e-postası gönderilemedi",
  "mgmt.mail.metricsFailed": "E-posta istatistikleri yüklenemedi.",
  "mgmt.mail.rangeLabel": "İstatistik zaman aralığı",
  "mgmt.mail.today": "Bugün",
  "mgmt.mail.7days": "7 gün",
  "mgmt.mail.30days": "30 gün",
  "mgmt.mail.refresh": "Yenile",
  "mgmt.mail.sentToday": "Bugün gönderilen",
  "mgmt.mail.rangeTotal": "Seçili dönem toplamı",
  "mgmt.mail.dayUnit": "gün",
  "mgmt.mail.activeProvider": "Etkin sağlayıcı",
  "mgmt.mail.gatewayHealthy": "Birincil geçit sağlıklı",
  "mgmt.mail.circuitOpen": "Brevo geçici olarak devre dışı; yedek aktif",
  "mgmt.mail.remaining": "güvenli kapasite",
  "mgmt.mail.fallback": "Yedek geçiş",
  "mgmt.mail.failed": "Başarısız",
  "mgmt.mail.failedAttempts": "Başarısız sağlayıcı denemesi",
  "mgmt.mail.undeliveredShort": "nihai teslim edilemedi",
  "mgmt.mail.chartTitle": "Sağlayıcı teslimat dağılımı",
  "mgmt.mail.chartHint": "Seçilen dönemde kabul edilen e-postalar",
  "mgmt.mail.accepted": "kabul edildi",
  "mgmt.mail.failureHeading": "Başarısız denemelerin açıklaması",
  "mgmt.mail.failureHint": "Bu sayı kaybolan kullanıcı e-postası değildir. Birincil sağlayıcı reddedip yedek sağlayıcı teslim ettiğinde başarısız deneme ve kurtarılan teslimat birlikte sayılır.",
  "mgmt.mail.recovered": "yedek sağlayıcıyla teslim edildi",
  "mgmt.mail.undelivered": "hiçbir sağlayıcıya teslim ettirilemedi",
  "mgmt.mail.categoryPerformance": "Performans alarmı",
  "mgmt.mail.categoryPasswordReset": "Parola sıfırlama",
  "mgmt.mail.categoryVerification": "E-posta doğrulama",
  "mgmt.mail.categoryAdminTest": "Yönetici testi",
  "mgmt.mail.categorySystem": "Sistem e-postası",
  "mgmt.mail.testHeading": "Uçtan uca gönderim testi",
  "mgmt.notif.userFamilyNotFound": "Kullanıcı veya aile bilgisi bulunamadı.",
  "mgmt.notif.familyAnnouncementTitle": "👨‍👩‍👧‍👦 Aile Duyurusu",
  "mgmt.notif.familyAnnouncementBody": "Aileniz için yeni bir bilgilendirme var. Lütfen uygulamayı kontrol edin.",
  "mgmt.notif.copiedToForm": "Son bildirim forma aktarıldı. Tekrar göndermek için Gönder'e bas.",
  "mgmt.notif.sendToSelected": "Seçili {n} Kullanıcıya Gönder",

  "health.lbl.branch": "🏥 Branş",
  "health.lbl.type": "📌 Tip",
  "health.lbl.location": "📍 Konum",
  "health.lbl.date": "🗓️ Tarih",
  "health.lbl.note": "📝 Not",
  "health.lbl.measureType": "🩺 Tip",
  "health.lbl.value": "📊 Değer",
  "health.lbl.context": "🍽️ Durum",
  "health.lbl.allergyType": "🏷️ Tür",
  "health.lbl.severity": "⚠️ Şiddet",
  "health.lbl.symptoms": "🤒 Belirti",
  "health.lbl.action": "✅ Yapılacak",
  "health.lbl.avoid": "🚫 Kaçın",
  "health.lbl.diagnosisDate": "📅 Tanı",
  "health.lbl.doctor": "👨‍⚕️ Doktor",
  "health.lbl.followUp": "🔁 Takip",
  "health.lbl.medicines": "💊 İlaçlar",
  "health.lbl.blood": "🩸 Kan",
  "health.lbl.person": "👤 Kişi",
  "health.lbl.relation": "👨‍👩‍👧 Yakınlık",
  "health.lbl.phone": "📞 Telefon",
  "health.lbl.allergy": "⚠️ Alerji",
  "health.lbl.condition": "🫀 Hastalık",
  "health.lbl.medicine": "💊 İlaç",
  "health.lbl.category": "🏷️ Kategori",
  "health.lbl.reportType": "📄 Tip",
  "health.lbl.institution": "🏥 Kurum",
  "health.lbl.summary": "📌 Özet",
  "health.prof.height": "Boy",
  "health.prof.weight": "Kilo",
  "health.prof.chronicDiseases": "Kronik Hastalıklar",
  "health.prof.regularMedicines": "Sürekli Kullanılan İlaçlar",
  "health.prof.surgeries": "Geçirilmiş Ameliyatlar",
  "health.prof.specialCondition": "Engellilik / Özel Durum",
  "health.prof.smokingAlcohol": "Sigara / Alkol Durumu",
  "health.prof.familyDoctor": "Aile Hekimi / Doktor",
  "health.prof.preferredHospital": "Hastane Tercihi",
  "health.prof.emergencyPerson": "Acil Durum Kişisi",
  "health.prof.emergencyRelation": "Yakınlık Derecesi",
  "health.prof.emergencyPhone": "Acil Telefon",
  "health.prof.notes": "Notlar",
  "health.noAge": "Yaş yok",
  "health.userFallback": "Kullanıcı",
  "health.saveFailed": "Sağlık bilgisi kaydedilemedi.",
  "health.noPermission": "Bu sağlık kartına kayıt ekleme yetkin yok.",
  "health.invalidMedTime": "En az bir geçerli ilaç saati gir. Örn: 08:00, 20:00",
  "health.placeholder.allergy": "Alerji adı seç veya yaz",
  "health.placeholder.condition": "Kronik hastalık seç veya yaz",
  "health.placeholder.vaccine": "Aşı adı seç veya yaz",

  "profile.tab.info": "Bilgiler",
  "profile.tab.edit": "Düzenle",
  "profile.tab.password": "Şifre",
  "profile.fullName": "Ad Soyad",
  "profile.username": "Kullanıcı Adı",
  "profile.email": "E-posta",
  "profile.nameRequired": "Ad ve soyad boş olamaz.",
  "profile.updatedOk": "Profil güncellendi ✓",
  "profile.updateFailed": "Güncelleme başarısız.",
  "profile.fillAll": "Tüm alanları doldur.",
  "profile.passwordMinChars": "Yeni şifre 8-128 karakter arasında olmalı.",
  "profile.passwordMismatch": "Şifreler eşleşmiyor.",
  "profile.passwordUpdatedOk": "Şifre güncellendi ✓",
  "settings.family.copied": "Aile davet bilgisi kopyalandı.",
  "settings.notifications.saveFailed": "Bildirim ayarı kaydedilemedi.",
  "settings.notifications.pushActivated": "Push bildirimleri aktif! ✓",
  "settings.notifications.permissionDenied": "Bildirim izni kapalı. Tekrar açmak için düğmeye yeniden dokunun.",
  "settings.notifications.openSystemSettings": "Bildirim iznini açmak için sistem ayarları açıldı.",
  "notification.permissionOn": "Bildirim izni açık",
  "notification.permissionOff": "Bildirim izni kapalı",
  "notification.permissionAction": "İzin ver",
  "settings.notifications.savedOk": "Bildirim ayarları kaydedildi ✓",
  "home.managePlans": "Planlarını yönet",
  "home.familyHealth": "Aile sağlık kartları",
  "home.mapSub": "Konumlar ve ortak yerler",
  "home.childrenSub": "Gelişim, eğitim ve rutinler",
  "home.cookingSub": "Menü önerisi",
  "home.family": "Ailem",
  "home.familyMembers": "aile üyesi",
  "home.managementSub": "Kullanıcı Yönetimi / Aile Bildirimleri",
  "home.newMessages": "Yeni Mesaj",
  "home.unreadMessages": "Okunmamış Mesaj",
  "children.nameRequired": "Profil adı boş bırakılamaz.",
  "children.newborn": "Yeni doğan",
  "children.monthsOld": "aylık",
  "children.yearsOld": "yaş",
  "children.months": "ay",
  "children.placeholder.chronic": "Kronik durum / hastalıklar",
  "children.placeholder.medicines": "Düzenli ilaçlar",
  "children.placeholder.milestone": "Gelişim dönüm noktası",
  "children.placeholder.education": "Kayıt türü: ödev, sınav...",
  "documents.nameRequired": "Belge adı boş olamaz.",
  "documents.fileRequired": "Dosya seçilmedi.",
  "documents.uploadFailed": "Yükleme başarısız",
  "chat.premium.history": "Sohbet geçmişi",
  "chat.premium.historyFull": "Geçmiş sohbetleri tam görüntüleme",
  "chat.premium.mediaHistory": "Sohbet içi medya ve dosya geçmişi",

  "finance.confirmDelete": "Bu kaydı silmek istediğine emin misin?",
  "finance.savings.reminderTitle": "💰 Birikim Hatırlatması",
  "finance.alert.highExpense": "Bu ay giderler gelirin %85'ini geçti. Harcamaları kontrol etmek iyi olur.",
  "finance.alert.insufficientData": "Bu dönem finans dengesi için yeterli veri oluşmaya başladı.",
  "health.confirmDelete": "Bu sağlık kaydı silinsin mi?",
  "health.defaultReport": "Sağlık raporu",
  "health.notifLoading": "Bildirim açılıyor...",
  "health.notifOpen": "🔔 Sağlık Bildirimlerini Aç",
  "health.vaultDoc": "Belge Kasası sağlık belgesi",
  "health.critical": "kritik kayıt",
  "common.edit": "Düzenle",
  "children.confirmDelete": "Bu kayıt silinsin mi?",
  "children.memoryPhoto": "Anı fotoğrafı",
  "children.memory": "Anı",
  "documents.lbl.category": "📁 Kategori",
  "documents.lbl.owner": "👤 Sahibi",
  "documents.lbl.uploader": "📤 Yükleyen",
  "documents.lbl.added": "🗓️ Eklenme",
  "documents.lbl.expiry": "⏰ Geçerlilik",
  "documents.upload": "Yükle",
  "documents.premium.storageLimit": "Belge depolama MB sınırı",
  "documents.premium.b1": "Daha yüksek belge depolama alanı",
  "documents.premium.b2": "Büyük dosya yükleme",
  "documents.premium.b3": "Tüm aile belgelerini tek yerde saklama",
  "documents.premium.b4": "Belge versiyonlarını sınırsız saklama",
  "chat.selectMembers": "Üyeleri Seç",
  "chat.roomMembers": "Sohbet Odası Üyeleri",
  "chat.removeMember": "Üye çıkar",

  /* ── Cooking page extended ── */
  "cooking.title": "Bugün Ne Pişirsem?",
  "cooking.sub": "Akşam yemeği için sana özel öneri",
  "cooking.empty": "Menü Oluştur'a bas,\nsana bir öneri sunayım!",
  "cooking.loading": "Menü hazırlanıyor…",
  "cooking.main": "Ana Yemek",
  "cooking.soup": "Çorba",
  "cooking.salad": "Salata / Meze",
  "cooking.tapRecipe": "Tarifi görmek için dokun",
  "cooking.like": "Beğendim",
  "cooking.dislike": "Beğenmedim",
  "cooking.savedLike": "✓ Kaydedildi! Afiyet olsun 🎉",
  "cooking.savedDislike": "✓ Kaydedildi. Bir dahaki sefere daha az önerilir.",
  "cooking.create": "Menü Oluştur",
  "cooking.another": "Başka Öneri Getir",
  "cooking.liked": "beğenilen",
  "cooking.dislikedMenu": "beğenilmeyen menü",
  "cooking.ingredients": "Malzemeler",
  "cooking.steps": "Yapılışı",
  "cooking.prepTime": "Hazırlık",
  "cooking.cookTime": "Pişirme",
  "cooking.totalTime": "Toplam",
  "cooking.difficulty": "Zorluk",
  "cooking.difficulty.easy": "Kolay",
  "cooking.difficulty.medium": "Orta",
  "cooking.difficulty.hard": "İleri",
  "cooking.tips": "Püf Noktaları",
  "cooking.substitutions": "Alternatifler",
  "cooking.foodSafety": "Güvenli Pişirme",
  "cooking.storage": "Saklama ve Isıtma",
  "cooking.allergens": "Alerjen Bilgisi",
  "cooking.noDeclaredAllergens": "Tarifte belirtilen yaygın bir alerjen bulunmuyor. Ürün etiketlerini yine de kontrol edin.",
  "cooking.recipeMissing": "Bu tarif için bilgi hazırlanamadı.",
  "cooking.closeRecipe": "Tarifi kapat",
  "cooking.openRecipe": "tarifini aç",
  "cooking.dailySuggestions": "Günlük öneriler",
  "cooking.curatedMenus": "özenle eşleştirilmiş menü",
  "cooking.cultureMatched": "Damak tadına uygun",
  "cooking.catalogAria": "Menü kataloğu bilgisi",
  "cooking.threeCourse": "3 çeşit akşam menüsü",
  "cooking.source.daily": "Günün menüsü",
  "cooking.source.suggestion": "Yeni öneri",
  "cooking.source.liked": "Beğendiğin menü",
  "cooking.source.recent": "Son menülerden",
  "cooking.source.planned": "Haftalık plandan",
  "cooking.backToDaily": "Günün menüsüne dön",
  "cooking.yourTaste": "Senin damak tadın",
  "cooking.likedMenus": "Beğendiğin menüler",
  "cooking.pickAgain": "Yeniden keşfet",
  "cooking.recentMenus": "Son görüntülenenler",
  "cooking.openMenu": "menüyü görüntüle",
  "cooking.smartFilters": "Akıllı menü filtreleri",
  "cooking.filtersHint": "Süre, zorluk ve damak tadına göre kişiselleştir",
  "cooking.filtersActive": "Yeni öneriler aktif tercihlerine göre hazırlanacak",
  "cooking.filter.mainType": "Menü tercihi",
  "cooking.filter.maxTime": "En fazla süre",
  "cooking.filter.difficulty": "Zorluk seviyesi",
  "cooking.filter.all": "Tümü",
  "cooking.filter.minutes": "{{count}} dk",
  "cooking.filter.type.all": "Tüm menüler",
  "cooking.filter.type.meat": "Etli",
  "cooking.filter.type.chicken": "Tavuklu",
  "cooking.filter.type.fish": "Balıklı",
  "cooking.filter.type.vegetarian": "Etsiz",
  "cooking.filter.seasonal": "Mevsime uygun öner",
  "cooking.filter.seasonalHint": "Mevsimlik yemekleri öne çıkarır, dört mevsimlik menüleri korur",
  "cooking.filter.allergens": "İçermesin istediğin alerjenler",
  "cooking.filter.excludeIngredients": "İstemediğin malzemeler",
  "cooking.filter.excludePlaceholder": "Örn. mantar, kereviz, sarımsak",
  "cooking.filter.noMatch": "Bu tercihlerle eşleşen menü bulunamadı. Bir filtreyi kaldırabilirsin.",
  "cooking.filter.matchCount": "{{count}} uygun menü hazır",
  "cooking.filter.reset": "Filtreleri sıfırla",
  "cooking.weeklyPlan": "Haftalık yemek planı",
  "cooking.weeklyPlanHint": "Beğendiğin menüleri haftanın günlerine yerleştir",
  "cooking.weeklyPlanPremiumDesc": "Akşam yemeklerini haftanın günlerine önceden yerleştir ve ne pişireceğini planla.",
  "cooking.weeklyBenefit1": "7 günlük yemek planı",
  "cooking.weeklyBenefit2": "Menüleri tek dokunuşla günlere yerleştirme",
  "cooking.weeklyBenefit3": "Planlanan tariflere hızlı erişim",
  "cooking.weeklyBenefit4": "Alışveriş listesiyle birlikte kullanım",
  "cooking.selectedDay": "Seçili gün",
  "cooking.dayNotPlanned": "Bu gün için henüz menü seçilmedi",
  "cooking.planCurrentMenu": "Bu menüyü planla",
  "cooking.clearPlannedDay": "Seçili günün menüsünü kaldır",
  "cooking.servingUnit": "kişilik",
  "cooking.servingSize": "Porsiyon sayısı",
  "cooking.decreaseServing": "Porsiyonu azalt",
  "cooking.increaseServing": "Porsiyonu artır",
  "cooking.addIngredientsShopping": "Malzemeleri alışverişe aktar",
  "cooking.chooseMissingIngredients": "Evde olmayanları seçip aile listesine ekle",
  "cooking.selectedIngredients": "{{count}} malzeme seçildi",
  "cooking.selectAll": "Tümünü seç",
  "cooking.clearSelection": "Temizle",
  "cooking.addSelectedShopping": "{{count}} malzemeyi listeye ekle",
  "cooking.addingShopping": "Alışveriş listesine ekleniyor…",
  "cooking.shoppingAdded": "{{count}} malzeme alışveriş listesine eklendi.",
  "cooking.openShoppingList": "Listeyi aç",
  "cooking.shoppingAddFailed": "Malzemeler eklenemedi. Lütfen tekrar dene.",
  "cooking.premium.b1": "Sınırsız günlük menü önerisi",
  "cooking.premium.b2": "Haftalık menü planı",
  "cooking.premium.b3": "Beğeni bazlı kişiselleştirme",
  "cooking.premium.b4": "Aile tercihlerine göre öneriler",

  /* ── Shared component labels ── */
  "common.showLess": "Daha az",
  "common.showMore": "Devamı",
  "common.showAll": "Tamamını göster",
  "common.now": "Şimdi",
  "footer.title": "Aile Takip Uygulamanız © 2026",
  "footer.dev": "Sercan YAVUZ tarafından geliştirilmektedir.",
  "finance.summaryTitle": "Genel Finans Durumu",
  "finance.privacy.show": "Tutarları göster",
  "finance.privacy.hide": "Tutarları gizle",
  "finance.netBalancePeriod": "Bu dönem net bakiye",
  "finance.balanced": "Dengede",
  "finance.deficit": "Açık Var",
  "finance.transaction": "İşlem",
  "notif.type.chat": "Sohbet",
  "notif.type.task": "Görev",
  "notif.type.reminder": "Hatırlatma",
  "notif.type.shopping": "Alışveriş",
  "notif.type.calendar": "Takvim",
  "notif.type.finance": "Finans",
  "notif.type.expense": "Harcama",
  "notif.type.document": "Belge",
  "notif.type.health": "Sağlık",
  "notif.type.medicine": "İlaç",
  "notif.type.appointment": "Randevu",
  "notif.type.birthday": "Doğum Günü",
  "notif.type.location": "Konum",
  "notif.type.family": "Aile",
  "notif.type.familyStatus": "Aile Durumu",
  "notif.type.system": "Sistem",
  "notif.type.scheduled": "Zamanlı",
  "notif.type.assistant": "Aile Asistanı",
  "notif.type.children": "Çocuk Takibi",
  "notif.type.default": "Bildirim",

  /* ── Premium Limits ── */
  "premium.limitReached": "{{label}} doldu",
  "premium.limitDescGeneric": "Ücretsiz planda en fazla {{max}} {{label}} kullanabilirsin",
  "premium.limit.shoppingItems": "Alışveriş öğeleri",
  "premium.limit.activeTasks": "Aktif görevler",
  "premium.limit.documents": "Belgeler",
  "premium.limit.financeRecords": "Finans kayıtları",
  "premium.benefit.multiFamily": "Birden fazla aile grubu",
  "premium.benefit.separatePlanning": "Her aile için ayrı planlama",
  "premium.benefit.quickSwitch": "Aileler arasında hızlı geçiş",
  "premium.benefit.unlimitedTasks": "Sınırsız aktif görev (ücretsizde 10 limit)",
  "premium.benefit.taskPriority": "Öncelik ve kategori desteği",
  "premium.benefit.taskReminders": "Görev hatırlatıcıları",
  "premium.plus.benefit.shoppingSync": "Tüm aile gruplarında ayrı listeler",
  "premium.plus.benefit.shoppingAssign": "Kişiye özel ürün atama",
  "premium.plus.benefit.shoppingBudget": "10 farklı ailede sınırsız ürün",
  "premium.plus.benefit.taskAssign": "Görev atama ve takibi",
  "premium.plus.benefit.taskRepeat": "10 farklı ailede ayrı görev listeleri",
  "premium.plus.benefit.taskStats": "Ailedeki 3 üye sınırı kalkar",
  "premium.plus.benefit.docsUnlimited": "Sınırsız belge ve depolama",
  "premium.plus.benefit.docsVersioning": "10 farklı ailede ayrı belge klasörleri",
  "premium.plus.benefit.docsTeam": "Sınırsız aile üyesiyle paylaşım",
  "premium.plus.benefit.financeMulti": "Çoklu aile finans takibi",
  "premium.plus.benefit.financeAdvanced": "10 farklı ailede ayrı finans takibi",
  "premium.plus.benefit.financeExport": "Sınırsız aile üyesiyle ortak harcama",
  "premium.benefit.unlimitedShopping": "Sınırsız alışveriş listesi",
  "premium.benefit.shoppingCategories": "Özel alışveriş kategorileri",
  "premium.benefit.shoppingHistory": "Alınan ürün geçmişi",
  "premium.benefit.unlimitedDocuments": "Sınırsız belge yükleme",
  "premium.benefit.personalSharedDocs": "Kişisel ve ortak belgeler",
  "premium.benefit.expiryTracking": "Geçerlilik tarihi takibi",
  "premium.benefit.unlimitedMonthlyRecords": "Sınırsız aylık kayıt",
  "premium.benefit.reportsCharts": "Rapor ve grafikler",
  "premium.benefit.savingsGoals": "Birikim hedefleri",
  "premium.benefit.installmentSubscriptions": "Taksit ve abonelik takibi",

  /* ── Reminder Panel ── */
  "reminder.set": "Hatırlatma kur",
  "reminder.once": "Bir kez",
  "reminder.daily": "Her gün",
  "reminder.weekly": "Her hafta",
  "reminder.monthly": "Her ay",
  "reminder.date": "Bildirim Tarihi",
  "reminder.time": "Saat",
  "reminder.daysBefore": "Kaç Gün Önce",
  "reminder.sameDay": "Aynı gün",
  "reminden.sameDay": "Aynı gün",
  "reminder.daysBeforeSuffix": "gün önce",
  "reminder.willSend": "Bildirim gönderilecek",
  "reminder.needReferenceDate": "Hatırlatma tarihi hesaplamak için önce son ödeme / yenileme tarihini girin.",
  "reminder.invalid.missingDate": "Hatırlatma için tarih seçmelisin.",
  "reminder.invalid.pastDate": "Hatırlatma geçmiş tarih veya saate kurulamaz. Lütfen ileri bir tarih ve saat seç.",
  "reminder.invalid.general": "Hatırlatma oluşturulamadı. Lütfen geçerli bir ileri tarih ve saat seç.",
  "reminder.repeat": "Tekrar",

  /* ── Auth Animation Scene ── */
  "auth.scene.calendar": "Aile Takvimi",
  "auth.scene.calendarDesc": "Tüm planlar bir arada",
  "auth.scene.tasks": "Görev Paylaşımı",
  "auth.scene.tasksDesc": "Birlikte tamamlayın",
  "auth.scene.finance": "Finans Takibi",
  "auth.scene.financeDesc": "Bütçenizi yönetin",
  "auth.scene.documents": "Aile Belgeleri",
  "auth.scene.documentsDesc": "Güvenli saklayın",
  "auth.scene.shopping": "Alışveriş",
  "auth.scene.shoppingDesc": "Liste hazırlayın",
  "auth.scene.expenses": "Ortak Harcama",
  "auth.scene.expensesDesc": "Hakkaniyetli paylaşım",

  /* ── Final App / Family Keys ── */
  "app.loadingSession": "Oturumun kontrol ediliyor.",
  "app.loadingFamily": "Aile bilgilerin kontrol ediliyor.",
  "family.noneTitle": "Aile alanını birlikte kuralım",
  "family.noneDesc": "Devam etmek için kendi aile grubunu oluştur veya ailenden aldığın davet koduyla mevcut gruba katıl.",
  "family.setupEyebrow": "Hesabın hazır · Son bir adım kaldı",
  "family.setupProgressLabel": "Aile kurulum adımları",
  "family.setupStepChoose": "Yolunu seç",
  "family.setupStepComplete": "Bilgileri tamamla",
  "family.setupChooseLabel": "Aile kurulum seçenekleri",
  "family.createOptionBadge": "Yeni bir grup",
  "family.createOptionTitle": "Kendi ailemi oluşturacağım",
  "family.createOptionDesc": "Ailene bir ad ver; ardından üyeleri güvenli davet koduyla ekle.",
  "family.createOptionAction": "Aile adı yazarak başla",
  "family.joinOptionBadge": "Davetim var",
  "family.joinOptionTitle": "Mevcut aileme katılacağım",
  "family.joinOptionDesc": "Aile yöneticinin gönderdiği FP ile başlayan davet kodunu kullan.",
  "family.joinOptionAction": "Davet kodunu gir",
  "family.createFormDesc": "Aile üyelerinin kolayca tanıyacağı kısa bir ad belirle.",
  "family.nameLabel": "Aile adı",
  "family.nameHelp": "Örneğin: Yavuz Ailesi, Bizim Ev veya Demir Ailesi",
  "family.inviteCodeLabel": "Aile davet kodu",
  "family.inviteCodeHelp": "Kodu aile grubunu oluşturan kişiden isteyebilirsin.",
  "family.wrongAccountHint": "Yanlış hesapla mı giriş yaptın?",
  "family.noFamilyDeleteTitle": "Hesabını kapatmak ister misin?",
  "family.noFamilyDeleteDesc": "Artık bağlı olduğun bir aile grubu yok. İstersen hesabını ve sana ait kişisel verileri kalıcı olarak silebilirsin.",
  "family.noFamilyDeleteFinalWarning": "Hesabınız kalıcı olarak silinecek. Profiliniz anonimleştirilecek, oturumlarınız kapatılacak ve size ait kişisel veriler temizlenecektir. Bu işlem geri alınamaz.",
  "accountDeletionSurvey.title": "Hesabını neden silmek istiyorsun?",
  "accountDeletionSurvey.required": "Devam etmek için en az bir neden seçmelisiniz.",
  "accountDeletionSurvey.maxReasons": "En fazla 5 neden seçebilirsiniz.",
  "accountDeletionSurvey.otherRequired": "Diğer neden için kısa bir açıklama yazın.",
  "accountDeletionSurvey.otherPlaceholder": "Kısaca nedenini yaz",
  "accountDeletionSurvey.continue": "Devam Et",
  "accountDeletionSurvey.reason.setup_unclear": "Aile oluşturma sürecini anlayamadım",
  "accountDeletionSurvey.reason.expected_something_else": "Uygulamadan farklı bir şey bekliyordum",
  "accountDeletionSurvey.reason.no_family_invite": "Mevcut aileme katılmak için davet kodum yok",
  "accountDeletionSurvey.reason.privacy_concern": "Gizlilik veya veri güvenliği konusunda endişeliyim",
  "accountDeletionSurvey.reason.too_many_steps": "Kurulum süreci uzun veya karmaşık geldi",
  "accountDeletionSurvey.reason.technical_problem": "Teknik bir sorun yaşadım",
  "accountDeletionSurvey.reason.missing_feature": "Aradığım özellik uygulamada yok",
  "accountDeletionSurvey.reason.just_testing": "Uygulamayı yalnızca denemek için kayıt oldum",
  "accountDeletionSurvey.reason.not_ready": "Şu anda kullanmaya hazır değilim",
  "accountDeletionSurvey.reason.other": "Diğer",
  "accountDeletionSurvey.reason.prefer_not_to_say": "Neden belirtmek istemiyorum",
  "family.create": "Aile Oluştur",
  "family.joinByCode": "Davet Koduyla Aileye Katıl",
  "family.createNew": "Yeni Aile Oluştur",
  "family.suggestedName": "{{surname}} AİLESİ",
  "family.placeholderName": "Örn: Yavuz Ailesi",
  "family.createButton": "Aileyi Oluştur",
  "family.join": "Aileye Katıl",
  "family.placeholderCode": "FP-XXXXXXX",
  "family.joinButton": "Katıl",
  "family.welcome": "Hoş geldin 🎉",
  "family.welcomePopup.title": "Hoş Geldin! 🎉",
  "family.welcomePopup.titleCreated": "Aileni Kurdun! 🎉",
  "family.welcomePopup.subtitle": "{{familyName}} artık senin ailen.",
  "family.welcomePopup.feature1": "Çocuklarınızın okul, ev ve belirlediğiniz önemli yerlere varış ve ayrılışlarını takip edin; anlık bildirimlerle haberdar olun.",
  "family.welcomePopup.feature2": "Çocuğunuzun ve bebeğinizin gelişimini düzenli olarak kaydedin; büyüme sürecini ve önemli gelişim adımlarını sürekli takip edin.",
  "family.welcomePopup.feature3": "Gelir, gider, birikim, taksit, abonelik ve faturalarınızı tek yerden düzenli ve kolayca takip edin.",
  "family.welcomePopup.feature4": "Aile Asistanı, aile verilerinizi takip eder; öncelikleri fark ederek önemli konularda sizi bilgilendirir ve öneriler sunar.",
  "family.welcomePopup.feature5": "Kişisel ve ortak aile belgelerinizi takip edin; süresi yaklaşan veya dolan belgeler için zamanında bildirim alın.",
  "family.welcomePopup.feature6": "Rastgele günlük menüler oluşturun, yeni fikirler keşfedin ve “Bugün ne pişirsem?” derdinden kurtulun.",
  "family.welcomePopup.feature7": "Ortak alışveriş listenizi birlikte yönetin; listeyi kamerayla tarayıp ürünleri hızlıca ekleyin ve alınanları anında takip edin.",
  "family.welcomePopup.feature8": "Ortak harcamalarınızı kolayca takip edin; fişi kamerayla tarayıp harcamaları hızla kaydedin, kim ödedi kim borçlu net görün.",
  "family.welcomePopup.cta": "Harika, Başlayalım!",
  "tour.ariaLabel": 'Uygulama rehberi',
  "tour.step": 'Adım {{current}} / {{total}}',
  "tour.skip": 'Geç',
  "tour.back": 'Geri',
  "tour.next": 'İleri',
  "tour.finish": 'Rehberi Bitir',
  "tour.profile.title": 'Profilin burada',
  "tour.profile.text": 'Kişisel bilgilerini ve avatarını düzenleyebilir, şifreni değiştirebilir ve hesabından güvenle çıkış yapabilirsin.',
  "tour.family.title": 'Ailelerini buradan yönet',
  "tour.family.text": 'Aileler arasında geçiş yapabilir, yeni bir aile oluşturabilir veya davet koduyla başka bir aileye katılabilirsin.',
  "tour.notifications.title": 'Tüm bildirimlerin tek yerde',
  "tour.notifications.text": 'Görev, takvim, sohbet, alışveriş, konum ve diğer aile aktivitelerinden gelen bildirimleri buradan takip edebilirsin.',
  "tour.settings.title": 'Uygulamayı kendine göre ayarla',
  "tour.settings.text": 'Tema, dil ve varsayılan açılış sayfasını seçebilir; bildirimleri ve sessiz saatleri düzenleyebilirsin. Aile ayarları, gizlilik işlemleri, yasal belgeler, veri indirme, konum geçmişi ve hesap işlemleri de burada bulunur.',
  "tour.summary.title": 'Ailenin güncel özeti',
  "tour.summary.text": 'Bu kartlar yaklaşan işleri, önemli sayıları ve Aile Asistanı özetlerini hızlıca görmeni sağlar. Kartları kaydırarak diğer özetlere geçebilirsin.',
  "tour.quickStats.title": 'Hızlı durum bilgileri',
  "tour.quickStats.text": 'Alışveriş durumlarını tek bakışta görür, ürün, bekleyen ve alınan sayılarına dokunarak ilgili alana doğrudan geçebilirsin.',
  "tour.familyStatus.title": 'Ailenin durumunu tek bakışta gör',
  "tour.familyStatus.text": 'En az iki üyeli ailelerde Evdeyim, Yoldayım ve Güvendeyim gibi güncel durumları burada görürsün. Kendi kartına dokunarak durumunu paylaşabilir; başka bir üyeye dokunarak ayrıntıları görebilir veya durum güncellemesi isteyebilirsin. Bu kartı Ayarlar > Aile bölümünden açıp kapatabilirsin.',
  "tour.modules.title": 'Aileniz için tüm araçlar',
  "tour.modules.text": 'Alışveriş, Takvim, Finans, Görevler, Harcamalar, Sağlık Verileri, Aile Haritası, Çocuk ve Bebek Takibi, Aile Sohbeti, Belgeler, Bugün Ne Pişirsem?, Ailem, Aile Aktivite Akışı, Yönetim ve Aile Asistanı gibi yetkine açık bölümlere ana sayfadaki kartlardan ulaşabilirsin.',
  "tour.gestures.title": "Hızlı hareketleri keşfet",
  "tour.gestures.intro": "Uygulamada daha hızlı hareket etmek için iki pratik kaydırma hareketini kullanabilirsin.",
  "tour.gestures.ariaLabel": 'Hızlı hareketler',
  "tour.gestures.back.title": 'Hızlı geri dön',
  "tour.gestures.back.text": 'Alt sayfalarda sol kenardan sağa kaydır.',
  "tour.gestures.menu.title": 'Yan menüyü aç',
  "tour.gestures.menu.text": 'Sağ kenardan sola kaydır.',
  "tour.done.title": 'Her şey hazır! 🎉',
  "tour.done.text": 'Artık Aile Yönetimi’ni kullanmaya hazırsın. Günlük planlarını ekleyebilir, aileni davet edebilir ve tüm özellikleri keşfetmeye başlayabilirsin.',
  "reminders.dailyTitle": "Günlük Hatırlatıcılar",

  /* ── Final i18n completion keys ── */
  "auth.error.requiredFields": "Lütfen tüm alanları doldurun.",
  "auth.error.loginFailed": "Giriş yapılamadı. Bilgilerinizi kontrol edip tekrar deneyin.",
  "auth.error.phoneFormat": "Telefon 05555555555 formatında olmalı.",
  "auth.error.usernameTaken": "Bu kullanıcı adı kullanılıyor.",
  "auth.error.emailTaken": "Bu e-posta adresi zaten kayıtlı.",
  "auth.error.phoneTaken": "Bu telefon kullanılıyor.",
  "auth.info.verificationSent": "Doğrulama maili gönderildi. Lütfen e-posta kutunu kontrol et.",
  "auth.error.userNotFound": "Kayıtlı kullanıcı bulunamadı.",
  "auth.error.loginRequired": "Giriş bilgisi ve şifre boş bırakılamaz.",
  "auth.error.sessionNotFound": "Oturum bulunamadı. Lütfen tekrar giriş yapın.",
  "auth.info.verificationResent": "Doğrulama maili tekrar gönderildi. Gelen kutunu ve spam klasörünü kontrol et.",
  "auth.info.emailVerified": "E-posta doğrulandı. Uygulamaya yönlendiriliyorsun.",
  "auth.error.emailNotVerified": "E-posta henüz doğrulanmamış görünüyor. Linke tıkladıktan sonra tekrar kontrol et.",
  "auth.error.resetInfoRequired": "Şifre sıfırlama için e-posta, kullanıcı adı veya telefon girin.",
  "auth.info.resetSent": "Şifre sıfırlama bağlantısı e-posta adresine gönderildi.",
  "auth.info.registerSuccess": "Kayıt başarılı! Hesabını etkinleştirmek için e-postana gönderdiğimiz doğrulama bağlantısına tıkla.",
  "auth.verifyEmailChecking": "Doğrulanıyor",
  "auth.verifyEmailCheckingSub": "E-posta doğrulama bağlantınız kontrol ediliyor.",
  "auth.verifyEmailSuccessSub": "Artık uygulamaya dönüp devam edebilirsiniz.",
  "auth.verifyEmailInvalidTitle": "Bağlantı geçersiz",
  "auth.verifyEmailLinkInvalid": "Doğrulama bağlantısı geçersiz, kullanılmış veya süresi dolmuş.",
  "family.error.nameRequired": "Aile adı boş bırakılamaz.",
  "family.error.codeRequired": "Davet kodunu girin.",
  "family.joinSuccess": "Artık {{familyName}}'nin bir üyesisin. 👨‍👩‍👧\nAileye hoşgeldin ❤️",
  "family.confirmLeave": "Aile grubundan ayrılmak istediğine emin misin?",
  "family.confirmLeaveOnlyAdminTitle": "Yöneticilik devredilecek",
  "family.confirmLeaveOnlyAdmin": "Bu ailedeki tek yöneticisiniz. Aileden ayrılırsanız yöneticilik başka bir üyeye devredilecek ve aile grubu silinmeden devam edecektir.",
  "family.confirmLeaveOnlyAdminButton": "Devret ve Ayrıl",
  "family.leftAndDeleted": "Aile grubundan ayrıldınız. Son üye olduğunuz için aile ve aileye ait veriler silindi.",
  "family.confirmLeaveLastMemberButton": "Aileyi Sil ve Ayrıl",
  "family.confirmLeaveLastMemberTitle": "Aile kalıcı olarak silinecek",
  "family.confirmLeaveLastMember": "Bu aile grubundaki son üyeysiniz. Aile grubundan ayrılırsanız aile kalıcı olarak silinecek ve bu aileye ait tüm veriler kaldırılacaktır. Bu işlem geri alınamaz.",
  "family.codeCopied": "Aile kodu kopyalandı.",
  "family.permissionsSaved": "Yetkiler kaydedildi.",
  "family.error.ownerRemove": "Aile kurucusu aileden çıkarılamaz.",
  "family.confirmRemove": "{{name}} aileden çıkarılsın mı?",
  "family.error.noUserEmail": "Bu kullanıcının e-postası bulunamadı.",
  "family.passwordResetSentTo": "{{email}} adresine şifre sıfırlama e-postası gönderildi.",
  "chat.newMenuSuggestion": "Yeni menü öner",
  "chat.sharedImageAlt": "Paylaşılan görsel",
  "chat.options": "Seçenekler",
  "chat.me": "Ben",
  "chat.addNewMember": "+ Yeni Üye Ekle",
  "chat.selectPeopleToAdd": "Eklenecek kişileri seç:",
  "chat.adding": "Ekleniyor...",
  "chat.addPeople": "✓ {{count}} Kişi Ekle",
  "chat.manageMembers": "Üyeleri yönet",
  "chat.addMember": "Üye ekle",
  "chat.memberCount": "{{count}} üye",
  "chat.search": "Ara",
  "chat.searchInMessages": "Mesajlarda ara...",
  "chat.pinnedMessage": "Sabitlenmiş mesaj",
  "chat.uploading": "%{{percent}} yükleniyor...",
  "chat.editing": "✏️ Düzenleniyor",
  "chat.media": "📎 Medya",
  "chat.addMedia": "Medya ekle",
  "chat.photo": "Fotoğraf",
  "chat.file": "Dosya",
  "chat.mediaExpired": "Bu medya dosyası 30 günlük saklama süresi dolduğu için kaldırıldı.",
  "chat.mediaRetentionInfo": "Chat fotoğraf, dosya ve belgeler ile ses mesajları 30 gün saklanır. Süresi dolan medya otomatik kaldırılır.",
  "chat.audioRecord": "Ses Kaydı",
  "chat.audioRecordStart": "Kayıt başlatılıyor…",
  "chat.audioRecordCancel": "İptal",
  "chat.audioRecordSend": "Gönder",
  "chat.voiceMessage": "🎤 Ses mesajı",
  "chat.noSendPermission": "Bu sohbette mesaj gönderme yetkiniz yok.",
  "chat.createQa": "{{label}} Oluştur",
  "chat.title": "Başlık",
  "chat.titlePlaceholder": "{{label}} başlığı...",
  "chat.createAndNotify": "✓ Oluştur ve Sohbete Bildir",
  "chat.draftReadWarn": "Sohbet taslağı okunamadı:",
  "chat.draftSaveWarn": "Sohbet taslağı kaydedilemedi:",
  "chat.messageSendError": "Mesaj gönderilemedi:",
  "chat.menuSuggestion": "🍽️ Menü önerisi: {{meal}}",
  "chat.freeHistoryLimit": "Ücretsiz planda bu sohbette sadece son {{limit}} mesaj görüntülenir. Daha eski mesajları görmek için premium gerekir.",
  "management.pageCount": "Sayfa",
  "management.actionCount": "İşlem",
  "management.saveFailed": "Kayıt başarısız.",
  "management.emailNotFound": "E-posta bulunamadı",
  "management.feature.financeReport": "Finans — Rapor & grafik",
  "management.feature.financeSavings": "Finans — Birikim hedefleri",
  "management.feature.financeInstallments": "Finans — Taksit takibi",
  "management.feature.financeSubscriptions": "Finans — Abonelik takibi",
  "management.feature.financeBills": "Finans — Fatura takibi",
  "management.feature.autoNotifications": "Bildirim — Otomatik",
  "mgmt.repeat.once": "Tek Sefer",
  "mgmt.repeat.weekly2": "Haftada Bir",
  "mgmt.notify.emergencyTitle": "Acil Aile Duyurusu",
  "mgmt.notify.calendarTitle": "Takvimini kontrol et",
  "mgmt.notify.documentsTitle": "Belgelerini kontrol et",
  "mgmt.notify.generalTitle": "Yeni duyuru",
  "mgmt.rule.sameDay": "Aynı gün",
  "mgmt.rule.daysBefore": "{{count}} gün önce",
  "mgmt.rule.overdue": "Geciken kayıtlar",
  "mgmt.rule.expired": "Süresi geçmiş kayıtlar",
  "mgmt.rule.weekly": "Haftalık özet",
  "mgmt.error.scheduledDateRequired": "Planlanan tarih/saat boş olamaz.",
  "mgmt.auto.runResult": "Otomatik bildirimler kontrol edildi ✓ Oluşturulan: {{created}}, Push: {{sent}}, Hata: {{failed}}",
  "mgmt.sys.scheduledCreated": "Zamanlı sistem duyurusu oluşturuldu ✓ Hedef kullanıcı: {{count}}",
  "mgmt.sys.sentToUsers": "{{count}} kullanıcıya sistem duyurusu gönderildi ✓",
  "mgmt.sys.deliveryResult": "{{sent}} cihaza push gönderildi · {{inApp}} uygulama içi kayıt · {{failed}} hata",
  "mgmt.sys.pushDeliveryFailed": "Push hiçbir cihaza ulaşmadı. {{count}} uygulama içi kayıt oluşturuldu.",
  "mgmt.user.sentToUsers": "{{count}} kullanıcıya bildirim gönderildi ✓",
  "mgmt.family.sentToMembers": "{{count}} aile üyesine bildirim gönderildi ✓",
  "mgmt.confirm.cancelScheduled": "Bu zamanlı bildirimi iptal etmek istiyor musun?",
  "mgmt.noMessage": "Mesaj yok",
  "mgmt.family.scheduleSelected": "⏰ Seçili {{count}} Üye İçin Zamanla",
  "mgmt.family.sendSelected": "📨 Seçili {{count}} Üyeye Gönder",
  "mgmt.sys.scheduleSelected": "⏰ {{count}} Kullanıcı İçin Zamanla",
  "mgmt.sys.sendSelected": "📢 {{count}} Kullanıcıya Gönder",
  "mgmt.auto.panelClose": "⚙️ Bildirim Otomasyonunu Kapat",
  "mgmt.auto.panelOpen": "⚙️ Bildirim Otomasyonu",
  "service.error.noNotifyUsers": "Bildirim gönderilecek kullanıcı bulunamadı.",
  "service.error.familyLimit": "En fazla 10 aileye üye olabilirsiniz.",
  "service.error.familyCodeNotFound": "Bu koda ait aile bulunamadı.",
  "service.error.alreadyFamilyMember": "Bu ailenin zaten üyesisiniz.",
  "service.error.apiReturned": "API hata döndürdü: {{status}}",
  "service.error.storage": "Depolama hatası: {{status}}",
  "service.error.network": "Ağ hatası",
  "service.error.cancelled": "İptal edildi",
  "service.error.billNotFound": "Fatura kaydı bulunamadı",
  "service.error.userFamilyMissing": "Kullanıcı veya aile bilgisi bulunamadı.",
  "service.error.httpsRequired": "Bildirim için uygulama HTTPS üzerinden açılmalı.",
  "service.error.noServiceWorker": "Bu cihaz Service Worker desteklemiyor.",
  "service.error.noWebPush": "Bu tarayıcı Web Push desteklemiyor.",
  "service.error.noNotification": "Bu tarayıcı bildirim desteklemiyor.",
  "service.error.iosStandalone": "iPhone'da bildirim için uygulamayı Ana Ekran'a eklediğin ikon üzerinden açmalısın.",
  "service.error.permissionDenied": "Bildirim izni verilmedi.",
  "service.error.notificationSettingsUid": "Bildirim ayarları kaydedilemedi. uid eksik.",

  /* ── Service i18n completion keys ── */
  "service.error.familySenderMissing": "Aile veya gönderen bilgisi eksik.",
  "service.error.familyCreatorMissing": "Aile veya oluşturan bilgisi eksik.",
  "service.error.noFamilyMembersToSend": "Gönderilecek aile üyesi bulunamadı. Üye seçimini kontrol et.",
  "service.error.familyIdMissing": "familyId bulunamadı.",
  "service.error.savingNotFound": "Birikim kaydı bulunamadı.",
  "service.error.installmentNotFound": "Taksit kaydı bulunamadı.",
  "service.error.subscriptionNotFound": "Abonelik kaydı bulunamadı.",
  "service.error.vapidInvalid": "VAPID Public Key hatalı. Beklenen uzunluk 65 byte, gelen: {{length}} byte.",

  /* ── Service i18n completion keys ── */
  "service.error.uploadStatus": "Yükleme hatası: {{status}}",
  "service.error.uploadFailed": "Yükleme başarısız.",

  /* ── Final i18n cleanup ── */
  "auth.error.invalidCredentials": "Kullanıcı adı veya şifre hatalı.",
  "auth.error.emailInUse": "Bu e-posta zaten kayıtlı.",
  "auth.error.weakPassword": "Şifre 8-128 karakter arasında olmalı.",
  "auth.error.invalidEmail": "Geçerli e-posta yazın.",
  "common.genericError": "Bir hata oluştu.",
  "common.noDeletePermission": "Bu kaydı silme yetkin yok.",
  "common.categoryAdminOnly": "Kategori ekleme yetkisi sadece aile yöneticisindedir.",
  "premium.feature.familyCreate": "Aile oluşturma",
  "premium.feature.familyJoin": "Aileye katılma",
  "premium.benefit.unlimitedMonthly": "Sınırsız aylık kayıt",
  "premium.benefit.installmentsSubscriptions": "Taksit ve abonelik takibi",
  "notif.shoppingList.title": "🛒 Alışveriş Listesi",
  "notif.shoppingList.added": "{{name}} listeye \"{{item}}\" ekledi",
  "notif.itemBought.title": "🛒 Ürün Alındı",
  "notif.itemBought.body": "\"{{item}}\" alındı olarak işaretlendi",
  "notif.itemBought.by": "{{name}}, \"{{item}}\" ürününü alındı olarak işaretledi",
  "notif.taskAssigned.title": "✅ Yeni Görev Atandı",
  "notif.taskAssigned.body": "\"{{task}}\" görevi sana atandı",
  "notif.taskCompleted.title": "✅ Görev Tamamlandı",
  "notif.taskCompleted.body": "{{name}}, \"{{task}}\" görevini tamamladı",
  "notif.medicineReminder.title": "💊 İlaç Hatırlatıcı",
  "notif.medicineSoon.title": "💊 İlaç Vakti Yaklaşıyor!",
  "notif.medicine1h": "{{medicine}} — 1 saat sonra ({{time}})",
  "notif.medicine5m": "{{medicine}} — 5 dakika sonra ({{time}})",

  /* ── Otomatik bildirim key'leri (backend baslikKey/aciklamaKey olarak kaydeder) ── */
  "notif.auto.shopping.title": "🛒 Alışveriş Hatırlatması",
  "notif.auto.shopping.body": "Alışveriş listesinde bekleyen {{count}} ürün var.",
  "notif.auto.sharedExpense.title": "💸 Harcama Hatırlatması",
  "notif.auto.sharedExpense.body": "Bu ay ortak harcamalarda {{count}} kayıt var. Toplam: {{amount}}.",
  "notif.auto.task.today.title": "🔴 Görev Bugün Son Gün",
  "notif.auto.task.today.body": "\"{{task}}\" görevi bugün tamamlanmalı.",
  "notif.auto.task.tomorrow.title": "🟠 Görev Yarın Son Gün",
  "notif.auto.task.tomorrow.body": "\"{{task}}\" görevinin son tarihi yarın.",
  "notif.auto.task.3days.title": "🟡 Görev Hatırlatıcı",
  "notif.auto.task.3days.body": "\"{{task}}\" görevinin son tarihine 3 gün kaldı.",
  "notif.auto.task.overdue.title": "🔴 Geciken Görev",
  "notif.auto.task.overdue.body": "\"{{task}}\" görevinin son tarihi geçti.",
  "notif.auto.calendar.today.title": "📅 Bugünkü Etkinlik",
  "notif.auto.calendar.tomorrow.title": "📅 Yarınki Etkinlik",
  "notif.auto.calendar.week.title": "📅 Bu Haftaki Etkinlik",
  "notif.auto.calendar.body": "{{event}}{{timeText}}",
  "notif.auto.calendar.timeText": " · Saat: {{time}}",
  "notif.auto.document.reminder.title": "📁 Belge Hatırlatması",
  "notif.auto.document.reminder.body": "\"{{document}}\" için geçerlilik tarihi yaklaşıyor.",
  "notif.auto.document.expired.title": "⛔ Belgenizin Süresi Doldu",
  "notif.auto.document.expired.body": "\"{{document}}\" belgenizin süresi doldu. Lütfen kontrol edin.",
  "notif.auto.document.today.title": "⚠️ Belge Süresi Bugün Doluyor",
  "notif.auto.document.tomorrow.title": "⚠️ Belge Süresi Yarın Doluyor",
  "notif.auto.document.days.title": "📁 Belge İçin {{days}} Gün Kaldı",
  "notif.auto.appointment.today.title": "🏥 Bugünkü Sağlık Randevusu",
  "notif.auto.appointment.tomorrow.title": "🏥 Yarın Sağlık Randevusu",
  "notif.auto.appointment.body": "{{member}} için randevu{{timeText}}",
  "notif.auto.medicine.ending.title": "💊 İlaç Bugün Bitiyor",
  "notif.auto.medicine.ending.body": "\"{{medicine}}\" ilacı bugün bitiyor.",
  "notif.auto.medicine.reminder.title": "💊 İlaç Hatırlatması",
  "notif.auto.medicine.reminder.body": "\"{{medicine}}\" ilacını alma zamanı geldi. Saat: {{time}}",
  "notif.auto.installment.today.title": "🧾 Taksit Ödemesi Bugün",
  "notif.auto.installment.today.body": "\"{{name}}\" taksitinin son ödeme günü bugün.",
  "notif.auto.installment.days.title": "🧾 Taksit Ödeme Hatırlatması",
  "notif.auto.installment.days.body": "\"{{name}}\" taksitinin son ödeme gününe {{days}} gün kaldı.",
  "notif.auto.subscription.today.title": "🔄 Abonelik Ödemesi Bugün",
  "notif.auto.subscription.today.body": "\"{{name}}\" aboneliğinin ödeme günü bugün.",
  "notif.auto.subscription.days.title": "🔄 Abonelik Ödeme Hatırlatması",
  "notif.auto.subscription.days.body": "\"{{name}}\" aboneliğinin ödeme gününe {{days}} gün kaldı.",
  "notif.auto.bill.today.title": "📋 Fatura Son Ödeme Günü",
  "notif.auto.bill.today.body": "\"{{name}}\" faturasının son ödeme günü bugün.",
  "notif.auto.bill.days.title": "📋 Fatura Ödeme Hatırlatması",
  "notif.auto.bill.days.body": "\"{{name}}\" faturasının son ödeme gününe {{days}} gün kaldı.",
  "notif.auto.birthday.title": "🎂 Bugün {{name}}'ın Doğum Günü!",
  "notif.auto.birthday.body": "Aile olarak {{name}}'a doğum günü dileklerinizi iletmeyi unutmayın! 🎉💕",
  "home.reminder.overdue": "{{days}} gün gecikmiş",
  "home.reminder.todayLast": "Bugün son gün!",
  "home.reminder.tomorrowLast": "Yarın son gün",
  "home.reminder.daysLeft": "{{days}} gün kaldı",
  "home.reminder.todayAt": "Bugün saat {{time}}",
  "home.reminder.today": "Bugün",
  "home.reminder.tomorrow": "Yarın",
  "home.reminder.daysLater": "{{days}} gün sonra",
  "home.reminder.birthday": "Doğum günü — {{when}}",
  "home.reminder.medicine": "İlaç",
  "home.reminder.appointment": "Randevu",
  "home.reminder.healthAppointment": "Sağlık randevusu — {{when}}{{timeText}}",
  "auto.shopping.title": "Alışveriş Hatırlatması",
  "auto.shopping.desc": "Alışveriş listesinde bekleyen ürün varsa aile üyelerine hatırlatma gönderir.",
  "auto.task.title": "Görev Son Tarih Hatırlatması",
  "auto.task.desc": "Bugün, yarın ve 3 gün kalan görevleri ilgili kullanıcıya hatırlatır.",
  "auto.calendar.title": "Takvim Etkinlik Hatırlatması",
  "auto.calendar.desc": "Bugünkü, yarınki ve bu haftaki etkinlikleri aile üyelerine bildirir.",
  "auto.document.title": "Belge Son Tarih Hatırlatması",
  "auto.document.desc": "Belge geçerlilik süreleri için 30, 10, 5 gün, yarın, bugün ve süresi doldu uyarıları gönderir.",
  "auto.health.title": "Sağlık / İlaç Hatırlatması",
  "auto.health.desc": "Yaklaşan sağlık randevuları ve ilaç hatırlatmalarını ilgili aile üyesine gönderir.",

  /* ── Chat cleanup ── */
  "chat.taskCreated": "Oluşturulan Görev",
  "chat.shoppingAdded": "Alışveriş Listesine Eklendi",
  "chat.calendarAdded": "Takvime Eklendi",
  "chat.edited": "düzenlendi",
  "chat.reply": "Yanıtla",
  "chat.edit": "Düzenle",
  "chat.addMembersToRoom": "{{room}} sohbetine üye ekle",
  "chat.allMembersAlreadyInRoom": "Tüm aile üyeleri zaten bu sohbette.",
  "chat.addSelectedMembers": "✓ {{count}} Üye Ekle",
  "chat.member": "Üye",
  "chat.deleteRoomConfirm": "Bu sohbet ve tüm mesajlar kalıcı olarak silinecek.",

  /* ── Management cleanup ── */
  "mgmt.description": "Aile üyelerinin sayfa erişimlerini, işlem yetkilerini ve aile bildirimlerinizi buradan yönetebilirsiniz.",
  "mgmt.noMembers": "Aile üyesi bulunamadı",
  "mgmt.permission": "Yetki",
  "mgmt.familyNotify.title": "Aileye Bildirim Gönder",
  "mgmt.familyNotify.desc": "Bu alan sadece kendi aile üyelerinize bildirim göndermek için kullanılır.",
  "mgmt.searchUser": "Kullanıcı Ara",
  "mgmt.selectAllVisibleFamily": "Tüm görünen aile üyelerini seç",
  "mgmt.selectedFamilyCount": "Seçili aile üyesi: {{selected}} / Toplam aile üyesi: {{total}}",
  "mgmt.noFamilySearch": "Aramaya uygun aile üyesi bulunamadı.",
  "mgmt.familyTemplates": "Aileye Yönelik Hazır Mesaj Kartları",
  "mgmt.title": "Başlık",
  "mgmt.sendType": "Gönderim Türü",
  "mgmt.sendTime": "Gönderim Zamanı",
  "mgmt.noFamilyNotif": "Henüz aile bildirimi gönderilmemiş.",
  "mgmt.resend": "Tekrar Gönder",
  "mgmt.noScheduledFamily": "Zamanlı aile bildirimi bulunamadı.",
  "mgmt.cancel": "İptal Et",
  "mgmt.notifManagement": "Bildirim Yönetimi",
  "mgmt.userNotify": "Kullanıcıya Bildirim Gönder",
  "mgmt.selectAllVisibleUsers": "Tüm görünen kullanıcıları seç",
  "mgmt.selectedUserCount": "Seçili kullanıcı: {{selected}} / Toplam kullanıcı: {{total}}",
  "mgmt.onlyFamily": "Bu bildirim sadece kendi aile üyelerinize gönderilir.",
  "mgmt.selectedFamilyOnly": "Seçili aile üyesi: {{count}}",
  "mgmt.templates": "Hazır Mesaj Kartları",
  "mgmt.globalIndependent": "Bu alan kullanıcıya bildirim gönder bölümünden bağımsızdır.",
  "mgmt.totalUsers": "Sistemde kayıtlı toplam kullanıcı: {{count}}",
  "mgmt.systemTemplates": "Hazır Sistem Duyuru Kartları",
  "mgmt.cronInfo": "GitHub cron her saat çalışır; bu panel cronun hangi otomatik bildirimleri çalıştıracağını yönetir.",
  "mgmt.lastRun": "Son çalışma: {{date}}",
  "mgmt.sentError": "Gönderilen: {{sent}} · Hata: {{error}}",
  "mgmt.activeRecords": "{{count}} aktif kayıt",
  "mgmt.noAutomationLog": "Henüz otomatik bildirim çalışma kaydı yok.",
  "mgmt.createdPushError": "Oluşturulan: {{created}} · Push: {{push}} · Hata: {{error}}",
  "mgmt.created": "Oluşturulan: {{created}}",
  "mgmt.pushLabel": "Push",
  "mgmt.errorLabel2": "Hata",
  "mgmt.policyDesc": "Kullanıcıların bildirim tercihlerini bozmadan, sistem bildirimlerinin saatini, gün politikasını, sessiz saatini ve günlük limitini buradan yönetebilirsin.",
  "mgmt.quietStart": "Sessiz saat başlangıcı",
  "mgmt.localTimeHint": "Buradaki saatler her kullanıcının kendi yerel saatine göre uygulanır.",
  "mgmt.quietEnd": "Sessiz saat bitişi",
  "mgmt.cronInterval": "Cron kontrol aralığı",
  "mgmt.resetDefaults": "Varsayılana Dön",
  "mgmt.dailyLimit": "Günlük limit",
  "mgmt.ruleName": "Kural adı",
  "mgmt.daysBefore": "Kaç gün kala",
  "mgmt.deliveryTime": "Gönderim saati",
  "mgmt.deleteRule": "Kuralı Sil",
  "mgmt.addDayRule": "+ Yeni gün kuralı ekle",
  "mgmt.scheduledInfo": "PostgreSQL scheduled_notifications tablosunda bekliyor durumunda olan bildirimleri buradan yönetebilirsin.",
  "mgmt.recurring": "Tekrarlı",
  "mgmt.noScheduledFilter": "Bu filtreye uygun bekleyen zamanlanmış bildirim yok.",
  "mgmt.noHistory": "Bildirim geçmişi bulunamadı.",
  "mgmt.premiumSettings": "Premium Ayarları",
  "mgmt.premiumDesc": "Ücretsiz kullanıcı limitleri ve kilitli özellik yönetimi",
  "mgmt.freeLimits": "Ücretsiz Plan Limitleri",
  "mgmt.freeLimitsDesc": "Ücretsiz kullanıcıların ulaşabileceği maksimum değerler.",
  "mgmt.default": "varsayılan",
  "mgmt.lockedFeatures": "Kilitli Özellikler",
  "mgmt.lockedDesc": "Kilitli = sadece premium kullanıcılar erişebilir.",
  "mgmt.resetPremiumDefaults": "Varsayılan Değerlere Sıfırla",
  "mgmt.limit.geofence": "Harita — Geofence",

  /* ── Chat menu cleanup ── */
  "chat.menuSuggestionTitle": "Menü Önerisi",
  "chat.mainDish": "Ana Yemek",
  "chat.soup": "Çorba",
  "chat.saladMeze": "Salata / Meze",

  /* ── Notification policy cleanup ── */
  "policy.global.title": "Genel Bildirim Politikası",
  "policy.shopping.title": "Alışveriş Hatırlatmaları",
  "policy.shopping.desc": "Alışveriş listesinde alınmamış ürün varsa belirlenen saatte hatırlatır.",
  "policy.shopping.pending": "Bekleyen ürün varsa",
  "policy.task.title": "Görev Hatırlatmaları",
  "policy.task.desc": "Son tarih yaklaşan veya geciken görevleri zaman politikasına göre gönderir.",
  "policy.rule.3days": "3 gün kala",
  "policy.rule.1day": "1 gün kala",
  "policy.rule.today": "Son gün",
  "policy.task.overdue": "Geciken görev",
  "policy.calendar.title": "Takvim Hatırlatmaları",
  "policy.calendar.desc": "Aile etkinliklerini etkinlik günü, 1 gün önce veya hafta özeti olarak hatırlatır.",
  "policy.calendar.today": "Etkinlik günü",
  "policy.calendar.week": "Bu hafta özeti",
  "policy.document.title": "Belge Son Tarihi",
  "policy.document.desc": "Belge geçerlilik tarihine göre kaç gün kala bildirim gideceğini yönetir.",
  "policy.rule.30days": "30 gün kala",
  "policy.rule.10days": "10 gün kala",
  "policy.rule.5days": "5 gün kala",
  "policy.document.today": "Bugün doluyor",
  "policy.document.expired": "Süresi geçti",
  "policy.health.title": "Sağlık ve İlaç",
  "policy.health.desc": "Sağlık randevuları ve ilaç doz hatırlatmalarını yönetir.",
  "policy.health.appt1day": "Randevu 1 gün önce",
  "policy.health.apptToday": "Randevu günü",
  "policy.health.meds": "İlaçlar kendi saatinde",

  "common.saving": "Kaydediliyor...",
  "common.actionFailed": "Kaydedilemedi · Tekrar deneyin",
  "common.processing": "İşleniyor…",
  "common.validation.title": "Zorunlu alanları tamamlayın",
  "common.validation.fillFields": "Doldurulması gereken alanlar:",
  "common.updating": "Güncelleniyor...",
  "profile.newPasswordRepeat": "Yeni şifre tekrar",
  "profile.currentPasswordWrong": "Mevcut şifre yanlış.",
  "profile.passwordUpdateFailed": "Şifre güncellenemedi.",
  "family.tapMemberDetails": "Üyeye dokunarak detaylarına ulaşabilirsin.",
  "family.shareCodeInvite": "Bu kodu paylaşarak yeni üye ekleyebilirsiniz.",
  "family.leaveGroup": "Aile grubundan ayrıl",
  "shopping.product": "Ürün",
  "shopping.bought": "Alınan",
  "common.noneYet": "Henüz yok",
  "finance.topExpense": "En Yoğun Gider",
  "finance.visibleAfterExpense": "Gider girilince görünür",
  "finance.familyExpenses": "Aile Harcamaları",
  "finance.thisMonthSharedTotal": "Bu ay ortak harcama toplamı",
  "finance.health": "Finans Sağlığı",
  "finance.underControl": "Kontrol altında",
  "finance.needsAttention": "Dikkat gerektiriyor",
  "finance.incomeRatio": "Gelir oranı",
  "finance.expenseRatio": "Gider oranı",
  "notify.shoppingListTitle": "🛒 Alışveriş Listesi",
  "notify.shoppingAdded": "{{name}} listeye \"{{item}}\" ekledi",
  "notify.shoppingBulkTitle": "🛒 Liste Güncellendi",
  "notify.shoppingBulkAdded": "{{name}} alışveriş listesini güncelledi: {{count}} yeni ürün eklendi.",
  "notify.receiptBulkTitle": "🧾 Fiş Eklendi",
  "notify.receiptBulkAdded": "{{name}} fişi taradı: {{count}} harcama kalemi eklendi.",
  "notify.shoppingBoughtTitle": "🛒 Ürün Alındı",
  "notify.shoppingBought": "{{name}}, \"{{item}}\" ürününü alındı olarak işaretledi",

  /* ── Otomasyon / hatırlatma ÖZET metinleri (in-app render için) ── */
  "auto.shoppingReminder.single": "{{item}} ürününü almayı unutmayın.",
  "auto.shoppingReminder.multi": "Alışveriş listenizde {{count}} bekleyen ürün var.",
  "auto.taskReminder.singleOverdue": "{{task}} görevinin tarihi geçti.",
  "auto.taskReminder.singleUpcoming": "{{task}} görevini unutmayın.",
  "auto.taskReminder.multiOverdue": "{{count}} geciken göreviniz var.",
  "auto.taskReminder.multiUpcoming": "{{count}} yaklaşan göreviniz var.",
  "auto.taskReminder.multiMixed": "{{overdue}} geciken, {{upcoming}} yaklaşan göreviniz var.",
  "auto.calendarReminder.single": "{{event}} etkinliğini unutmayın.",
  "auto.calendarReminder.multiWeekly": "Bu hafta takviminizde {{count}} etkinlik var.",
  "auto.calendarReminder.multi": "Takviminizde {{count}} yaklaşan etkinlik var.",
  "auto.documentExpiry.single": "{{document}} belgesinin geçerlilik tarihini kontrol edin.",
  "auto.documentExpiry.expired": "{{count}} belgenizin süresi doldu.",
  "auto.documentExpiry.expiring": "{{count}} belgenizin süresi dolmak üzere.",
  "documentExpiry.reminderTitle": "📁 Belge Hatırlatması",
  "auto.healthReminder.single": "{{record}} randevusunu kontrol edin.",
  "auto.healthReminder.multi": "{{count}} sağlık randevunuz var.",
  "auto.healthReminder.medicineSingle": "{{record}} ilacını/sağlık kaydını kontrol edin.",
  "auto.healthReminder.medicineMulti": "Saat {{time}} için {{count}} sağlık/ilaç hatırlatmanız var.",
  "health.reminderTitle": "❤️ Sağlık Hatırlatması",
  "auto.financeReminder.single": "{{record}} için ödeme/bitiş tarihini kontrol edin.",
  "auto.financeReminder.multi": "{{count}} yaklaşan finans ödemeniz var.",
  "finance.reminderTitle": "💰 Finans Hatırlatması",
  "auto.generic.single": "{{record}} hatırlatması var.",
  "auto.generic.multi": "{{count}} hatırlatmanız var.",

  /* ── Harita / konum bildirimleri (in-app render için) ── */
  "auto.push.nearby.bodyVeryClose": "{{member}} sana çok yakın!",
  "auto.push.location.timedBodyMinutes": "{{member}} {{value}} dakika boyunca konumunu paylaşıyor",
  "auto.push.location.timedBodyHours": "{{member}} {{value}} saat boyunca konumunu paylaşıyor",
  "auto.push.geofence.addedBothBody": "\"{{zone}}\" için giriş/çıkış bildirimi eklendi",

  "common.someone": "Bir kullanıcı",
  "notify.taskAssignedTitle": "✅ Yeni Görev Atandı",
  "notify.taskAssigned": "\"{{task}}\" görevi sana atandı",
  "notify.taskCompletedTitle": "✅ Görev Tamamlandı",
  "notify.taskCompleted": "{{name}}, \"{{task}}\" görevini tamamladı",
  "notify.newIncome": "💰 Yeni Gelir",
  "notify.newExpense": "💰 Yeni Gider",
  "notify.documentUploadedTitle": "📁 Yeni Belge Yüklendi",
  "notify.documentUploaded": "{{name}}: {{title}}",
  "notify.expenseReminder.item": "\"{{item}}\" harcamasını unutma!",
  "notify.expenseReminder.default": "Harcama hatırlatman var.",
  "notify.sharedExpenseTitle": "💸 Ortak Harcama",
  "notify.sharedExpenseAdded": "{{name}} bir ortak harcama ekledi: {{title}} ({{amount}})",
  "notify.financeAdded": "{{name}}, \"{{title}}\" eklendi ({{amount}})",
  "notify.healthEventTitle": "❤️ Sağlık Kaydı",
  "notify.healthEventAdded": "{{name}} bir sağlık kaydı ekledi: {{title}}",
  "notify.childRecordTitle": "👶 Çocuk Kaydı",
  "notify.childRecordAdded": "{{name}} bir çocuk kaydı ekledi: {{title}}",
  "notify.chatTitle": "Sohbet",
  "notify.chatTitleIcon": "💬 Sohbet",
  "notify.calendarEventTitle": "📅 Yeni Etkinlik",
  "notify.calendarEventAdded": "{{name}} bir etkinlik ekledi: {{event}}",
  "family.member": "Aile üyesi",
  "calendar.healthAppointment": "Sağlık Randevusu",
  "notification.oneDayBefore": "1 gün önce",
  "calendar.premium.recurringEvents": "Tekrarlayan etkinlikler",
  "calendar.premium.familySync": "Aile takvimi senkronizasyonu",
  "premium.unlimitedAllModules": "Tüm modüllerde sınırsız kullanım",

  /* ── Notification popup i18n completion ── */
  "notification.title": "Bildirimler",
  "notification.empty": "Henüz bildirim yok",
  "notification.markRead": "Okundu işaretle",
  "notification.markUnread": "Okunmadı işaretle",
  "notification.markAllRead": "Tümünü okundu işaretle",
  "notification.markAllReadShort": "Tümünü oku",
  "notification.deleteAll": "Tümünü sil",
  "notification.clearAll": "Tümünü temizle",
  "notification.deleteRead": "Okunmuşları sil",
  "notification.close": "Kapat",
  "notification.stats": "İstatistikler",
  "notification.tab.general": "Genel",
  "notification.tab.chat": "Sohbet",
  "notification.searchPlaceholder": "Bildirimlerde ara…",
  "notification.unread": "Okunmamış",
  "notification.read": "Okunmuş",
  "notification.readRate": "Okunan",
  "notification.star.add": "Yıldızla",
  "notification.star.remove": "Yıldızı kaldır",
  "notification.empty.search": "Sonuç bulunamadı",
  "notification.empty.starred": "Yıldızlı bildirim yok",
  "notification.empty.unread": "Tüm bildirimler okunmuş",
  "notification.empty.searchFor": "\"{{query}}\" için eşleşme yok",
  "notification.action.shopping": "Listeye git",
  "notification.action.task": "Göreve git",
  "notification.action.calendar": "Takvime git",
  "notification.action.finance": "Finansa git",
  "notification.action.sharedExpense": "Harcamaya git",
  "notification.action.health": "Sağlığa git",
  "notification.action.chat": "Sohbete git",
  "notification.action.document": "Belgeye git",
  "notification.action.open": "Bildirimi aç",
  "notification.action.announcement": "Duyuruyu aç",
  "notification.ago.now": "Az önce",
  "notification.ago.minutes": "dk önce",
  "notification.ago.hours": "sa önce",
  "notification.ago.days": "gün önce",

  "notify.installmentReminder.title": "🧾 Taksit Ödeme Hatırlatması",
  "notify.installmentReminder.body": "\"{{name}}\" taksit ödemesi yaklaşıyor!",
  "finance.installment.tomorrowTitle": "🧾 Yarın bir taksit günün var",
  "finance.installment.tomorrowBody": "\"{{name}}\" için yarın {{amount}} ödeme var. Hazır olman için şimdiden haber vereyim 😊",
  "finance.installment.todayTitle": "🧾 Bugünün taksit hatırlatması",
  "finance.installment.todayBody": "\"{{name}}\" taksit ödemen bugün. Ödeyince kafan rahat etsin 😊",
  "finance.subscription.tomorrowTitle": "🔄 Yarın bir abonelik yenileniyor",
  "finance.subscription.tomorrowBody": "\"{{name}}\" yarın {{amount}} karşılığında yenilenecek. Bütçende küçük bir yer ayırmayı unutma 😊",
  "finance.subscription.todayTitle": "🔄 Bugün abonelik yenileme günü",
  "finance.subscription.todayBody": "\"{{name}}\" bugün {{amount}} karşılığında yenileniyor. Bilgin olsun 😊",
  "finance.bill.tomorrowTitle": "📋 Yarın bir faturanın son günü",
  "finance.bill.tomorrowBody": "\"{{name}}\" faturanın {{amount}} tutarındaki ödemesi yarın son gün. Son ana kalmasın diye haber vereyim 😊",
  "finance.bill.todayTitle": "📋 Bugün fatura ödeme günü",
  "finance.bill.todayBody": "\"{{name}}\" faturanın {{amount}} tutarındaki ödemesi bugün son gün. Gözünden kaçmasın 😊",
  "notify.subscriptionReminder.title": "🔄 Abonelik Yenileme Hatırlatması",
  "notify.subscriptionReminder.body": "\"{{name}}\" aboneliğin yakında yenileniyor!",
  "notify.billReminder.title": "📋 Fatura Ödeme Hatırlatması",
  "notify.billReminder.body": "\"{{name}}\" faturasının son ödeme tarihi yaklaşıyor!",


  "finance.savings.reminderBody": "\"{{name}}\" birikimini güncellemeyi unutma!",
  "auto.push.location.shareOnTitle": "📍 Konum Paylaşımı Açıldı",
  "auto.push.location.shareOnBody": "{{member}} konumunu paylaşmaya başladı",
  "auto.push.location.timedTitle": "⏱ Süreli Konum Paylaşımı",
  "auto.push.location.timedBody": "{{member}} {{duration}} boyunca konumunu paylaşıyor",
  "auto.push.sos.title": "🆘 ACİL YARDIM!",
  "auto.push.sos.body": "{{member}} yardım istiyor! Konumu paylaşıldı.",
  "auto.push.meeting.title": "🤝 Buluşma Noktası Belirlendi",
  "auto.push.meeting.body": "{{member}} buluşma noktası olarak \"{{place}}\" belirledi",
  "auto.push.geofence.newTitle": "🔔 Yeni Coğrafi Sınır",
  "auto.push.geofence.addedBody": "\"{{zone}}\" için {{mode}} bildirimi eklendi",
  "auto.push.geofence.addedEntryBody": "\"{{zone}}\" için giriş bildirimi eklendi",
  "auto.push.geofence.addedExitBody": "\"{{zone}}\" için çıkış bildirimi eklendi",
  "auto.push.safeZone.newTitle": "🟢 Yeni Güvenli Alan",
  "auto.push.safeZone.addedBody": "\"{{zone}}\" güvenli alan olarak tanımlandı",
  "auto.push.nearby.title": "📡 Aile Üyesi Yakında",
  "auto.push.nearby.body": "{{member}} sana {{distance}}",

  /* ── Notification i18n final fixes ── */
  "auto.push.zone.safeTitle": "{{emoji}} Güvenli Alan: {{zone}}",
  "auto.push.zone.geofenceTitle": "{{emoji}} Coğrafi Sınır: {{zone}}",
  "auto.push.zone.enterBody": "{{member}} \"{{zone}}\" alanına girdi{{distance}}",
  "auto.push.zone.exitBody": "{{member}} \"{{zone}}\" alanına çıktı{{distance}}",
  "notify.shoppingReminder.item": "\"{{item}}\" ürününü almayı unutma!",
  "notify.shoppingReminder.default": "Alışveriş listeni kontrol et.",
  "notify.taskReminder.item": "\"{{task}}\" görevini unutma!",
  "notify.taskReminder.default": "Görevini kontrol et.",
  "notify.calendarReminder.body": "{{event}}{{timeText}} etkinliğini unutma!",

  "nav.activity": "Aile Aktivite Akışı",
  "home.activitySub": "Ailenizdeki son işlemler",
  "activity.title": "Aile Aktivite Akışı",
  "activity.subtitle": "Ailenizde gerçekleşen önemli işlemleri ve güncellemeleri tek bir akışta takip edin.",
  "activity.heroBadge": "CANLI AİLE MERKEZİ",
  "activity.stat.today": "Bugün",
  "activity.stat.week": "Bu hafta",
  "activity.stat.mostActive": "En aktif üye",
  "activity.stat.unread": "Yeni",
  "activity.search": "Aktivite ara...",
  "activity.new": "Yeni",
  "activity.someone": "Bir aile üyesi",
  "activity.emptyTitle": "Henüz aktivite yok",
  "activity.emptyText": "Ailenizde işlem yapıldıkça burada canlı bir akış oluşacak.",
  "activity.group.today": "Bugün",
  "activity.group.yesterday": "Dün",
  "activity.group.week": "Bu Hafta",
  "activity.group.older": "Daha Eski",
  "activity.category.all": "Tümü",
  "activity.category.shopping": "Alışveriş",
  "activity.category.tasks": "Görev",
  "activity.category.calendar": "Takvim",
  "activity.category.finance": "Finans",
  "activity.category.documents": "Belge",
  "activity.category.health": "Sağlık",
  "activity.category.children": "Çocuk",
  "activity.category.chat": "Sohbet",
  "activity.category.management": "Yönetim",
  "activity.title.shoppingAdded": "Ürün eklendi",
  "activity.title.shoppingCompleted": "Ürün alındı",
  "activity.title.shoppingDeleted": "Ürün silindi",
  "activity.title.taskAdded": "Görev eklendi",
  "activity.title.taskCompleted": "Görev tamamlandı",
  "activity.title.taskDeleted": "Görev silindi",
  "activity.title.calendarAdded": "Etkinlik eklendi",
  "activity.title.calendarUpdated": "Etkinlik güncellendi",
  "activity.title.calendarDeleted": "Etkinlik silindi",
  "activity.title.incomeAdded": "Gelir eklendi",
  "activity.title.financeAdded": "Finans kaydı eklendi",
  "activity.title.expenseAdded": "Gider eklendi",
  "activity.title.financeDeleted": "Finans kaydı silindi",
  "activity.title.documentAdded": "Belge eklendi",
  "activity.title.documentDeleted": "Belge silindi",
  "activity.title.healthAdded": "Sağlık kaydı eklendi",
  "activity.title.childAdded": "Çocuk takip kaydı eklendi",
  "activity.title.managementNotification": "Aile bildirimi gönderildi",
  "activity.msg.shoppingAdded": "{{actor}} alışveriş listesine “{{item}}” ekledi.",
  "activity.msg.shoppingCompleted": "{{actor}} “{{item}}” ürününü alındı olarak işaretledi.",
  "activity.msg.shoppingDeleted": "{{actor}} “{{item}}” ürününü listeden sildi.",
  "activity.msg.taskAdded": "{{actor}} “{{item}}” görevini oluşturdu.",
  "activity.msg.taskCompleted": "{{actor}} “{{item}}” görevini tamamladı.",
  "activity.msg.taskDeleted": "{{actor}} “{{item}}” görevini sildi.",
  "activity.msg.calendarAdded": "{{actor}} takvime “{{item}}” etkinliğini ekledi.",
  "activity.msg.calendarUpdated": "{{actor}} “{{item}}” etkinliğini güncelledi.",
  "activity.msg.calendarDeleted": "{{actor}} “{{item}}” etkinliğini sildi.",
  "activity.msg.financeAdded": "{{actor}} “{{item}}” finans kaydını ekledi{{amount}}.",
  "activity.msg.financeDeleted": "{{actor}} “{{item}}” finans kaydını sildi.",
  "activity.msg.documentAdded": "{{actor}} “{{item}}” belgesini ekledi.",
  "activity.msg.documentDeleted": "{{actor}} “{{item}}” belgesini sildi.",
  "activity.msg.healthAdded": "{{actor}} “{{item}}” sağlık kaydını ekledi.",
  "activity.msg.childAdded": "{{actor}} “{{item}}” çocuk takip kaydını ekledi.",
  "activity.msg.managementNotification": "{{actor}} aileye “{{item}}” bildirimini gönderdi.",
  "activity.showMore": "{{count}} aktivite daha göster",

  "profile.tab.avatar": "Avatar",
  "profile.avatar.title": "Avatarını Seç",
  "profile.avatar.hint": "Senin için önerilen",
  "profile.avatar.initials": "Baş harfli renkli avatar",
  "profile.avatar.colors": "Rengini Seç",
  "profile.avatar.all": "Tüm avatarlar",
  "profile.avatar.save": "Avatarı Kaydet",
  "profile.avatar.savedOk": "Avatar güncellendi ✓",
  "profile.avatar.saveFail": "Avatar güncellenemedi.",
  "profile.photo.title": "Kendi fotoğrafını kullan",
  "profile.photo.subtitle": "Kameradan çek veya galerinden seç; yüzünü daireye tam oturt.",
  "profile.photo.camera": "Fotoğraf çek",
  "profile.photo.gallery": "Galeriden seç",
  "profile.photo.privacy": "Fotoğrafın yalnızca profil görünümünde kullanılır.",
  "profile.photo.editorTitle": "Fotoğrafını ayarla",
  "profile.photo.editorSubtitle": "Daire içindeki görünüm avatarın olacak",
  "profile.photo.editorHint": "Fotoğrafı sürükle; iki parmakla veya kaydırıcıyla yakınlaştır.",
  "profile.photo.zoom": "Fotoğraf yakınlaştırma",
  "profile.photo.rotate": "Döndür",
  "profile.photo.reset": "Sıfırla",
  "profile.photo.use": "Kullan",
  "profile.photo.uploading": "Yükleniyor… {{percent}}%",
  "profile.photo.preparing": "Fotoğraf hazırlanıyor…",
  "profile.photo.saved": "Profil fotoğrafın güncellendi ✓",
  "profile.photo.remove": "Fotoğrafı kaldır",
  "profile.photo.removeTitle": "Profil fotoğrafı kaldırılsın mı?",
  "profile.photo.removeConfirm": "Yüklediğin profil fotoğrafı kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "profile.photo.unsupported": "Bu fotoğraf açılamadı. JPG, PNG, WebP veya HEIC bir fotoğraf seç.",
  "profile.photo.tooLarge": "Seçilen fotoğraf çok büyük. En fazla 25 MB bir fotoğraf seç.",
  "profile.photo.uploadFailed": "Profil fotoğrafı yüklenemedi. Bağlantını kontrol edip tekrar dene.",
  "profile.photo.editorError": "Fotoğraf hazırlanamadı. Başka bir fotoğrafla tekrar dene.",

  "children.avatar.title": "Avatar Seç",
  "children.avatar.change": "Avatar Değiştir",
  "children.avatar.save": "Kaydet",
  "children.avatar.savedOk": "Avatar güncellendi ✓",
  "children.avatar.saveFail": "Avatar güncellenemedi.",
  "children.photo.use": "Yüklenen fotoğrafı kullan",
  "children.photo.removeTitle": "Profil fotoğrafı kaldırılsın mı?",
  "children.photo.removeConfirm": "Bu çocuk, bebek veya evcil hayvan profiline yüklenen fotoğraf kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "children.photo.uploadFailed": "Profil fotoğrafı yüklenemedi. Bağlantını kontrol edip tekrar dene.",
  "children.photo.deleteFailed": "Profil fotoğrafı kaldırılamadı. Lütfen tekrar dene.",

  /* ── Günlük giriş hatırlatıcı popup ── */
  "daily.popup.title": "📋 Bugün & Yaklaşanlar",
  "daily.popup.close": "Kapat",
  "daily.popup.noItems": "Bugün için bekleyen hatırlatma yok 🎉",
  "daily.popup.task": "Görev",
  "daily.popup.event": "Etkinlik",
  "daily.popup.medicine": "İlaç",
  "daily.popup.appointment": "Randevu",
  "daily.popup.birthday": "🎂 Doğum Günü",
  "daily.popup.overdue": "Gecikmiş",
  "daily.popup.today": "Bugün",
  "daily.popup.tomorrow": "Yarın",
  "daily.popup.daysLeft": "{{days}} gün kaldı",

  /* ── Doğum günü bildirimleri ── */
  "notify.birthday.title": "🎂 Bugün {{name}}'ın Doğum Günü!",
  "notify.birthday.body": "Aile olarak {{name}}'a doğum günü dileklerinizi iletmeyi unutmayın! 🎉💕",

  /* ── Chat: gönderen adlı push bildirimi ── */
  "notify.chatMessage": "{{senderName}}: {{message}}",

  /* ── Uygulama içi dialog / toast ── */
  "mgmt.sched.confirmCancelRecurring": "Bu tekrar eden sistem duyurusunu iptal etmek istiyor musun?",
  "dialog.confirmTitle": "Onay",
  "dialog.infoTitle": "Bilgi",
  "dialog.confirm": "Onayla",
  "dialog.cancel": "Vazgeç",
  "dialog.ok": "Tamam",
  "dialog.close": "Kapat",

  "mgmt.field.message": "Mesaj",
  "mgmt.field.dateTime": "Tarih / Saat",
  "mgmt.field.repeatType": "Tekrar Tipi",
  "mgmt.field.plannedDateTime": "Planlanan Tarih / Saat",
  "mgmt.notif.last50": "🕘 Son 50 Bildirim",
  "mgmt.notif.last100": "Son 100 Bildirim",
  "mgmt.notif.tabAnnouncements": "📢 Duyurular",
  "mgmt.notif.tabAutomation": "⚙️ Otomatik Bildirim Kontrolleri",
  "mgmt.notif.noAutomationHistory": "Henüz otomatik bildirim kaydı yok.",
  "mgmt.notif.errorLabel": "Hata",
  "mgmt.notif.plannedLabel": "Planlanan",
  "mgmt.notif.repeatLabelShort": "Tekrar",
  "mgmt.auto.resume": "▶️ Devam Ettir",
  "mgmt.auto.pause": "⏸️ Duraklat",
  "mgmt.noRepeatingAnnouncement": "Tekrar eden sistem duyurusu bulunmuyor.",


  /* ── Children tracking premium header ── */
  "children.tracking.archive": "Aile Arşivi",
  "children.tracking.title": "Çocuk / Bebek / Evcil Takibi",
  "children.tracking.subtitle": "Gelişim, sağlık, eğitim, rutin ve bakım kayıtlarını sakin bir aile arşivinde takip et.",
  "children.tracking.addProfile": "Ekle",
  "children.type.child": "Çocuk",
  "children.type.baby": "Bebek",
  "children.type.pet": "Evcil Hayvan",
  "auth.resetPasswordTitle": "Şifrenizi yenileyin",
  "auth.resetPasswordSubtitle": "Aile Yönetimi hesabınız için güvenli yeni şifre oluşturun.",
  "auth.resetLinkChecking": "Bağlantı kontrol ediliyor",
  "auth.resetLinkCheckingSub": "Şifre sıfırlama bağlantınız güvenli şekilde doğrulanıyor.",
  "auth.resetLinkInvalidTitle": "Bağlantı geçersiz",
  "auth.resetLinkInvalid": "Şifre sıfırlama bağlantısı geçersiz, kullanılmış veya süresi dolmuş.",
  "auth.createNewPassword": "Yeni şifre oluştur",
  "auth.createNewPasswordSub": "Güvenliğiniz için 8-128 karakter arasında yeni bir şifre belirleyin.",
  "auth.placeholder.newPassword": "Yeni şifre",
  "auth.placeholder.confirmNewPassword": "Yeni şifre tekrar",
  "auth.saveNewPassword": "Yeni şifreyi kaydet",
  "auth.resetPasswordMin": "Yeni şifre 8-128 karakter arasında olmalı.",
  "auth.resetPasswordMismatch": "Yeni şifreler eşleşmiyor.",
  "auth.resetPasswordFailed": "Şifre güncellenemedi. Lütfen tekrar deneyin.",
  "auth.resetPasswordSuccessTitle": "Şifreniz güncellendi",
  "auth.resetPasswordSuccessSub": "Artık yeni şifrenizle giriş yapabilirsiniz.",
  /* ── Aile Asistanı ── */
  "nav.assistant": "Aile Asistanı",
  "assistant.title": "Aile Asistanı",
  "assistant.subtitle": "Aileniz için günlük akıllı özet hazırlanıyor.",
  "assistant.todaySummary": "Bugünkü akıllı özet",
  "assistant.priority": "Öncelikli işler",
  "assistant.smartAdvice": "Aile Asistanı Tavsiyeleri",
  "assistant.finance": "Finans",
  "assistant.tasks": "Görevler",
  "assistant.calendar": "Takvim",
  "assistant.shopping": "Alışveriş",
  "assistant.health": "Sağlık",
  "assistant.documents": "Belgeler",
  "assistant.children": "Çocuk",
  "assistant.map": "Harita",
  "assistant.chat": "Chat",
  "assistant.notifications": "Bildirimler",
  "assistant.empty.title": "Henüz kritik bir konu yok",
  "assistant.empty.desc": "Bugün aile planınız sakin görünüyor. Yeni görev, alışveriş veya takvim kaydı ekleyerek asistan özetini zenginleştirebilirsiniz.",
  "assistant.disclaimer.health": "Bu öneriler bilgilendirme amaçlıdır, tıbbi değerlendirme yerine geçmez.",
  "assistant.viewDetails": "Detayları gör",
  "assistant.refresh": "Yenile",
  "assistant.updatedNow": "Güncellendi",
  "assistant.loading": "Özet hazırlanıyor",
  "assistant.scoreExplain": "Puan nasıl hesaplandı?",
  "assistant.score": "durum skoru",
  "assistant.error": "Özet alınamadı. Lütfen tekrar deneyin.",
  "scan.previewTitle": "Taranan Ürünler",
  "scan.previewTitleReceipt": "Taranan Fiş",

  /* ── Özel Takvimim ── */
  "cycle.title": "Özel Takvimim",
  "cycle.private": "Sadece siz görebilirsiniz",
  "cycle.day": "gün",
  "cycle.days": "gün",
  "cycle.today": "Bugün",
  "cycle.late": "Gecikmeli",
  "cycle.daysLate": "gün gecikme",

  /* Onboarding */
  "cycle.onb.welcome": "Özel Takvimim'e Hoş Geldiniz",
  "cycle.onb.welcomeDesc": "Regl döngünüzü, belirtilerinizi ve sağlık verilerinizi özel ve güvenli şekilde takip edin.",
  "cycle.onb.lastPeriod": "Son regl başlangıç tarihi",
  "cycle.onb.cycleLength": "Döngü Uzunluğu",
  "cycle.onb.cycleLengthDesc": "Ortalama regl döngünüz ve regl süreniz nedir?",
  "cycle.onb.avgCycle": "Ortalama döngü:",
  "cycle.onb.avgPeriod": "Ortalama regl süresi:",
  "cycle.onb.privacy": "Gizlilik Güvencesi",
  "cycle.onb.privacyDesc": "Bu veriler tamamen özeldir. Hiçbir aile üyesi, yönetici veya sistem yöneticisi göremez.",
  "cycle.onb.start": "Takibe Başla",

  /* Hero */
  "cycle.hero.today": "Bugün",
  "cycle.hero.nextPeriod": "Sonraki regl",
  "cycle.hero.ovulation": "Yumurtlama",
  "cycle.hero.fertile": "Doğurgan dönem",
  "cycle.hero.regularity": "Düzenlilik",
  "cycle.hero.activePeriod": "Reglin devam ediyor",
  "cycle.confidence.starter": "Başlangıç tahmini",
  "cycle.confidence.medium": "Gelişen tahmin",
  "cycle.confidence.high": "Güçlü tahmin",

  /* Quick Actions */
  "cycle.qa.start": "Reglim Başladı",
  "cycle.qa.end": "Reglim Bitti",
  "cycle.qa.symptom": "Belirti Ekle",
  "cycle.qa.note": "Not Ekle",

  /* Period modal */
  "cycle.period.date": "Tarih",
  "cycle.period.flow": "Kanama yoğunluğu",

  /* Tabs */
  "cycle.tab.home": "Ana Sayfa",
  "cycle.tab.calendar": "Takvim",
  "cycle.tab.analysis": "Analiz",
  "cycle.tab.meds": "İlaçlar",

  /* Day panel sections */
  "cycle.mood.title": "Ruh Hali",
  "cycle.pain.title": "Ağrı Seviyesi",
  "cycle.symptoms.title": "Belirtiler",
  "cycle.discharge.title": "Akıntı",
  "cycle.note.title": "Notlar",
  "cycle.note.placeholder": "Bugün için notunuz...",

  /* Calendar legend */
  "cycle.legend.period": "Regl",
  "cycle.legend.predicted": "Tahmini regl",
  "cycle.legend.ovulation": "Yumurtlama",
  "cycle.legend.fertile": "Doğurgan",
  "cycle.legend.pms": "PMS",

  /* Insights */
  "cycle.insights.title": "Akıllı İçgörüler",

  /* Medications */
  "cycle.meds.title": "İlaç Takibi",
  "cycle.meds.add": "İlaç Ekle",
  "cycle.meds.namePlaceholder": "İlaç adı",
  "cycle.meds.dosagePlaceholder": "Doz (örn: 500mg)",
  "cycle.meds.empty": "Henüz ilaç kaydı yok.",
  "cycle.prediction.title": "Döngü tahminleri",
  "cycle.meds.emptyTitle": "İlaç takibiniz hazır",
  "cycle.meds.emptyDesc": "Ağrı kesici, vitamin veya düzenli kullandığınız ilaçlar için güvenli hatırlatmalar oluşturabilirsiniz.",
  "cycle.meds.emptyFeature1": "Saat seçerek düzenli hatırlatma alın.",
  "cycle.meds.emptyFeature2": "Bu kayıtlar sadece size özeldir.",
  "cycle.meds.emptyFeature3": "Doz, kullanım notu ve düzenleme desteği.",
  "cycle.meds.addFirst": "İlk ilacı ekle",

  /* Analysis */
  "cycle.analysis.title": "Analiz",
  "cycle.analysis.periodCount": "Regl sayısı",
  "cycle.analysis.avgCycle": "Ort. döngü",
  "cycle.analysis.avgPeriod": "Ort. regl süresi",
  "cycle.analysis.regularity": "Düzenlilik",
  "cycle.analysis.cycleTrend": "Döngü uzunluğu trendi",
  "cycle.analysis.painTrend": "Ağrı trendi",
  "cycle.analysis.moodDist": "Ruh hali dağılımı",
  "cycle.analysis.topSymptoms": "En sık belirtiler",

  /* Settings */
  "cycle.settings.title": "Ayarlar",
  "cycle.settings.notifications": "Bildirimler",
  "cycle.settings.notificationTimes": "Bildirim Saatleri",
  "cycle.settings.notificationTimesHint": "Günlük kayıt, regl hatırlatmaları ve döngü bildirimlerinin hangi saatte geleceğini buradan ayarlayabilirsiniz.",
  "cycle.settings.defaultTime": "Varsayılan: {time}",
  "cycle.settings.privacy": "Gizlilik & Özellikler",
  "cycle.settings.export": "Veri Dışa Aktarma",
  "cycle.settings.deleteData": "Veri Silme",
  "cycle.settings.deleteAll": "Tüm verileri sil",
  "cycle.settings.deleteConfirm": "Tüm döngü verileriniz kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "cycle.settings.sexualTracking": "Cinsel sağlık takibi (opsiyonel)",
  "cycle.settings.pregnancyMode": "Hamilelik planlama modu",

  /* Notifications */
  "cycle.notif.period7d": "Regl 7 gün önce",
  "cycle.notif.period3d": "Regl 3 gün önce",
  "cycle.notif.period1d": "Regl 1 gün önce",
  "cycle.notif.periodToday": "Tahmini regl günü",
  "cycle.notif.ovulation": "Yumurtlama dönemi",
  "cycle.notif.fertile": "Doğurgan dönem",
  "cycle.notif.pms": "PMS başlangıcı",
  "cycle.notif.dailyLog": "Günlük kayıt hatırlatması",
  "cycle.notif.delay": "Gecikme bildirimi",
  "cycle.notif.medication": "İlaç hatırlatması",
  "cycle.notif.privateMode": "Gizli bildirim modu",

  /* Privacy */
  "cycle.privacy.familyHide": "Aile üyeleri göremez",
  "cycle.privacy.adminHide": "Yöneticiler göremez",
  "cycle.privacy.superAdminHide": "Sistem yöneticisi göremez",
  "cycle.privacy.onlyYou": "Sadece siz görebilirsiniz",

  /* Common extras */
  "common.next": "İleri",
  "common.confirm": "Onayla",
  /* ── Özel Takvimim — ek anahtarlar ── */
  "cycle.ai.title": "Tavsiyeler",
  "cycle.calendar.hasEntry": "Bu güne kayıt eklendi",
  "cycle.analysis.periodTrend": "Regl süresi eğilimi",
  "cycle.ai.empty": "Düzenli kayıt tutmaya başladıkça kişisel analizler burada görünecek.",
  "cycle.ai.tip1": "Tahminleri aktif etmek için regl başlangıcınızı kaydedin.",
  "cycle.ai.tip2": "Günlük belirti takibi örüntüleri belirlemenize yardımcı olur.",
  "cycle.ai.tip3": "3 döngü sonrasında kişiselleştirilmiş içgörüler burada çıkar.",
  "cycle.ai.tip4": "Su tüketimi, uyku ve hafif yürüyüş kayıtlarınızı daha dengeli yorumlamamıza yardımcı olur.",
  "cycle.ai.tip5": "Yumurtlama ve doğurgan dönem tahminleri geçmiş kayıtlar arttıkça daha isabetli hale gelir.",
  "cycle.ai.tip6": "Ağrı veya ruh hali değişimini her gün kısa notlarla takip etmek ay sonu analizini güçlendirir.",
  "cycle.ai.tip7": "Aşırı kanama, dayanılmaz ağrı veya olağan dışı belirti varsa doktora danışmanız önerilir.",
  "cycle.calInfo.thisCycle": "Bu döngü",
  "cycle.calInfo.hint": "Belirti, ruh hali veya not eklemek için herhangi bir güne dokunun.",
  "cycle.analysis.empty.title": "Döngünüzü Takip Etmeye Başlayın",
  "cycle.analysis.empty.desc": "Daha fazla kayıt girdikçe grafik ve trendler burada görünecek.",
  "cycle.analysis.empty.s1": "Regl başlangıcını kaydet",
  "cycle.analysis.empty.s2": "Günlük belirti girişi yap",
  "cycle.analysis.empty.s3": "3+ döngü sonrası grafikler aktif",
  "cycle.meds.editTitle": "İlacı Düzenle",
  "cycle.meds.update": "Güncelle",
  "cycle.pregnancy.banner": "Hamilelik Planlama Modu Aktif",
  "cycle.pregnancy.tip": "En uygun zamanlama için doğurgan döneminizi takip edin.",
  "cycle.pregnancy.bestDays": "En uygun günler",
  "cycle.sexual.title": "Cinsel Sağlık",
  "cycle.sexual.protected": "Korumalı",
  "cycle.sexual.unprotected": "Korumasız",
  "cycle.sexual.pregnancyIntent": "Hamilelik planlıyorum",
  "cycle.hero.cycleDay": "Döngü Günü",
  "cycle.hero.period": "Regl",
  "cycle.period.addPast": "Geçmiş Regl Ekle",
  "cycle.period.startDate": "Başlangıç tarihi",
  "cycle.period.endDate": "Bitiş tarihi (opsiyonel)",
  "cycle.period.startHelp": "Tarihleri ve kanama yoğunluğunu kaydederek tahminlerinin zamanla kişiselleşmesini sağlayabilirsin.",
  "cycle.period.endHelp": "Reglinin bittiği günü seç. Döngü hesabın bu tarihe göre güncellenecek.",
  "cycle.period.ongoing": "Devam ediyor",
  "cycle.period.completed": "Tamamlandı",
  "cycle.period.ongoingHint": "Reglin bittiğinde bu kaydı tek dokunuşla kapatabilirsin.",
  "cycle.tab.swipeHint": "Sekme değiştirmek için kaydırın",
  "cycle.analysis.insights": "Döngü Analizleri",
  "cycle.analysis.noTrend": "Henüz trend verisi yok",

  "cycle.analysis.healthScore": "Sağlık içgörüsü",
  "cycle.analysis.scoreGood": "Döngünüz düzenli görünüyor. Kayıtlar arttıkça tahminler daha da netleşir.",
  "cycle.analysis.scoreMedium": "Takip düzeniniz oluşuyor. Birkaç kayıt daha tahmin kalitesini artırır.",
  "cycle.analysis.scoreLow": "Döngü değişken görünüyor. Düzenli kayıt, gecikme ve belirti takibini güçlendirir.",
  "cycle.analysis.scoreStart": "İlk verilerinizle analiz hazırlanıyor. Kayıt ekledikçe burası zenginleşir.",
  "cycle.analysis.nextWindow": "Sıradaki dönem",
  "cycle.analysis.ovulationWindow": "Yumurtlama görünümü",
  "cycle.analysis.notEnough": "Daha fazla kayıtla netleşecek",

  // ── Harita / Bölge bildirimleri (auto.push) ──────────────────
  "auto.push.zone.placeTitle":       "📍 Ortak Yer — {{zone}}",
  "auto.push.zone.created.safe":     "🟢 '{{zone}}' güvenli alanı oluşturuldu! Artık bu bölge için giriş-çıkış bildirimleriniz aktif 🏠",
  "auto.push.zone.created.geo":      "🔔 '{{zone}}' sınırı oluşturuldu! Bu bölgeye girip çıkışlarda anında haber alacaksınız 📍",
  "auto.push.zone.created.place":    "📍 '{{zone}}' ortak yerine bildirim eklendi! Aile üyeleri bu bölgeye gelip gidince haberdar olacaksınız 🗺️",
  "auto.push.safe.enter":            "{{member}} '{{zone}}' güvenli alanına ulaştı! Her şey yolunda, içeride huzur var ✨",
  "auto.push.safe.exit":             "{{member}} '{{zone}}' güvenli alanından ayrıldı. Dikkatli yolculuklar, iyi bakın kendinize! 👋",
  "auto.push.geo.enter":             "{{member}} '{{zone}}' bölgesine geldi. Merak etme, her şeyi takip ediyoruz 📍",
  "auto.push.geo.exit":              "{{member}} '{{zone}}' bölgesinden ayrıldı. Yolculuk devam ediyor, iyi gitsin! 🛤️",
  "auto.push.place.enter":           "{{member}} '{{zone}}' yakınına geldi! Bir uğrayış var gibi görünüyor 😊",
  "auto.push.place.exit":            "{{member}} '{{zone}}' bölgesinden ayrıldı. Güle güle, tekrar görüşürüz! 👋",
  "auto.push.child.okul.enter":      "🏫 {{member}} okula güvenle ulaştı! Bugün iyi dersler 📚",
  "auto.push.child.okul.exit":       "📌 {{member}} okuldan ayrıldı. Bugün iyi bir gün geçirmiştir! 🌟",
  "auto.push.child.kres.enter":      "🧸 {{member}} kreşe güvenle ulaştı! Keyifli bir gün dileriz 💛",
  "auto.push.child.kres.exit":       "🏠 {{member}} kreşten ayrıldı, eve doğru! Görüşürüz sevgilisi 💕",
  "auto.push.child.yuzme.enter":     "🏊 {{member}} yüzme dersine ulaştı! Hadi yüzmeye 🌊",
  "auto.push.child.yuzme.exit":      "🚿 {{member}} yüzme dersinden ayrıldı. Harika bir antrenman! 💪",
  "auto.push.child.spor.enter":      "⚽ {{member}} spora ulaştı! Başarılar, hadi mücadele 💪",
  "auto.push.child.spor.exit":       "🏆 {{member}} spordan ayrıldı. Harika bir antrenman! 🌟",
  "auto.push.child.dershane.enter":  "📚 {{member}} dershaneye ulaştı, çalışmaya hazır ✏️",
  "auto.push.child.dershane.exit":   "📖 {{member}} dershaneden ayrıldı. Çok çalıştı, tebrikler! 🌟",
  "auto.push.child.kurs.enter":      "🎨 {{member}} kursa ulaştı! Yaratıcılık zamanı 🖌️",
  "auto.push.child.kurs.exit":       "🎭 {{member}} kurstan ayrıldı. Harika bir gün geçirdi! ✨",
  "auto.push.child.park.enter":      "🌳 {{member}} parka ulaştı! Eğlenceli zaman 🎪",
  "auto.push.child.park.exit":       "🏠 {{member}} parktan ayrıldı, eve doğru! Hava almak güzeldi 🌸",
  "auto.push.child.diger.enter":     "🌟 {{member}} \"{{zone}}\" alanına güvenle ulaştı!",
  "auto.push.child.diger.exit":      "👣 {{member}} \"{{zone}}\" alanından ayrıldı.",

  /* ── Offline banner ── */
  "offline.banner": "İnternet bağlantısı yok — son veriler gösteriliyor",

  /* ── Yasal Belgeler / Legal Documents ── */
  "settings.privacy.legalDocuments": "Yasal Belgeler",
  "settings.privacy.legalDocumentsHint": "Gizlilik, kullanım ve hesap silme belgelerini inceleyin.",
  "settings.privacy.privacyPolicy": "Gizlilik Politikası",
  "settings.privacy.privacyPolicyHint": "Verilerin nasıl işlendiğini ve korunduğunu görün.",
  "settings.privacy.termsOfService": "Kullanım Şartları",
  "settings.privacy.termsOfServiceHint": "Hizmetin kullanım kuralları ve sorumlulukları.",
  "settings.privacy.accountDeletionInfo": "Hesap Silme Bilgisi",
  "settings.privacy.accountDeletionInfoHint": "Hesap silme, veri dışa aktarma ve saklama süreleri.",


  "auth.register.personalInfo": "Kişisel Bilgiler",
  "auth.register.required": "Zorunlu alanlar",
  "auth.register.name": "Ad",
  "auth.register.surname": "Soyad",
  "auth.register.birthDate": "Doğum Tarihi",
  "auth.register.birthDateHelp": "Yaş hesaplamaları ve doğum günü hatırlatmaları için kullanılır.",
  "auth.register.gender": "Cinsiyet",
  "auth.register.familyProfile": "Aile Profili",
  "auth.register.phone": "Telefon",
  "auth.register.username": "Kullanıcı Adı",
  "auth.register.role": "Aile Rolü",
  "auth.register.accountInfo": "Hesap Bilgileri",
  "auth.register.email": "E-posta",
  "auth.register.password": "Şifre",
  "auth.error.nameRequired": "Adınızı yazın.",
  "auth.error.nameMin": "Ad en az 3 karakter olmalı.",
  "auth.error.surnameRequired": "Soyadınızı yazın.",
  "auth.error.surnameMin": "Soyad en az 2 karakter olmalı.",
  "auth.error.birthDateRequired": "Doğum tarihini seçin.",
  "auth.error.usernameRequired": "Kullanıcı adını yazın.",
  "auth.error.emailInvalid": "Geçerli bir e-posta adresi yazın.",
  "auth.register.healthInfo": "Sağlık bilgileri",
  "auth.register.optional": "İsteğe bağlı",
  "auth.register.bloodGroup": "Kan Grubu",
  "auth.register.height": "Boy",
  "auth.register.weight": "Kilo",
  "auth.social.google": "Google ile devam et",
  "auth.social.apple": "Apple ile devam et",
  "auth.social.orEmail": "veya e-posta ve şifreyle",
  "auth.social.quickRegister": "Hızlı ve güvenli kayıt",
  "auth.social.orForm": "veya formu doldurun",
  "auth.social.completeProfile": "Profilini Tamamla",
  "auth.social.completeProfileSub": "Hesabını oluşturmak için kalan bilgileri tamamla",
  "auth.social.googleConnected": "Google hesabınız doğrulandı",
  "auth.social.appleConnected": "Apple hesabınız doğrulandı",
  "auth.social.linkSuccess": "Giriş yöntemi hesabınıza güvenle bağlandı.",
  "auth.social.error.existingAccount": "Bu e-posta ile mevcut bir hesap var. Önce e-posta ve şifrenizle giriş yapıp Ayarlar > Gizlilik bölümünden sosyal hesabınızı bağlayın.",
  "auth.social.error.identityInUse": "Bu sosyal hesap başka bir Aile Yönetimi hesabına bağlı.",
  "auth.social.error.verifyFailed": "Sosyal hesap doğrulanamadı. Lütfen tekrar deneyin.",
  "auth.social.error.appleDeleteRetry": "Apple hesabı yeniden doğrulanamadı. Hesabınız silinmedi; lütfen tekrar deneyin.",
  "auth.social.error.noLinkedProvider": "Hesap silme için bağlı bir sosyal giriş yöntemi bulunamadı.",
  "auth.social.error.generic": "Sosyal giriş tamamlanamadı. Lütfen tekrar deneyin.",
  "auth.social.error.googleNoCredential": "Google hesabı seçilemedi. Google Play Hizmetlerinin güncel ve cihazınızda Google hesabınızın açık olduğundan emin olup tekrar deneyin.",
  "auth.social.error.googleProviderUnavailable": "Bu cihazdaki Google giriş hizmeti hazırlanamadı. Google Play’i bir kez açıp uygulamaya dönerek tekrar deneyin.",
  "auth.social.error.googlePlayServices": "Google ile giriş için Google Play Hizmetlerini güncelleyin ve tekrar deneyin.",
  "auth.social.error.googleConfiguration": "Google ile giriş şu anda kullanılamıyor. Lütfen uygulamanın güncel olduğundan emin olup tekrar deneyin.",
  "auth.social.error.network": "Google ile giriş tamamlanamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.",
  "auth.social.error.busy": "Google giriş ekranı zaten açık. Lütfen mevcut işlemi tamamlayın veya birkaç saniye sonra tekrar deneyin.",
  "auth.social.error.timeout": "Google giriş işlemi beklenenden uzun sürdü. Lütfen tekrar deneyin.",
  "settings.privacy.loginMethods": "Giriş Yöntemleri",
  "settings.privacy.loginMethodsHint": "Hesabınıza Google veya Apple girişini güvenle bağlayabilirsiniz.",
  "settings.privacy.connected": "Bağlı",
  "settings.privacy.connect": "Bağla",
  "settings.privacy.socialDeleteHint": "Hesabınızı silmeden önce bağlı sosyal hesabınızla yeniden doğrulama yapılacaktır.",
  "settings.privacy.socialReauth": "Sosyal Hesapla Doğrula ve Sil",
  "profile.createPassword": "Şifre Oluştur",
  "profile.createPasswordHint": "İsterseniz sosyal girişe ek olarak e-posta ve şifreyle giriş için bir şifre oluşturabilirsiniz.",
  "profile.passwordCreatedOk": "Şifre oluşturuldu ✓",

  /* ── Sesli sohbet (FAZ 1) ── */
  "call.start": "Sesli arama başlat",
  "call.voiceCall": "Sesli sohbet",
  "call.incoming": "Sizi arıyor",
  "call.ongoing": "Devam eden sesli sohbet",
  "call.calling": "Aranıyor…",
  "call.someone": "Bilinmeyen",
  "call.accept": "Cevapla",
  "call.join": "Katıl",
  "call.decline": "Reddet",
  "call.leave": "Ayrıl",
  "call.mute": "Sustur",
  "call.unmute": "Sesi aç",
  "call.declined": "Arama reddedildi.",
  "call.micDenied": "Sesli arama için mikrofon izni gerekli. Ayarlardan izin verebilirsiniz.",
  "call.unsupported": "Bu cihaz sesli aramayı desteklemiyor.",
  "call.startFailed": "Arama başlatılamadı. Lütfen tekrar deneyin.",
  "call.joinFailed": "Aramaya katılınamadı. Lütfen tekrar deneyin.",
  "call.premiumTitle": "Sesli sohbet",
  "call.premiumB1": "Aile üyelerinle sesli konuş",
  "call.premiumB2": "6 kişiye kadar grup araması",
  "call.premiumB3": "Uçtan uca şifreli, kayıt tutulmaz",
  "call.premiumNote": "Arama başlatmak için premium gerekir. Sana gelen aramalara premium olmadan da katılabilirsin.",

  /* ── Sesli sohbet (FAZ 2) ── */
  "call.incomingGroup": "Grup araması",
  "call.people": "kişi",
  "call.speaking": "konuşuyor",
  "call.you": "Sen",
  "call.connecting": "Bağlanıyor…",
  "call.minimize": "Küçült",
  "call.full": "Arama dolu (en fazla 6 kişi).",
  "call.sec": "sn",
  "call.min": "dk",
  "call.logMissed": "Cevapsız sesli arama",
  "call.logDeclined": "Arama reddedildi",
  "call.logCancelled": "Aramadan vazgeçildi",

  /* ── Sesli sohbet (FAZ 3) ── */
  "call.fullShort": "Dolu",
  "call.qualityFair": "Bağlantı orta",
  "call.qualityWeak": "Bağlantı zayıf",
  "call.reconnecting": "Yeniden bağlanıyor…",

  /* ── Oylama + Okuyanlar (1. paket — FAZ 1'de yanlislikla dusmustu) ── */
  "chat.poll": "Oylama",
  "chat.pollCreate": "Oylama Oluştur",
  "chat.pollQuestion": "Soru",
  "chat.pollQuestionPlaceholder": "Örn: Bu akşam ne yiyelim?",
  "chat.pollOptions": "Seçenekler",
  "chat.pollOptionPlaceholder": "{{index}}. seçenek",
  "chat.pollAddOption": "Seçenek ekle",
  "chat.pollMultiSetting": "Birden fazla seçenek işaretlenebilsin",
  "chat.pollAnonymousSetting": "Oy verenler gizli kalsın",
  "chat.pollSend": "Oylamayı Başlat",
  "chat.pollMulti": "Çoklu seçim",
  "chat.pollAnonymous": "Anonim",
  "chat.pollClosed": "Sona erdi",
  "chat.pollNoVotes": "Henüz oy verilmedi",
  "chat.pollVoterCount": "{{count}} kişi oy verdi",
  "chat.pollEnd": "Oylamayı bitir",
  "chat.pollChangeHint": "Değiştirmek için tekrar dokun",
  "chat.readByTitle": "Okuyanlar",
  "chat.readByUnknown": "Üye",


  /* ── Güvenli aile daveti ── */
  "familyInvite.title": "Güvenli Aile Daveti",
  "familyInvite.subtitle": "Tek kullanımlık ve 1 saat geçerli davet oluşturun.",
  "familyInvite.secure": "Güvenli",
  "familyInvite.codeLabel": "Davet kodu",
  "familyInvite.maskHint": "Kod yalnızca oluşturulduğu anda gösterilir.",
  "familyInvite.activeWithTime": "Aktif davet var · {{time}}",
  "familyInvite.singleUseAndTime": "Tek kullanımlık · {{time}}",
  "familyInvite.minutesLeft": "{{minutes}} dakika kaldı",
  "familyInvite.secondsLeft": "{{seconds}} saniye kaldı",
  "familyInvite.minutesSecondsLeft": "{{minutes}} dk {{seconds}} sn kaldı",
  "familyInvite.generate": "Davet Kodu Oluştur",
  "familyInvite.generateNew": "Yeni Kod Oluştur",
  "familyInvite.generating": "Kod oluşturuluyor…",
  "familyInvite.newCode": "Yeni davet kodu",
  "familyInvite.replaceConfirm": "Yeni kod oluşturursanız mevcut aktif davet hemen geçersiz olur. Devam edilsin mi?",
  "familyInvite.revoke": "Daveti İptal Et",
  "familyInvite.revokeConfirm": "Aktif davet kodu iptal edilsin mi? Bu kod artık kullanılamayacak.",
  "familyInvite.copy": "Kopyala",
  "familyInvite.copied": "Kopyalandı",
  "familyInvite.share": "Paylaş",
  "familyInvite.shareTitle": "{{familyName}} Aile Daveti",
  "familyInvite.shareText": "👨‍👩‍👧 Seni aileme davet ediyorum.\n\nFamily Planner uygulamasında {{familyName}} ailesine katılmak için aşağıdaki tek kullanımlık davet kodunu kullan:\n\n{{code}}\n\nBu kod yalnızca 1 kişi tarafından kullanılabilir ve 1 saat geçerlidir.\n\n{{appUrl}}",
  "familyInvite.shareCopied": "Davet bilgileri panoya kopyalandı.",
  "familyInvite.notRecoverable": "Güvenlik nedeniyle aktif kod tekrar gösterilemez. Yeni kod oluşturursanız mevcut kod iptal edilir.",
  "familyInvite.educationTitle": "Güvenli Davet",
  "familyInvite.educationText": "Bu kod yalnızca bir kişi tarafından kullanılabilir ve 1 saat sonunda otomatik olarak geçersiz olur. Yeni davet oluşturmak mevcut daveti iptal eder.",
  "familyInvite.joinTitle": "Davet Kodunuz Var mı?",
  "familyInvite.joinDescription": "Aile yöneticinizin oluşturduğu tek kullanımlık davet kodunu girin.",
  "familyInvite.joinHelper": "Kod FP- ile başlar, yalnızca bir kez kullanılabilir ve 1 saat geçerlidir.",
  "familyInvite.errors.invalid": "Davet kodu geçersiz. Kodu kontrol edip tekrar deneyin.",
  "familyInvite.errors.generic": "Davet işlemi tamamlanamadı. Lütfen tekrar deneyin.",
  "familySwitcher.secureInvite": "Güvenli Davet Oluştur",
  "familySwitcher.secureInviteSub": "Tek kullanımlık · 1 saat geçerli",
  "familySwitcher.adminOnlyInvite": "Davetleri yalnızca aile yöneticileri oluşturabilir",
  "familySwitcher.secureInviteIntro": "Yeni bir aile üyesi için güvenli davet oluşturun. Aktif bir davet varsa yeni kod oluşturulduğunda otomatik iptal edilir.",

  /* ── Apple Sağlık / HealthKit (yalnızca iOS) ── */
  "health.apple.title": "Apple Sağlık Özeti",
  "health.apple.privateOnDevice": "Özel · Yalnızca bu cihazda",
  "health.apple.sourceToday": "Apple Sağlık · Bugün",
  "health.apple.todaySummary": "Bugünün Apple Sağlık özeti",
  "health.apple.steps": "Adım",
  "health.apple.energy": "Enerji",
  "health.apple.distance": "Mesafe",
  "health.apple.exercise": "Egzersiz",
  "health.apple.sleep": "Uyku",
  "health.apple.restingHeartRate": "Dinlenme kalp hızı",
  "health.apple.latestHeartRate": "Son kalp hızı",
  "health.apple.heartData": "Kalp hızı",
  "health.apple.minuteUnit": "dk",
  "health.apple.hourUnit": "sa",
  "health.apple.bpmUnit": "BPM",
  "health.apple.connect": "Bağlan",
  "health.apple.live": "Canlı",
  "health.apple.openSummary": "Apple Sağlık özetini aç",
  "health.apple.permissionEyebrow": "Gizliliğiniz kontrolünüzde",
  "health.apple.permissionTitle": "Günlük sağlığınızı tek yerde görün",
  "health.apple.permissionDesc": "Adım, aktif enerji, yürüme mesafesi, egzersiz, uyku ve kalp hızı özetlerinizi göstermek için seçtiğiniz Apple Sağlık verilerine salt okunur erişim istenir.",
  "health.apple.permissionPrivacy": "Verileriniz sunucuya gönderilmez, aile üyeleriyle paylaşılmaz ve Apple Sağlık'a veri yazılmaz.",
  "health.apple.continue": "Apple Sağlık'a Bağlan",
  "health.apple.connecting": "Bağlanıyor…",
  "health.apple.notNow": "Şimdi Değil",
  "health.apple.today": "BUGÜN",
  "health.apple.dailyMovement": "Günlük hareketiniz",
  "health.apple.refresh": "Apple Sağlık verilerini yenile",
  "health.apple.noDataTitle": "Henüz görüntülenecek veri yok",
  "health.apple.noDataDesc": "Veri bulunamadı veya bu verilere erişim kapalı. İzinlerinizi Ayarlar'dan yönetebilirsiniz.",
  "health.apple.loadFailed": "Apple Sağlık verileri şu anda yenilenemedi. Lütfen tekrar deneyin.",
  "health.apple.weeklyTrends": "7 günlük eğilimler",
  "health.apple.weeklyTrendsDesc": "Hareket alışkanlıklarınızdaki değişimi izleyin",
  "health.apple.last7Days": "Son 7 gün",
  "health.apple.onDeviceTitle": "Cihazınızda ve size özel",
  "health.apple.onDeviceDesc": "Apple Sağlık verileri yalnızca bu ekranda işlenir; sunucuya veya aile üyelerine aktarılmaz.",
  "health.apple.permissionsTitle": "İzinler her zaman sizde",
  "health.apple.permissionsDesc": "Hangi veri türlerinin paylaşılacağını iPhone Ayarları'ndan dilediğiniz zaman değiştirebilirsiniz.",
  "health.apple.openSettings": "Sağlık İzinlerini Yönet",
  "health.apple.updated": "Son güncelleme:",
  "health.apple.updatedUnknown": "Henüz güncellenmedi",
  "health.apple.disclaimer": "Bu bilgiler genel farkındalık içindir; tıbbi teşhis veya tedavi önerisi değildir.",
  "health.apple.unavailableTitle": "Apple Sağlık bu cihazda kullanılamıyor",
  "health.apple.unavailableDesc": "Bu özellik HealthKit desteği bulunan bir iPhone üzerinde kullanılabilir.",

  /* ── Sesli sohbet (FAZ 4 düzeltmeleri) ── */
  "call.speaker": "Hoparlör",
  "call.earpiece": "Ahize",
  "call.open": "Aç",
  "finance.recurring.toggle": "Düzenli gelir / gider",
  "finance.recurring.hint": "Kayıt, seçtiğiniz dönemde otomatik oluşur.",
  "finance.recurring.frequency": "Tekrar aralığı",
  "finance.recurring.monthly": "Her ay",
  "finance.recurring.quarterly": "3 ayda bir",
  "finance.recurring.semiannual": "6 ayda bir",
  "finance.recurring.yearly": "Her yıl",
  "finance.recurring.endDate": "Bitiş tarihi (isteğe bağlı)",
  "finance.recurring.deleteConfirm": "Bu finans kaydını silmek istiyor musunuz?",
  "finance.recurring.deleteFutureQuestion": "Bu düzenli kaydın sonraki oluşumlarını da durdurmak ister misiniz?",
  "finance.recurring.thisAndFuture": "Bu ve sonrakiler",
  "finance.recurring.onlyThis": "Yalnızca bu kayıt",
  "finance.currency.rateUnavailable": "Güncel kur bekleniyor",
  "mgmt.finance.customRule": "Yeni ödeme hatırlatması",
  "mgmt.finance.deliverySpread": "Gönderim dağıtma süresi (dk)",
  "mgmt.finance.recordType": "Finans kayıt türü",
  "mgmt.finance.inactivityDays": "Hareketsizlik eşiği (gün)",
  "mgmt.finance.repeatEveryDays": "Tekrar aralığı (gün)",
  "mgmt.finance.maxRepeat": "Maksimum tekrar",
  "mgmt.finance.addReminderDay": "Ödeme günü kuralı ekle",
};

export default tr;
